export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: string };
  UUID: { input: any; output: string };
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: string };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: number };
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: any; output: string };
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: number };
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: number };
};

export type Adresse = {
  __typename?: "Adresse";
  adresselinie1: Scalars["String"]["output"];
  adresselinie2?: Maybe<Scalars["String"]["output"]>;
  postnummer: Scalars["String"]["output"];
  bynavn: Scalars["String"]["output"];
  adresselinie4?: Maybe<Scalars["String"]["output"]>;
  landekode: Scalars["String"]["output"];
  toLines: Array<Scalars["String"]["output"]>;
  darAdresseId?: Maybe<Scalars["UUID"]["output"]>;
  coNavn?: Maybe<Scalars["String"]["output"]>;
  landNavigation?: Maybe<Land>;
};

export type DatoInterval = {
  __typename?: "DatoInterval";
  fraDato: Scalars["Date"]["output"];
  tilDato: Scalars["Date"]["output"];
  tilDatoInklusiv: Scalars["Date"]["output"];
  overlapper: Scalars["Boolean"]["output"];
  fortsaettesAf: Scalars["Boolean"]["output"];
  fortsaetter: Scalars["Boolean"]["output"];
  inkluderer: Scalars["Boolean"]["output"];
  harUendeligFraDato: Scalars["Boolean"]["output"];
  harUendeligTilDato: Scalars["Boolean"]["output"];
  medTilDato: DatoInterval;
  medFraDato: DatoInterval;
};

export type DatoIntervalOverlapperArgs = {
  other: DatoIntervalInput;
};

export type DatoIntervalFortsaettesAfArgs = {
  other: DatoIntervalInput;
};

export type DatoIntervalFortsaetterArgs = {
  other: DatoIntervalInput;
};

export type DatoIntervalInkludererArgs = {
  tidspunkt: Scalars["DateTime"]["input"];
};

export type DatoIntervalMedTilDatoArgs = {
  tilDato: Scalars["Date"]["input"];
};

export type DatoIntervalMedFraDatoArgs = {
  fraDato: Scalars["Date"]["input"];
};

export type Person = {
  __typename?: "Person";
  fornavne?: Maybe<Scalars["String"]["output"]>;
  efternavn?: Maybe<Scalars["String"]["output"]>;
  emailPrivat?: Maybe<Scalars["String"]["output"]>;
  prioriterEmailPrivat: Scalars["Boolean"]["output"];
  personDoedDato?: Maybe<Scalars["Date"]["output"]>;
  changeBeskikkelse: PersonBeskikkelse;
  harAabneDisciplinaerSagerPaa: Scalars["Boolean"]["output"];
  efteruddannelsesMaanederPerPeriode: Array<KeyValuePairOfGuidAndIListOfDateOnly>;
  efteruddannelsesMaaneder: Array<Scalars["Date"]["output"]>;
  beregnetTilDatoForPersonEfteruddannelse: Scalars["Date"]["output"];
  addPersonEfteruddannelse: PersonEfteruddannelse;
  updatePersonEfteruddannelsePeriode: PersonEfteruddannelse;
  deleteSenestePersonEfteruddannelseIndberetning: Array<PersonEfteruddannelseIndberetning>;
  deletePersonEfteruddannelseIndberetning: Array<PersonEfteruddannelseIndberetning>;
  deletePersonEfteruddannelse: PersonEfteruddannelse;
  personart: PersonartId;
  personartPaa: PersonartId;
  doedFoer: Scalars["Boolean"]["output"];
  udoevendePaa: Scalars["Boolean"]["output"];
  udoevendeAdvokatPaa: Scalars["Boolean"]["output"];
  udoevendeFuldmaegtigPaa: Scalars["Boolean"]["output"];
  kanVaerePrincipalPaa: Scalars["Boolean"]["output"];
  primaerPersonFirmaRelationPaa?: Maybe<PersonFirma>;
  prioriteredePersonFirmaRelationerPaa: Array<PersonFirma>;
  foersteBeskikkelse?: Maybe<PersonBeskikkelse>;
  senesteGenudlevering?: Maybe<PersonBeskikkelse>;
  senesteDeponering?: Maybe<PersonBeskikkelse>;
  moederetHoejesteret: Scalars["Boolean"]["output"];
  moederetLandsret: Scalars["Boolean"]["output"];
  primaerPrincipalPaa?: Maybe<Person>;
  prioriteretEmail?: Maybe<Scalars["String"]["output"]>;
  udoevendeAdvokatPerioder: Array<DatoInterval>;
  udoevendePerioder: Array<DatoInterval>;
  kundeNr: Scalars["Long"]["output"];
  foedselsDato?: Maybe<Scalars["Date"]["output"]>;
  koen?: Maybe<Scalars["String"]["output"]>;
  tlfMobilNr?: Maybe<Scalars["String"]["output"]>;
  auktionsleder?: Maybe<Scalars["Boolean"]["output"]>;
  advokatnoeglen?: Maybe<Scalars["Boolean"]["output"]>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  titelId?: Maybe<Scalars["UUID"]["output"]>;
  titel1Id?: Maybe<Scalars["UUID"]["output"]>;
  titel?: Maybe<Titel>;
  titel1?: Maybe<Titel>;
  fmulinjeKursist: Array<FmulinjeKursist>;
  fmuretssagsproeveEksaminand: Array<Fmuretssagsproeve>;
  fmuretssagsproeveCensor: Array<Fmuretssagsproeve>;
  personForening: Array<PersonForening>;
  kursusholdUnderviser: Array<KursusholdUnderviser>;
  personAbonnement: Array<PersonAbonnement>;
  personPersonart: Array<PersonPersonart>;
  personBeskikkelse: Array<PersonBeskikkelse>;
  personBetalingsadresse: Array<PersonBetalingsadresse>;
  personBidragsopkraevning: Array<PersonBidragsopkraevning>;
  personDisciplinaerstatus: Array<PersonDisciplinaerstatus>;
  personEfteruddannelse: Array<PersonEfteruddannelse>;
  personFirma: Array<PersonFirma>;
  personForsikring: Array<PersonForsikring>;
  personhistorikNavigation: Array<Personhistorik>;
  personhistorik2Navigation: Array<Personhistorik2>;
  personInteresse: Array<PersonInteresse>;
  personKlienterklaering: Array<PersonKlienterklaering>;
  personKorrespondance: Array<PersonKorrespondance>;
  kursusPerson: Array<KursusPerson>;
  personPrincipalPersonFuldm: Array<PersonPrincipal>;
  personPrincipalPersonPrincipalNavigation: Array<PersonPrincipal>;
  personSanktion: Array<PersonSanktion>;
  personTilsyn: Array<PersonTilsyn>;
  personTilsynserklaering: Array<PersonTilsynserklaering>;
  personUdenlandskadvokatsamfund: Array<PersonUdenlandskadvokatsamfund>;
  personPersontype: Array<PersonPersontype>;
  personUdvalg: Array<PersonUdvalg>;
  personKontaktadresse: Array<PersonKontaktadresse>;
  fuldtNavn?: Maybe<Scalars["String"]["output"]>;
  erDoed: Scalars["Boolean"]["output"];
  erUdoevende: Scalars["Boolean"]["output"];
  adresse?: Maybe<PersonBeregnetAdresse>;
  debitorInfo?: Maybe<PersonDebitorInfo>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonChangeBeskikkelseArgs = {
  beskikkelsesType: BeskikkelsestypeId;
  fraDato: Scalars["Date"]["input"];
  aarsag?: InputMaybe<Scalars["String"]["input"]>;
};

export type PersonHarAabneDisciplinaerSagerPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonBeregnetTilDatoForPersonEfteruddannelseArgs = {
  personEfteruddannelseId: Scalars["UUID"]["input"];
  maanedsKrav?: Scalars["Int"]["input"];
};

export type PersonAddPersonEfteruddannelseArgs = {
  periode: DatoIntervalInput;
};

export type PersonUpdatePersonEfteruddannelsePeriodeArgs = {
  personEfteruddannelseId: Scalars["UUID"]["input"];
  nyperiode: DatoIntervalInput;
};

export type PersonDeletePersonEfteruddannelseIndberetningArgs = {
  personEfteruddannelseId: Scalars["UUID"]["input"];
};

export type PersonDeletePersonEfteruddannelseArgs = {
  personEfteruddannelseId: Scalars["UUID"]["input"];
};

export type PersonPersonartPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonDoedFoerArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonUdoevendePaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonUdoevendeAdvokatPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonUdoevendeFuldmaegtigPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonKanVaerePrincipalPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonPrimaerPersonFirmaRelationPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonPrioriteredePersonFirmaRelationerPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonPrimaerPrincipalPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type PersonFirma = {
  __typename?: "PersonFirma";
  priorieteretPrimaerFra?: Maybe<Scalars["Date"]["output"]>;
  personfirmatypeNr: PersonfirmatypeId;
  id: Scalars["UUID"]["output"];
  emailArbejde?: Maybe<Scalars["String"]["output"]>;
  periode: DatoInterval;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  adresseStandard: Scalars["Boolean"]["output"];
  adressePrioritet?: Maybe<Scalars["Int"]["output"]>;
  fakturaReference?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  firmaId: Scalars["UUID"]["output"];
  firma: Firma;
  person: Person;
  personfirmatypeNrNavigation?: Maybe<PersonfirmatypeKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
};

export type PersonPersonart = {
  __typename?: "PersonPersonart";
  personartNr: PersonartId;
  periode: DatoInterval;
  personId: Scalars["UUID"]["output"];
  person: Person;
  personartNrNavigation?: Maybe<PersonartKode>;
};

export type PersonBeskikkelse = {
  __typename?: "PersonBeskikkelse";
  beskikkelsestype: BeskikkelsestypeId;
  periode: DatoInterval;
  aarsag?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  beskikkelsestypeNavigation?: Maybe<BeskikkelsestypeKode>;
  person: Person;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonPrincipal = {
  __typename?: "PersonPrincipal";
  periode: DatoInterval;
  personFuldmId: Scalars["UUID"]["output"];
  personPrincipalId: Scalars["UUID"]["output"];
  personFuldm: Person;
  personPrincipalNavigation: Person;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonPersontype = {
  __typename?: "PersonPersontype";
  persontypeNr: Scalars["Int"]["output"];
  periode: DatoInterval;
  personId: Scalars["UUID"]["output"];
  person: Person;
  persontypeNrNavigation?: Maybe<Persontype>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonSanktion = {
  __typename?: "PersonSanktion";
  sagsNr?: Maybe<Scalars["String"]["output"]>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  sagsLink?: Maybe<Scalars["String"]["output"]>;
  afgoerelseskoder?: Maybe<Scalars["String"]["output"]>;
  indbragtretten: Scalars["Boolean"]["output"];
  naevnskendelseSanktionstypeNr: Scalars["Int"]["output"];
  naevnskendelseDato: Scalars["Date"]["output"];
  naevnskendelseBoedebeloeb?: Maybe<Scalars["Int"]["output"]>;
  retskendelseSanktionstypeNr?: Maybe<Scalars["Int"]["output"]>;
  retskendelseDato?: Maybe<Scalars["Date"]["output"]>;
  retskendelseBoedebeloeb?: Maybe<Scalars["Int"]["output"]>;
  personId: Scalars["UUID"]["output"];
  person: Person;
  naevnskendelseSanktionstypeNrNavigation?: Maybe<Sanktionstype>;
  retskendelseSanktionstypeNrNavigation?: Maybe<Sanktionstype>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export enum PersonIdKortStatus {
  Bestilt = "BESTILT",
  Behandlet = "BEHANDLET",
}

export type PersonIdKort = {
  __typename?: "PersonIdKort";
  personId: Scalars["UUID"]["output"];
  status: PersonIdKortStatus;
  ekspederingstidspunkt?: Maybe<Scalars["DateTime"]["output"]>;
  ekspederetAf?: Maybe<Scalars["String"]["output"]>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonTilsyn = {
  __typename?: "PersonTilsyn";
  personTilsynstype: PersonTilsynstypeId;
  gennemfoerselDato?: Maybe<Scalars["Date"]["output"]>;
  sagsNr?: Maybe<Scalars["String"]["output"]>;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  person?: Maybe<Person>;
  personTilsynstypeNavigation?: Maybe<PersonTilsynstypeKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonEfteruddannelse = {
  __typename?: "PersonEfteruddannelse";
  periode: DatoInterval;
  lektionerGennemfoert: Scalars["Float"]["output"];
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  fraDatoLaast: Scalars["Boolean"]["output"];
  tilDatoLaast: Scalars["Boolean"]["output"];
  person: Person;
  personEfteruddannelseIndberetning: Array<PersonEfteruddannelseIndberetning>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonEfteruddannelseIndberetning = {
  __typename?: "PersonEfteruddannelseIndberetning";
  efteruddannelseIndberetningstype: EfteruddannelseIndberetningstypeId;
  indberetningFrist?: Maybe<Scalars["Date"]["output"]>;
  indberettedeLektionerAsDictionary: Array<KeyValuePairOfInt32AndSingle>;
  sumIndberettedeLektioner: Scalars["Float"]["output"];
  personEfteruddannelseId: Scalars["UUID"]["output"];
  personEfteruddannelseIndberetningLinje: Array<PersonEfteruddannelseIndberetningLinje>;
  personEfteruddannelseNavigation?: Maybe<PersonEfteruddannelse>;
  registreringsDato?: Maybe<Scalars["Date"]["output"]>;
  efteruddannelseIndberetningstypeNavigation?: Maybe<EfteruddannelseIndberetningstypeKode>;
  efteruddannelseIndberetningStatus?: Maybe<EfteruddannelseIndberetningStatusId>;
  efteruddannelseIndberetningStatusNavigation?: Maybe<EfteruddannelseIndberetningStatusKode>;
  signatur?: Maybe<Array<Scalars["Byte"]["output"]>>;
  signaturNavn?: Maybe<Scalars["String"]["output"]>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonEfteruddannelseIndberetningLinje = {
  __typename?: "PersonEfteruddannelseIndberetningLinje";
  indberettedeLektioner: Scalars["Float"]["output"];
  personEfteruddannelseIndberetningId: Scalars["UUID"]["output"];
  efteruddannelsestypenr: Scalars["Int"]["output"];
  efteruddannelsestypenrNavigation?: Maybe<Efteruddannelsestype>;
  personEfteruddannelseIndberetningNavigation?: Maybe<PersonEfteruddannelseIndberetning>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonPaabud = {
  __typename?: "PersonPaabud";
  periode: DatoInterval;
  paakraevedeLektioner: Scalars["Float"]["output"];
  lektionerGennemfoert: Scalars["Float"]["output"];
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  personEfteruddannelseId: Scalars["UUID"]["output"];
  status: PersonPaabudStatusId;
  personPaabudIndberetning: Array<PersonPaabudIndberetning>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonPaabudIndberetning = {
  __typename?: "PersonPaabudIndberetning";
  personPaabudId: Scalars["UUID"]["output"];
  registreringsDato?: Maybe<Scalars["Date"]["output"]>;
  efteruddannelseIndberetningStatus?: Maybe<EfteruddannelseIndberetningStatusId>;
  efteruddannelseIndberetningStatusNavigation?: Maybe<EfteruddannelseIndberetningStatusKode>;
  indberetningFrist?: Maybe<Scalars["Date"]["output"]>;
  personPaabudNavigation?: Maybe<PersonPaabud>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonForsikring = {
  __typename?: "PersonForsikring";
  policeNr?: Maybe<Scalars["String"]["output"]>;
  restance: Scalars["Boolean"]["output"];
  periode: DatoInterval;
  garantiordning: Scalars["Boolean"]["output"];
  garantiPoliceNr?: Maybe<Scalars["String"]["output"]>;
  notat?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  forsikringsselskabId: Scalars["UUID"]["output"];
  person: Person;
  forsikringsselskab?: Maybe<Forsikringsselskab>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonTilsynserklaering = {
  __typename?: "PersonTilsynserklaering";
  erklAar: Scalars["Int"]["output"];
  erklModtaget?: Maybe<Scalars["Date"]["output"]>;
  tilsynserklaeringStatus: TilsynserklaeringStatusId;
  erklDocument?: Maybe<Array<Scalars["Byte"]["output"]>>;
  koerselDato?: Maybe<Scalars["Date"]["output"]>;
  frist?: Maybe<Scalars["Date"]["output"]>;
  indberetningsData?: Maybe<Scalars["String"]["output"]>;
  forsikringDaekning?: Maybe<Scalars["String"]["output"]>;
  forsikringPolice?: Maybe<Scalars["String"]["output"]>;
  forsikringSelskab?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  tilsynserklaeringStatusNavigation?: Maybe<TilsynserklaeringStatusKode>;
  person: Person;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonKlienterklaering = {
  __typename?: "PersonKlienterklaering";
  personId: Scalars["UUID"]["output"];
  person?: Maybe<Person>;
  erklAar: Scalars["Int"]["output"];
  erklNr?: Maybe<Scalars["Int"]["output"]>;
  klienterklaeringstype: KlienterklaeringstypeId;
  erklModtaget?: Maybe<Scalars["Date"]["output"]>;
  periode: DatoInterval;
  frist: Scalars["Date"]["output"];
  koerselDato?: Maybe<Scalars["Date"]["output"]>;
  klienterklaeringStatus: KlienterklaeringStatusId;
  erklDocument?: Maybe<Array<Scalars["Byte"]["output"]>>;
  indberetningsData?: Maybe<Scalars["String"]["output"]>;
  erklNrWeb?: Maybe<Scalars["Int"]["output"]>;
  indberettetformular?: Maybe<KlienterklaeringIndberettetformular>;
  firmaCvrNr?: Maybe<Scalars["Long"]["output"]>;
  klienterklaeringStatusNavigation?: Maybe<KlienterklaeringStatusKode>;
  klienterklaeringstypeNavigation?: Maybe<KlienterklaeringstypeKode>;
  klienterklaeringIndberettetformularNavigation?: Maybe<KlienterklaeringIndberettetformularKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Firma = {
  __typename?: "Firma";
  advokatVirksomhed: Scalars["Boolean"]["output"];
  harUdoevendePaa: Scalars["Boolean"]["output"];
  udoevendePaa: Array<PersonFirma>;
  harPersonrelationPaa: Scalars["Boolean"]["output"];
  personRelationerPaa: Array<PersonFirma>;
  firmatypePaa: Firmatype;
  firmaNr: Scalars["Long"]["output"];
  cvrNr?: Maybe<Scalars["Long"]["output"]>;
  pnr?: Maybe<Scalars["Long"]["output"]>;
  pnrSubNr: Scalars["Int"]["output"];
  pnrOphoertCvr?: Maybe<Scalars["Date"]["output"]>;
  pnrStatusCvr?: Maybe<Scalars["String"]["output"]>;
  cvrNrStatusCvr?: Maybe<Scalars["String"]["output"]>;
  udenlandskVirksomhedsId?: Maybe<Scalars["String"]["output"]>;
  periode: DatoInterval;
  navn1: Scalars["String"]["output"];
  navn2?: Maybe<Scalars["String"]["output"]>;
  navn3?: Maybe<Scalars["String"]["output"]>;
  beliggenhedsadresse: Adresse;
  kommuneNr?: Maybe<Scalars["Int"]["output"]>;
  retskredsNr?: Maybe<Scalars["Int"]["output"]>;
  tlf?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  webAdresse?: Maybe<Scalars["String"]["output"]>;
  selskabstype?: Maybe<Scalars["Int"]["output"]>;
  emailSikker?: Maybe<Scalars["String"]["output"]>;
  virksomhedsform?: Maybe<VirksomhedsformId>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  fakturaAfsendelse: FakturaAfsendelseId;
  fakturaEmail?: Maybe<Scalars["String"]["output"]>;
  ean?: Maybe<Scalars["String"]["output"]>;
  fakturaReference?: Maybe<Scalars["String"]["output"]>;
  virksomhedsformNavigation?: Maybe<VirksomhedsformKode>;
  fakturaAfsendelseNavigation?: Maybe<FakturaAfsendelseKode>;
  retskredsNrNavigation?: Maybe<Retskreds>;
  selskabstypeNavigation?: Maybe<Selskabstype>;
  kommuneNavigation?: Maybe<Kommune>;
  firmaAbonnement: Array<FirmaAbonnement>;
  firmaBetalingsadresse: Array<FirmaBetalingsadresse>;
  firmaejerskabEjendeFirmaNavigation: Array<Firmaejerskab>;
  firmaejerskabEjetFirma: Array<Firmaejerskab>;
  firmahistorikNavigation: Array<Firmahistorik>;
  firmahistorik2Navigation: Array<Firmahistorik2>;
  firmaKlienterklaering: Array<FirmaKlienterklaering>;
  firmaKorrespondance: Array<FirmaKorrespondance>;
  firmaSanktion: Array<FirmaSanktion>;
  firmaTilsyn: Array<FirmaTilsyn>;
  personFirma: Array<PersonFirma>;
  harAktivitet: Scalars["Boolean"]["output"];
  harUdoevende: Scalars["Boolean"]["output"];
  harPersonrelation: Scalars["Boolean"]["output"];
  firmatype: Firmatype;
  debitorInfo: FirmaDebitorInfo;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type FirmaHarUdoevendePaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type FirmaUdoevendePaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type FirmaHarPersonrelationPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type FirmaPersonRelationerPaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type FirmaFirmatypePaaArgs = {
  dato: Scalars["Date"]["input"];
};

export type FirmaSanktion = {
  __typename?: "FirmaSanktion";
  sagsNr?: Maybe<Scalars["String"]["output"]>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  sagsLink?: Maybe<Scalars["String"]["output"]>;
  afgoerelseskoder?: Maybe<Scalars["String"]["output"]>;
  indbragtretten: Scalars["Boolean"]["output"];
  naevnskendelseSanktionstypeNr: Scalars["Int"]["output"];
  naevnskendelseDato: Scalars["Date"]["output"];
  naevnskendelseBoedebeloeb?: Maybe<Scalars["Int"]["output"]>;
  retskendelseSanktionstypeNr?: Maybe<Scalars["Int"]["output"]>;
  retskendelseDato?: Maybe<Scalars["Date"]["output"]>;
  retskendelseBoedebeloeb?: Maybe<Scalars["Int"]["output"]>;
  firmaId: Scalars["UUID"]["output"];
  firma: Firma;
  naevnskendelseSanktionstypeNrNavigation?: Maybe<Sanktionstype>;
  retskendelseSanktionstypeNrNavigation?: Maybe<Sanktionstype>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type FirmaTilsyn = {
  __typename?: "FirmaTilsyn";
  firmaTilsynstype: FirmaTilsynstypeId;
  gennemfoerselDato?: Maybe<Scalars["Date"]["output"]>;
  sagsNr?: Maybe<Scalars["String"]["output"]>;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  firmaId: Scalars["UUID"]["output"];
  firma?: Maybe<Firma>;
  firmaTilsynstypeNavigation?: Maybe<FirmaTilsynstypeKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type FirmaKlienterklaering = {
  __typename?: "FirmaKlienterklaering";
  firmaId: Scalars["UUID"]["output"];
  firma?: Maybe<Firma>;
  erklAar: Scalars["Int"]["output"];
  erklNr?: Maybe<Scalars["Int"]["output"]>;
  klienterklaeringstype: KlienterklaeringstypeId;
  erklModtaget?: Maybe<Scalars["Date"]["output"]>;
  periode: DatoInterval;
  frist: Scalars["Date"]["output"];
  koerselDato?: Maybe<Scalars["Date"]["output"]>;
  klienterklaeringStatus: KlienterklaeringStatusId;
  erklDocument?: Maybe<Array<Scalars["Byte"]["output"]>>;
  indberetningsData?: Maybe<Scalars["String"]["output"]>;
  erklNrWeb?: Maybe<Scalars["Int"]["output"]>;
  indberettetformular?: Maybe<KlienterklaeringIndberettetformular>;
  firmaCvrNr?: Maybe<Scalars["Long"]["output"]>;
  klienterklaeringStatusNavigation?: Maybe<KlienterklaeringStatusKode>;
  klienterklaeringstypeNavigation?: Maybe<KlienterklaeringstypeKode>;
  klienterklaeringIndberettetformularNavigation?: Maybe<KlienterklaeringIndberettetformularKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Kursushold = {
  __typename?: "Kursushold";
  antalTilmeldte: Scalars["Int"]["output"];
  antalTilmeldteFraLinje: Scalars["Int"]["output"];
  antalTilmeldteOvernatingFraDagenFoer: Scalars["Int"]["output"];
  antalTilmeldteOvernatingMellemKursusdage: Scalars["Int"]["output"];
  holdNr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
  kursustype: Scalars["Int"]["output"];
  varighed?: Maybe<Scalars["String"]["output"]>;
  hotelId?: Maybe<Scalars["UUID"]["output"]>;
  fraDato: Scalars["Date"]["output"];
  fraKlDag?: Maybe<Scalars["TimeSpan"]["output"]>;
  tilDato: Scalars["Date"]["output"];
  tilKlDag?: Maybe<Scalars["TimeSpan"]["output"]>;
  censordato?: Maybe<Scalars["Date"]["output"]>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  pris?: Maybe<Scalars["Decimal"]["output"]>;
  kodeKursusmappe?: Maybe<Scalars["String"]["output"]>;
  fmulinjeId?: Maybe<Scalars["UUID"]["output"]>;
  fmukursusKategoriNr?: Maybe<Scalars["Int"]["output"]>;
  hotelNavigation?: Maybe<Hotel>;
  kursustypeNavigation?: Maybe<Kursustype>;
  fmukursusKategoriNavigation?: Maybe<FmukursusKategori>;
  fmulinje?: Maybe<Fmulinje>;
  kursusholdUnderviser: Array<KursusholdUnderviser>;
  kursusPerson: Array<KursusPerson>;
  kursusKorrespondance: Array<KursusholdKorrespondance>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type KursusPerson = {
  __typename?: "KursusPerson";
  deltagerStatus?: Maybe<DeltagerStatusId>;
  fmuLinjeTilmeldt: Scalars["Boolean"]["output"];
  overnatning?: Maybe<OvernatningstypeId>;
  tilmeldtRaekkefoelge: Scalars["Int"]["output"];
  tilmeldDato: Scalars["Date"]["output"];
  betalMark?: Maybe<Scalars["Boolean"]["output"]>;
  bestaaetMark?: Maybe<BestaaetStatusId>;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  prisdeltagertotal?: Maybe<Scalars["Decimal"]["output"]>;
  fakturaNr?: Maybe<Scalars["Long"]["output"]>;
  fakturaStatus: FakturaStatusId;
  tilEksamen?: Maybe<Scalars["Boolean"]["output"]>;
  afKursist?: Maybe<Scalars["String"]["output"]>;
  hotelPris?: Maybe<Scalars["Decimal"]["output"]>;
  kursusPris?: Maybe<Scalars["Decimal"]["output"]>;
  tillaegsPris?: Maybe<Scalars["Decimal"]["output"]>;
  eksamensdato?: Maybe<Scalars["Date"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  ikkeGennemfoert: Scalars["Boolean"]["output"];
  holdId: Scalars["UUID"]["output"];
  personId: Scalars["UUID"]["output"];
  hold: Kursushold;
  person: Person;
  fakturaStatusNavigation?: Maybe<FakturaStatusKode>;
  overnatningstypeNavigation?: Maybe<OvernatningstypeKode>;
  deltagerStatusNavigation?: Maybe<DeltagerStatusKode>;
  bestaaetStatusNavigation?: Maybe<BestaaetStatusKode>;
  kursusPersonKursusGruppe: Array<KursusPersonKursusGruppe>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Query = {
  __typename?: "Query";
  person?: Maybe<PersonDto>;
  personer?: Maybe<PersonerConnection>;
  firma?: Maybe<FirmaDto>;
  firmaer?: Maybe<FirmaerConnection>;
  kursushold?: Maybe<KursusholdDto>;
  kursusholds?: Maybe<KursusholdsConnection>;
  fmulinje?: Maybe<FmulinjeDto>;
  fmulinjer?: Maybe<FmulinjerConnection>;
};

export type QueryPersonArgs = {
  id: Scalars["UUID"]["input"];
  where?: InputMaybe<PersonDtoFilterInput>;
};

export type QueryPersonerArgs = {
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  where?: InputMaybe<PersonDtoFilterInput>;
  order?: InputMaybe<Array<PersonDtoSortInput>>;
};

export type QueryFirmaArgs = {
  id: Scalars["UUID"]["input"];
  where?: InputMaybe<FirmaDtoFilterInput>;
};

export type QueryFirmaerArgs = {
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  where?: InputMaybe<FirmaDtoFilterInput>;
  order?: InputMaybe<Array<FirmaDtoSortInput>>;
};

export type QueryKursusholdArgs = {
  id: Scalars["UUID"]["input"];
  where?: InputMaybe<KursusholdDtoFilterInput>;
};

export type QueryKursusholdsArgs = {
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  where?: InputMaybe<KursusholdDtoFilterInput>;
  order?: InputMaybe<Array<KursusholdDtoSortInput>>;
};

export type QueryFmulinjeArgs = {
  id: Scalars["UUID"]["input"];
  where?: InputMaybe<FmulinjeDtoFilterInput>;
};

export type QueryFmulinjerArgs = {
  first?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  where?: InputMaybe<FmulinjeDtoFilterInput>;
  order?: InputMaybe<Array<FmulinjeDtoSortInput>>;
};

export enum ApplyPolicy {
  BeforeResolver = "BEFORE_RESOLVER",
  AfterResolver = "AFTER_RESOLVER",
  Validation = "VALIDATION",
}

export type Land = {
  __typename?: "Land";
  landekode: Scalars["String"]["output"];
  navn: Scalars["String"]["output"];
  falId?: Maybe<Scalars["String"]["output"]>;
  falReferenceDatatypeIndex?: Maybe<Scalars["Int"]["output"]>;
  fal?: Maybe<Falreferencedata>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type DatoIntervalInput = {
  fraDato: Scalars["Date"]["input"];
  tilDato: Scalars["Date"]["input"];
  tilDatoInklusiv: Scalars["Date"]["input"];
};

export enum BeskikkelsestypeId {
  Beskikket = "BESKIKKET",
  Deponeret = "DEPONERET",
  Frakendt = "FRAKENDT",
  RegistreretEuAdvokat = "REGISTRERET_EU_ADVOKAT",
  AfregistreretEuAdvokat = "AFREGISTRERET_EU_ADVOKAT",
  FrakendtEuAdvokat = "FRAKENDT_EU_ADVOKAT",
}

export type KeyValuePairOfGuidAndIListOfDateOnly = {
  __typename?: "KeyValuePairOfGuidAndIListOfDateOnly";
  key: Scalars["UUID"]["output"];
  value: Array<Scalars["Date"]["output"]>;
};

export enum PersonartId {
  Advokatfuldmaegtig = "ADVOKATFULDMAEGTIG",
  Oevrig = "OEVRIG",
  Advokat = "ADVOKAT",
}

export type Titel = {
  __typename?: "Titel";
  titelNr: Scalars["Int"]["output"];
  titel1?: Maybe<Scalars["String"]["output"]>;
  navn?: Maybe<Scalars["String"]["output"]>;
  falId?: Maybe<Scalars["String"]["output"]>;
  falReferenceDatatypeIndex?: Maybe<Scalars["Int"]["output"]>;
  falSkjult: Scalars["Boolean"]["output"];
  fal?: Maybe<Falreferencedata>;
  personTitel: Array<Person>;
  personTitel1: Array<Person>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type FmulinjeKursist = {
  __typename?: "FmulinjeKursist";
  deltagerStatus?: Maybe<DeltagerStatusId>;
  tilmeldDato?: Maybe<Scalars["Date"]["output"]>;
  overnatning?: Maybe<OvernatningstypeId>;
  email?: Maybe<Scalars["String"]["output"]>;
  fmulinjeId: Scalars["UUID"]["output"];
  personId: Scalars["UUID"]["output"];
  fmulinje?: Maybe<Fmulinje>;
  person: Person;
  overnatningstypeNavigation?: Maybe<OvernatningstypeKode>;
  deltagerStatusNavigation?: Maybe<DeltagerStatusKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Fmuretssagsproeve = {
  __typename?: "Fmuretssagsproeve";
  nr: Scalars["Int"]["output"];
  fiktiv: Scalars["Boolean"]["output"];
  status: FmuretssagsproeveResultatId;
  eksaminandPersonId: Scalars["UUID"]["output"];
  censorPersonId?: Maybe<Scalars["UUID"]["output"]>;
  proceduredato: Scalars["Date"]["output"];
  tidspunkt?: Maybe<Scalars["String"]["output"]>;
  retFirmaId?: Maybe<Scalars["UUID"]["output"]>;
  adresse?: Maybe<Scalars["String"]["output"]>;
  retssal?: Maybe<Scalars["String"]["output"]>;
  bsNummer?: Maybe<Scalars["String"]["output"]>;
  antalDommere?: Maybe<Scalars["Int"]["output"]>;
  dommernavn?: Maybe<Scalars["String"]["output"]>;
  pris?: Maybe<Scalars["Decimal"]["output"]>;
  fakturaStatus: FakturaStatusId;
  fakturaNr?: Maybe<Scalars["Long"]["output"]>;
  notat?: Maybe<Scalars["String"]["output"]>;
  eksaminandNavigation: Person;
  censorNavigation?: Maybe<Person>;
  retNavigation?: Maybe<Firma>;
  statusNavigation?: Maybe<FmuretssagsproeveResultatKode>;
  fakturaStatusNavigation?: Maybe<FakturaStatusKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonForening = {
  __typename?: "PersonForening";
  periode: DatoInterval;
  sidsteOpkraevning?: Maybe<Scalars["Int"]["output"]>;
  lbNr: Scalars["Int"]["output"];
  sidsteFakturaNr?: Maybe<Scalars["Long"]["output"]>;
  foreningId: Scalars["UUID"]["output"];
  personId: Scalars["UUID"]["output"];
  forening: Forening;
  person: Person;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type KursusholdUnderviser = {
  __typename?: "KursusholdUnderviser";
  personId: Scalars["UUID"]["output"];
  holdId: Scalars["UUID"]["output"];
  hold?: Maybe<Kursushold>;
  person: Person;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonAbonnement = {
  __typename?: "PersonAbonnement";
  abonnementNr: Scalars["Int"]["output"];
  periode: DatoInterval;
  faktureres: Scalars["Boolean"]["output"];
  antalEksemplar: Scalars["Int"]["output"];
  sidsteOpkraevning?: Maybe<Scalars["Int"]["output"]>;
  sidsteFakturaNr?: Maybe<Scalars["Long"]["output"]>;
  personId: Scalars["UUID"]["output"];
  person?: Maybe<Person>;
  abonnementNrNavigation?: Maybe<Abonnement>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonBetalingsadresse = {
  __typename?: "PersonBetalingsadresse";
  email?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  person: Person;
  adresse: Adresse;
  periode: DatoInterval;
  attention?: Maybe<Scalars["String"]["output"]>;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  reference?: Maybe<Scalars["String"]["output"]>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonBidragsopkraevning = {
  __typename?: "PersonBidragsopkraevning";
  personId: Scalars["UUID"]["output"];
  dato?: Maybe<Scalars["Date"]["output"]>;
  opkraevningsaar?: Maybe<Scalars["Int"]["output"]>;
  fakturaNr?: Maybe<Scalars["Long"]["output"]>;
  faktureretBeloeb?: Maybe<Scalars["Decimal"]["output"]>;
  fakturaStatus: FakturaStatusId;
  bidragsmodtager: BidragsmodtagerId;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  person: Person;
  fakturaStatusNavigation: FakturaStatusKode;
  bidragsmodtagerNavigation: BidragsmodtagerKode;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonDisciplinaerstatus = {
  __typename?: "PersonDisciplinaerstatus";
  personId: Scalars["UUID"]["output"];
  disciplinaerstatustypeNr: Scalars["Int"]["output"];
  periode: DatoInterval;
  esdhSagsNr?: Maybe<Scalars["String"]["output"]>;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  disciplinaerstatustypeNrNavigation?: Maybe<Disciplinaerstatustype>;
  person: Person;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Personhistorik = {
  __typename?: "Personhistorik";
  titel1?: Maybe<Scalars["String"]["output"]>;
  titel2?: Maybe<Scalars["String"]["output"]>;
  efternavn?: Maybe<Scalars["String"]["output"]>;
  fornavne?: Maybe<Scalars["String"]["output"]>;
  adr1?: Maybe<Scalars["String"]["output"]>;
  husNr?: Maybe<Scalars["Int"]["output"]>;
  husNrBogstav?: Maybe<Scalars["String"]["output"]>;
  etageNr?: Maybe<Scalars["String"]["output"]>;
  side?: Maybe<Scalars["String"]["output"]>;
  adr2?: Maybe<Scalars["String"]["output"]>;
  adr3?: Maybe<Scalars["String"]["output"]>;
  adr4?: Maybe<Scalars["String"]["output"]>;
  postNr?: Maybe<Scalars["String"]["output"]>;
  landeKode?: Maybe<Scalars["String"]["output"]>;
  tlfPrivat?: Maybe<Scalars["String"]["output"]>;
  tlfMobilNr?: Maybe<Scalars["String"]["output"]>;
  tlfFaxNr?: Maybe<Scalars["String"]["output"]>;
  emailPrivat?: Maybe<Scalars["String"]["output"]>;
  webAdresse?: Maybe<Scalars["String"]["output"]>;
  personart?: Maybe<Scalars["String"]["output"]>;
  aktiv?: Maybe<Scalars["Boolean"]["output"]>;
  foedselsDato?: Maybe<Scalars["Date"]["output"]>;
  mkmark?: Maybe<Scalars["String"]["output"]>;
  postboks?: Maybe<Scalars["Int"]["output"]>;
  regionNavn?: Maybe<Scalars["String"]["output"]>;
  kommuneNavn?: Maybe<Scalars["String"]["output"]>;
  kredsNavn?: Maybe<Scalars["String"]["output"]>;
  tlfArbejde?: Maybe<Scalars["String"]["output"]>;
  emailArbejde?: Maybe<Scalars["String"]["output"]>;
  afsendelsesformStd?: Maybe<Scalars["String"]["output"]>;
  frakendtBeskikkelse?: Maybe<Scalars["Boolean"]["output"]>;
  advokatnoeglen?: Maybe<Scalars["Boolean"]["output"]>;
  personDoed: Scalars["Boolean"]["output"];
  personDoedDato?: Maybe<Scalars["Date"]["output"]>;
  personFirmaNavn?: Maybe<Scalars["String"]["output"]>;
  advokatsamfundudlNavn?: Maybe<Scalars["String"]["output"]>;
  emailFirma?: Maybe<Scalars["String"]["output"]>;
  emailSikkerFirma?: Maybe<Scalars["String"]["output"]>;
  retskreds?: Maybe<Scalars["Int"]["output"]>;
  land?: Maybe<Scalars["String"]["output"]>;
  personId: Scalars["UUID"]["output"];
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Personhistorik2 = {
  __typename?: "Personhistorik2";
  erForskeligFra: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  snapshotTid: Scalars["DateTime"]["output"];
  personId: Scalars["UUID"]["output"];
  kundeNr: Scalars["Long"]["output"];
  titel1?: Maybe<Scalars["String"]["output"]>;
  titel2?: Maybe<Scalars["String"]["output"]>;
  fornavne?: Maybe<Scalars["String"]["output"]>;
  efternavn?: Maybe<Scalars["String"]["output"]>;
  personart?: Maybe<Scalars["String"]["output"]>;
  erUdoevende?: Maybe<Scalars["Boolean"]["output"]>;
  foedselsDato?: Maybe<Scalars["Date"]["output"]>;
  personDoedDato?: Maybe<Scalars["Date"]["output"]>;
  tlfMobilNr?: Maybe<Scalars["String"]["output"]>;
  emailPrivat?: Maybe<Scalars["String"]["output"]>;
  fakturaAfsendelse?: Maybe<Scalars["String"]["output"]>;
  primaerFirmaFirmaNr?: Maybe<Scalars["Long"]["output"]>;
  primaerFirmaNavn?: Maybe<Scalars["String"]["output"]>;
  primaerFirmaEmailSikker?: Maybe<Scalars["String"]["output"]>;
  primaerFirmaEmailArbejde?: Maybe<Scalars["String"]["output"]>;
  primaerFirmaAdvokatkreds?: Maybe<Scalars["String"]["output"]>;
  adresseCoNavn?: Maybe<Scalars["String"]["output"]>;
  adresseAdresselinie1?: Maybe<Scalars["String"]["output"]>;
  adresseAdresselinie2?: Maybe<Scalars["String"]["output"]>;
  adressePostnummer?: Maybe<Scalars["String"]["output"]>;
  adresseBynavn?: Maybe<Scalars["String"]["output"]>;
  adresseAdresselinie4?: Maybe<Scalars["String"]["output"]>;
  adresseLandekode?: Maybe<Scalars["String"]["output"]>;
};

export type Personhistorik2ErForskeligFraArgs = {
  o: Personhistorik2Input;
};

export type PersonInteresse = {
  __typename?: "PersonInteresse";
  personId: Scalars["UUID"]["output"];
  interesseId: Scalars["UUID"]["output"];
  interesse?: Maybe<Interesse>;
  person: Person;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonKorrespondance = {
  __typename?: "PersonKorrespondance";
  dokumentNr: Scalars["Int"]["output"];
  beskrivelse?: Maybe<Scalars["String"]["output"]>;
  navn?: Maybe<Scalars["String"]["output"]>;
  filnavn?: Maybe<Scalars["String"]["output"]>;
  dokument?: Maybe<Array<Scalars["Byte"]["output"]>>;
  originatorRid?: Maybe<Scalars["UUID"]["output"]>;
  originatorTableName?: Maybe<Scalars["String"]["output"]>;
  searchRid?: Maybe<Scalars["UUID"]["output"]>;
  personId: Scalars["UUID"]["output"];
  person?: Maybe<Person>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonUdenlandskadvokatsamfund = {
  __typename?: "PersonUdenlandskadvokatsamfund";
  personId: Scalars["UUID"]["output"];
  udenlandskadvokatsamfundId: Scalars["UUID"]["output"];
  periode: DatoInterval;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  person: Person;
  udenlandskadvokatsamfundNavigation: Udenlandskadvokatsamfund;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonUdvalg = {
  __typename?: "PersonUdvalg";
  tillidshvervNr: TillidshvervId;
  periode: DatoInterval;
  fratraadtAarsag?: Maybe<Scalars["String"]["output"]>;
  udvalgId: Scalars["UUID"]["output"];
  personId: Scalars["UUID"]["output"];
  person: Person;
  tillidshvervNrNavigation?: Maybe<TillidshvervKode>;
  udvalg: Udvalg;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonKontaktadresse = {
  __typename?: "PersonKontaktadresse";
  personId: Scalars["UUID"]["output"];
  person: Person;
  adresse: Adresse;
  periode: DatoInterval;
  attention?: Maybe<Scalars["String"]["output"]>;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  reference?: Maybe<Scalars["String"]["output"]>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonBeregnetAdresse = {
  __typename?: "PersonBeregnetAdresse";
  kildeId: Scalars["UUID"]["output"];
  kilde: Scalars["String"]["output"];
  personId: Scalars["UUID"]["output"];
  adresse: Adresse;
};

export type PersonDebitorInfo = {
  __typename?: "PersonDebitorInfo";
  kundeNr: Scalars["Long"]["output"];
  personId: Scalars["UUID"]["output"];
  firmaNr?: Maybe<Scalars["Long"]["output"]>;
  firmaId?: Maybe<Scalars["UUID"]["output"]>;
  adresse: Adresse;
  fakturaAfsendelse: FakturaAfsendelseId;
  email?: Maybe<Scalars["String"]["output"]>;
  ean?: Maybe<Scalars["String"]["output"]>;
  reference?: Maybe<Scalars["String"]["output"]>;
  personFirmaReference?: Maybe<Scalars["String"]["output"]>;
  attention?: Maybe<Scalars["String"]["output"]>;
  kilde: Scalars["String"]["output"];
  kildeId: Scalars["UUID"]["output"];
  firmaNavigation?: Maybe<Firma>;
};

export enum PersonfirmatypeId {
  Ansat = "ANSAT",
  Partner = "PARTNER",
  Ejer = "EJER",
}

export type PersonfirmatypeKode = {
  __typename?: "PersonfirmatypeKode";
  personFirma: Array<PersonFirma>;
  nr: PersonfirmatypeId;
  navn: Scalars["String"]["output"];
};

export type PersonartKode = {
  __typename?: "PersonartKode";
  personArter: Array<PersonPersonart>;
  nr: PersonartId;
  navn: Scalars["String"]["output"];
};

export type BeskikkelsestypeKode = {
  __typename?: "BeskikkelsestypeKode";
  personBeskikkelse: Array<PersonBeskikkelse>;
  nr: BeskikkelsestypeId;
  navn: Scalars["String"]["output"];
};

export type Persontype = {
  __typename?: "Persontype";
  personPersontype: Array<PersonPersontype>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Sanktionstype = {
  __typename?: "Sanktionstype";
  udvidetLevetid: Scalars["Boolean"]["output"];
  firmaSanktionKendelseNaevn: Array<FirmaSanktion>;
  firmaSanktionKendelseRetten: Array<FirmaSanktion>;
  personSanktionKendelseNaevn: Array<PersonSanktion>;
  personSanktionKendelseRetten: Array<PersonSanktion>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export enum PersonTilsynstypeId {
  TypeIkkeAngivet = "TYPE_IKKE_ANGIVET",
  Standard = "STANDARD",
  Risikobaseret = "RISIKOBASERET",
  Tema = "TEMA",
  Hvidvaskspecifikt = "HVIDVASKSPECIFIKT",
  Spontant = "SPONTANT",
  Genbesoeg = "GENBESOEG",
}

export enum PersonPaabudStatusId {
  Aabent = "AABENT",
  Lukket = "LUKKET",
  Slettet = "SLETTET",
}

export enum PersonPaalaegStatusId {
  Aabent = "AABENT",
  Lukket = "LUKKET",
  Slettet = "SLETTET",
}

export type PersonTilsynstypeKode = {
  __typename?: "PersonTilsynstypeKode";
  personTilsyn: Array<PersonTilsyn>;
  nr: PersonTilsynstypeId;
  navn: Scalars["String"]["output"];
};

export enum EfteruddannelseIndberetningstypeId {
  Saerlig = "SAERLIG",
  Deponering = "DEPONERING",
  Paabud = "PAABUD",
  Paalaeg = "PAALAEG",
  Periodeudloeb = "PERIODEUDLOEB",
  PaabudOverfoert = "PAABUD_OVERFOERT",
  PaalaegOverfoert = "PAALAEG_OVERFOERT",
}

export type KeyValuePairOfInt32AndSingle = {
  __typename?: "KeyValuePairOfInt32AndSingle";
  key: Scalars["Int"]["output"];
  value: Scalars["Float"]["output"];
};

export type EfteruddannelseIndberetningstypeKode = {
  __typename?: "EfteruddannelseIndberetningstypeKode";
  personEfteruddannelseIndberetning: Array<PersonEfteruddannelseIndberetning>;
  nr: EfteruddannelseIndberetningstypeId;
  navn: Scalars["String"]["output"];
};

export enum EfteruddannelseIndberetningStatusId {
  Ukendt = "UKENDT",
  FristOrdinaer = "FRIST_ORDINAER",
  ModtagetUdenFejl = "MODTAGET_UDEN_FEJL",
  ModtagetMedFejl = "MODTAGET_MED_FEJL",
  Undersoeges = "UNDERSOEGES",
  IndbragtForAdvokatnaevnet = "INDBRAGT_FOR_ADVOKATNAEVNET",
  Henlagt = "HENLAGT",
}

export type EfteruddannelseIndberetningStatusKode = {
  __typename?: "EfteruddannelseIndberetningStatusKode";
  personEfteruddannelseIndberetning: Array<PersonEfteruddannelseIndberetning>;
  nr: EfteruddannelseIndberetningStatusId;
  navn: Scalars["String"]["output"];
};

export type Efteruddannelsestype = {
  __typename?: "Efteruddannelsestype";
  periode: DatoInterval;
  maxLektioner?: Maybe<Scalars["Int"]["output"]>;
  overfoerPrioritet: Scalars["Int"]["output"];
  formaal: Scalars["Int"]["output"];
  overfoerTilMax: Scalars["Boolean"]["output"];
  personEfteruddannelseIndberetningLinje: Array<PersonEfteruddannelseIndberetningLinje>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Forsikringsselskab = {
  __typename?: "Forsikringsselskab";
  forsikringsselskabNr: Scalars["Int"]["output"];
  godkendt: Scalars["Boolean"]["output"];
  cvrNr?: Maybe<Scalars["Long"]["output"]>;
  periode: DatoInterval;
  navn1: Scalars["String"]["output"];
  navn2?: Maybe<Scalars["String"]["output"]>;
  adresse?: Maybe<Adresse>;
  tlfNr?: Maybe<Scalars["String"]["output"]>;
  faxNr?: Maybe<Scalars["String"]["output"]>;
  attPerson?: Maybe<Scalars["String"]["output"]>;
  notat?: Maybe<Scalars["String"]["output"]>;
  eMail?: Maybe<Scalars["String"]["output"]>;
  webAdresse?: Maybe<Scalars["String"]["output"]>;
  personForsikring: Array<PersonForsikring>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export enum TilsynserklaeringStatusId {
  FristOrdinaer = "FRIST_ORDINAER",
  ModtagetUdenFejl = "MODTAGET_UDEN_FEJL",
  ModtagetMedFejl = "MODTAGET_MED_FEJL",
  Undersoeges = "UNDERSOEGES",
  IndbragtForAdvokatnaevnet = "INDBRAGT_FOR_ADVOKATNAEVNET",
}

export type TilsynserklaeringStatusKode = {
  __typename?: "TilsynserklaeringStatusKode";
  personTilsynserklaering: Array<PersonTilsynserklaering>;
  nr: TilsynserklaeringStatusId;
  navn: Scalars["String"]["output"];
};

export enum KlienterklaeringstypeId {
  LoebendeErklaering = "LOEBENDE_ERKLAERING",
  SlutErklaering = "SLUT_ERKLAERING",
}

export enum KlienterklaeringStatusId {
  FristOrdinaer = "FRIST_ORDINAER",
  ModtagetUdenFejl = "MODTAGET_UDEN_FEJL",
  ModtagetMedFejl = "MODTAGET_MED_FEJL",
  Undersoeges = "UNDERSOEGES",
  Revisor = "REVISOR",
  IndbragtForAdvokatnaevnet = "INDBRAGT_FOR_ADVOKATNAEVNET",
}

export enum KlienterklaeringIndberettetformular {
  Formular1 = "FORMULAR1",
  Formular2 = "FORMULAR2",
}

export type KlienterklaeringStatusKode = {
  __typename?: "KlienterklaeringStatusKode";
  personKlienterklaering: Array<PersonKlienterklaering>;
  firmaKlienterklaering: Array<FirmaKlienterklaering>;
  nr: KlienterklaeringStatusId;
  navn: Scalars["String"]["output"];
};

export type KlienterklaeringstypeKode = {
  __typename?: "KlienterklaeringstypeKode";
  personKlienterklaering: Array<PersonKlienterklaering>;
  firmaKlienterklaering: Array<FirmaKlienterklaering>;
  nr: KlienterklaeringstypeId;
  navn: Scalars["String"]["output"];
};

export type KlienterklaeringIndberettetformularKode = {
  __typename?: "KlienterklaeringIndberettetformularKode";
  personKlienterklaering: Array<PersonKlienterklaering>;
  firmaKlienterklaering: Array<FirmaKlienterklaering>;
  nr: KlienterklaeringIndberettetformular;
  navn: Scalars["String"]["output"];
};

export enum Firmatype {
  AndenEnhed = "ANDEN_ENHED",
  Virksomhed = "VIRKSOMHED",
  Advokatvirksomhed = "ADVOKATVIRKSOMHED",
}

export enum VirksomhedsformId {
  Enkeltmandsvirksomhed = "ENKELTMANDSVIRKSOMHED",
  PersonligtEjetMindreVirksomhed = "PERSONLIGT_EJET_MINDRE_VIRKSOMHED",
  Doedsbo = "DOEDSBO",
  Interessentskab = "INTERESSENTSKAB",
  Kommanditselskab = "KOMMANDITSELSKAB",
  Medarbejderinvesteringsselskab = "MEDARBEJDERINVESTERINGSSELSKAB",
  Partrederi = "PARTREDERI",
  Aktieselskab = "AKTIESELSKAB",
  KommanditaktieselskabPartnerselskab = "KOMMANDITAKTIESELSKAB_PARTNERSELSKAB",
  Anpartsselskab = "ANPARTSSELSKAB",
  Ivaerksaetterselskab = "IVAERKSAETTERSELSKAB",
  FondeOgAndreSelvejendeInstitutioner = "FONDE_OG_ANDRE_SELVEJENDE_INSTITUTIONER",
  Trust = "TRUST",
  ErhvervsdrivendeFond = "ERHVERVSDRIVENDE_FOND",
  Forening = "FORENING",
  FrivilligForening = "FRIVILLIG_FORENING",
  AndelsselskabEllerForening = "ANDELSSELSKAB_ELLER_FORENING",
  AndelsselskabEllerForeningMedBegraensetAnsvar = "ANDELSSELSKAB_ELLER_FORENING_MED_BEGRAENSET_ANSVAR",
  ForeningEllerSelskabMedBegraensetAnsvar = "FORENING_ELLER_SELSKAB_MED_BEGRAENSET_ANSVAR",
  SelskabMedBegraensetAnsvar = "SELSKAB_MED_BEGRAENSET_ANSVAR",
  ForeningMedBegraensetAnsvar = "FORENING_MED_BEGRAENSET_ANSVAR",
  EuropaeiskOekonomiskFirmagruppe = "EUROPAEISK_OEKONOMISK_FIRMAGRUPPE",
  FilialAfUdenlandskAktieselskabKommanditaktieselskab = "FILIAL_AF_UDENLANDSK_AKTIESELSKAB_KOMMANDITAKTIESELSKAB",
  FilialAfUdenlandskAnpartsselskabEllerSelskab = "FILIAL_AF_UDENLANDSK_ANPARTSSELSKAB_ELLER_SELSKAB",
  FilialAfUdenlandskVirksomhedMedBegraensetAnsvar = "FILIAL_AF_UDENLANDSK_VIRKSOMHED_MED_BEGRAENSET_ANSVAR",
  SceSelskab = "SCE_SELSKAB",
  FilialAfUdenlandskSceSelskab = "FILIAL_AF_UDENLANDSK_SCE_SELSKAB",
  FilialAfAndenUdenlandskVirksomhedsform = "FILIAL_AF_ANDEN_UDENLANDSK_VIRKSOMHEDSFORM",
  AndenUdenlandskVirksomhed = "ANDEN_UDENLANDSK_VIRKSOMHED",
  FastForretningsstedAfEuropaeiskOekonomiskFirmagruppe = "FAST_FORRETNINGSSTED_AF_EUROPAEISK_OEKONOMISK_FIRMAGRUPPE",
  StatsligAdministrativEnhed = "STATSLIG_ADMINISTRATIV_ENHED",
  SelvstaendigOffentligVirksomhed = "SELVSTAENDIG_OFFENTLIG_VIRKSOMHED",
  Amtskommune = "AMTSKOMMUNE",
  Region = "REGION",
  Primaerkommune = "PRIMAERKOMMUNE",
  FolkekirkeligInstitution = "FOLKEKIRKELIG_INSTITUTION",
  EnhedUnderOprettelseIErhvervsstyrelsen = "ENHED_UNDER_OPRETTELSE_I_ERHVERVSSTYRELSEN",
  OevrigeVirksomhedsformer = "OEVRIGE_VIRKSOMHEDSFORMER",
  SaerligFinansielVirksomhed = "SAERLIG_FINANSIEL_VIRKSOMHED",
  SeSelskab = "SE_SELSKAB",
  FilialAfSeSelskab = "FILIAL_AF_SE_SELSKAB",
  GroenlandskAfdelingAfUdenlandskSelskabEllerVirksomhed = "GROENLANDSK_AFDELING_AF_UDENLANDSK_SELSKAB_ELLER_VIRKSOMHED",
  GroenlandskOffentligVirksomhed = "GROENLANDSK_OFFENTLIG_VIRKSOMHED",
  UoplystVirksomhedsform = "UOPLYST_VIRKSOMHEDSFORM",
}

export enum FakturaAfsendelseId {
  Eboks = "EBOKS",
  Email = "EMAIL",
  Brev = "BREV",
  Ean = "EAN",
}

export type VirksomhedsformKode = {
  __typename?: "VirksomhedsformKode";
  definition: Scalars["String"]["output"];
  nr: VirksomhedsformId;
  navn: Scalars["String"]["output"];
};

export type FakturaAfsendelseKode = {
  __typename?: "FakturaAfsendelseKode";
  firma: Array<Firma>;
  nr: FakturaAfsendelseId;
  navn: Scalars["String"]["output"];
};

export type Retskreds = {
  __typename?: "Retskreds";
  retskredsId: Scalars["Int"]["output"];
  advokatkredsNr: Scalars["Int"]["output"];
  advokatkredsNrNavigation?: Maybe<Advokatkreds>;
  firma: Array<Firma>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Selskabstype = {
  __typename?: "Selskabstype";
  firma: Array<Firma>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Kommune = {
  __typename?: "Kommune";
  regionNr?: Maybe<Scalars["Int"]["output"]>;
  regionNrNavigation?: Maybe<Region>;
  firma: Array<Firma>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type FirmaAbonnement = {
  __typename?: "FirmaAbonnement";
  abonnementNr: Scalars["Int"]["output"];
  periode: DatoInterval;
  faktureres: Scalars["Boolean"]["output"];
  antalEksemplar: Scalars["Int"]["output"];
  sidsteOpkraevningsaar?: Maybe<Scalars["Int"]["output"]>;
  erpFakturaRegnskabsId?: Maybe<Scalars["String"]["output"]>;
  firmaId: Scalars["UUID"]["output"];
  firma?: Maybe<Firma>;
  abonnementNrNavigation?: Maybe<Abonnement>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type FirmaBetalingsadresse = {
  __typename?: "FirmaBetalingsadresse";
  email: Scalars["String"]["output"];
  firmaId: Scalars["UUID"]["output"];
  firma: Firma;
  adresse: Adresse;
  periode: DatoInterval;
  attention?: Maybe<Scalars["String"]["output"]>;
  bemaerkning?: Maybe<Scalars["String"]["output"]>;
  reference?: Maybe<Scalars["String"]["output"]>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Firmaejerskab = {
  __typename?: "Firmaejerskab";
  periode: DatoInterval;
  ejetFirmaId: Scalars["UUID"]["output"];
  ejendeFirmaId: Scalars["UUID"]["output"];
  ejendeFirmaNavigation: Firma;
  ejetFirma: Firma;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Firmahistorik = {
  __typename?: "Firmahistorik";
  navn1?: Maybe<Scalars["String"]["output"]>;
  navn2?: Maybe<Scalars["String"]["output"]>;
  navn3?: Maybe<Scalars["String"]["output"]>;
  adr1?: Maybe<Scalars["String"]["output"]>;
  adr2?: Maybe<Scalars["String"]["output"]>;
  adr3?: Maybe<Scalars["String"]["output"]>;
  adr4?: Maybe<Scalars["String"]["output"]>;
  husNr?: Maybe<Scalars["Int"]["output"]>;
  husNrBogstav?: Maybe<Scalars["String"]["output"]>;
  etageNr?: Maybe<Scalars["String"]["output"]>;
  side?: Maybe<Scalars["String"]["output"]>;
  postNr?: Maybe<Scalars["String"]["output"]>;
  landeKode?: Maybe<Scalars["String"]["output"]>;
  tlf?: Maybe<Scalars["String"]["output"]>;
  tlfFaxNr?: Maybe<Scalars["String"]["output"]>;
  emailArbejde?: Maybe<Scalars["String"]["output"]>;
  webAdresse?: Maybe<Scalars["String"]["output"]>;
  firmatype?: Maybe<Scalars["String"]["output"]>;
  aktiv?: Maybe<Scalars["Boolean"]["output"]>;
  cvrNr?: Maybe<Scalars["Long"]["output"]>;
  pnr?: Maybe<Scalars["Long"]["output"]>;
  indskudskapital?: Maybe<Scalars["Float"]["output"]>;
  firmaStartDato?: Maybe<Scalars["DateTime"]["output"]>;
  adrCo?: Maybe<Scalars["String"]["output"]>;
  postboks?: Maybe<Scalars["Int"]["output"]>;
  regionNavn?: Maybe<Scalars["String"]["output"]>;
  kommuneNavn?: Maybe<Scalars["String"]["output"]>;
  kredsNavn?: Maybe<Scalars["String"]["output"]>;
  advokatnoeglen?: Maybe<Scalars["Boolean"]["output"]>;
  afsendelsesformStd?: Maybe<Scalars["String"]["output"]>;
  faktureringAs?: Maybe<Scalars["Boolean"]["output"]>;
  erOvertaget: Scalars["Boolean"]["output"];
  emailSikkerArbejde?: Maybe<Scalars["String"]["output"]>;
  erpKundegruppe?: Maybe<Scalars["String"]["output"]>;
  erpBetalingsbetingelseKode?: Maybe<Scalars["String"]["output"]>;
  erpMomskode?: Maybe<Scalars["String"]["output"]>;
  ejerskab?: Maybe<Scalars["Int"]["output"]>;
  retskreds?: Maybe<Scalars["Int"]["output"]>;
  land?: Maybe<Scalars["String"]["output"]>;
  firmaId: Scalars["UUID"]["output"];
  firma: Firma;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Firmahistorik2 = {
  __typename?: "Firmahistorik2";
  erForskeligFra: Scalars["Boolean"]["output"];
  id: Scalars["UUID"]["output"];
  snapshotTid: Scalars["DateTime"]["output"];
  firmaId: Scalars["UUID"]["output"];
  firmaNr: Scalars["Long"]["output"];
  navn1: Scalars["String"]["output"];
  navn2?: Maybe<Scalars["String"]["output"]>;
  advokatvirksomhed: Scalars["Boolean"]["output"];
  harAktivitet: Scalars["Boolean"]["output"];
  cvrNr?: Maybe<Scalars["Long"]["output"]>;
  pnr?: Maybe<Scalars["Long"]["output"]>;
  virksomhedsform?: Maybe<Scalars["String"]["output"]>;
  selskabstype?: Maybe<Scalars["String"]["output"]>;
  tlf?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  emailSikker?: Maybe<Scalars["String"]["output"]>;
  webAdresse?: Maybe<Scalars["String"]["output"]>;
  periodeFraDato: Scalars["Date"]["output"];
  periodeTilDato: Scalars["Date"]["output"];
  adresseCoNavn?: Maybe<Scalars["String"]["output"]>;
  adresseAdresselinie1?: Maybe<Scalars["String"]["output"]>;
  adresseAdresselinie2?: Maybe<Scalars["String"]["output"]>;
  adressePostnummer?: Maybe<Scalars["String"]["output"]>;
  adresseBynavn?: Maybe<Scalars["String"]["output"]>;
  adresseAdresselinie4?: Maybe<Scalars["String"]["output"]>;
  adresseLandekode?: Maybe<Scalars["String"]["output"]>;
  kommune?: Maybe<Scalars["String"]["output"]>;
  region?: Maybe<Scalars["String"]["output"]>;
  advokatkreds?: Maybe<Scalars["String"]["output"]>;
  retskreds?: Maybe<Scalars["String"]["output"]>;
};

export type Firmahistorik2ErForskeligFraArgs = {
  o: Firmahistorik2Input;
};

export type FirmaKorrespondance = {
  __typename?: "FirmaKorrespondance";
  dokumentNr: Scalars["Int"]["output"];
  beskrivelse?: Maybe<Scalars["String"]["output"]>;
  navn?: Maybe<Scalars["String"]["output"]>;
  filnavn?: Maybe<Scalars["String"]["output"]>;
  dokument?: Maybe<Array<Scalars["Byte"]["output"]>>;
  originatorRid?: Maybe<Scalars["UUID"]["output"]>;
  originatorTableName?: Maybe<Scalars["String"]["output"]>;
  searchRid?: Maybe<Scalars["UUID"]["output"]>;
  firmaId: Scalars["UUID"]["output"];
  firma?: Maybe<Firma>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type FirmaDebitorInfo = {
  __typename?: "FirmaDebitorInfo";
  firmaNr: Scalars["Long"]["output"];
  firmaId: Scalars["UUID"]["output"];
  adresse: Adresse;
  fakturaAfsendelse: FakturaAfsendelseId;
  email?: Maybe<Scalars["String"]["output"]>;
  ean?: Maybe<Scalars["String"]["output"]>;
  reference?: Maybe<Scalars["String"]["output"]>;
  attention?: Maybe<Scalars["String"]["output"]>;
  kilde: Scalars["String"]["output"];
  kildeId: Scalars["UUID"]["output"];
};

export enum FirmaTilsynstypeId {
  TypeIkkeAngivet = "TYPE_IKKE_ANGIVET",
  Standard = "STANDARD",
  Risikobaseret = "RISIKOBASERET",
  Tema = "TEMA",
  Hvidvaskspecifikt = "HVIDVASKSPECIFIKT",
  Spontant = "SPONTANT",
  Genbesoeg = "GENBESOEG",
}

export type FirmaTilsynstypeKode = {
  __typename?: "FirmaTilsynstypeKode";
  firmaTilsyn: Array<FirmaTilsyn>;
  nr: FirmaTilsynstypeId;
  navn: Scalars["String"]["output"];
};

export type Hotel = {
  __typename?: "Hotel";
  hotelNr: Scalars["Int"]["output"];
  navn1: Scalars["String"]["output"];
  navn2?: Maybe<Scalars["String"]["output"]>;
  sted?: Maybe<Scalars["String"]["output"]>;
  tlfNr?: Maybe<Scalars["String"]["output"]>;
  faxNr?: Maybe<Scalars["String"]["output"]>;
  attPerson?: Maybe<Scalars["String"]["output"]>;
  eMail?: Maybe<Scalars["String"]["output"]>;
  webAdresse?: Maybe<Scalars["String"]["output"]>;
  aflysUgeHotel: Scalars["Int"]["output"];
  aflysUgeV_relse: Scalars["Int"]["output"];
  fuldtNavn: Scalars["String"]["output"];
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Kursustype = {
  __typename?: "Kursustype";
  kursushold: Array<Kursushold>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type FmukursusKategori = {
  __typename?: "FmukursusKategori";
  kursushold: Array<Kursushold>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Fmulinje = {
  __typename?: "Fmulinje";
  antalTilmeldte?: Maybe<Scalars["Int"]["output"]>;
  nr: Scalars["Int"]["output"];
  navn?: Maybe<Scalars["String"]["output"]>;
  antalKurser?: Maybe<Scalars["Int"]["output"]>;
  prisPrDag?: Maybe<Scalars["Decimal"]["output"]>;
  prisPrNat?: Maybe<Scalars["Decimal"]["output"]>;
  hotelId: Scalars["UUID"]["output"];
  hotelNavigation: Hotel;
  fmulinjeKursist: Array<FmulinjeKursist>;
  kursushold: Array<Kursushold>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type KursusholdKorrespondance = {
  __typename?: "KursusholdKorrespondance";
  dokument?: Maybe<Array<Scalars["Byte"]["output"]>>;
  sendt?: Maybe<Scalars["DateTime"]["output"]>;
  emne?: Maybe<Scalars["String"]["output"]>;
  antalModtagere: Scalars["Int"]["output"];
  kursusholdId: Scalars["UUID"]["output"];
  kursushold?: Maybe<Kursushold>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export enum DeltagerStatusId {
  Tilmeldt = "TILMELDT",
  Afmeldt = "AFMELDT",
  Venteliste = "VENTELISTE",
}

export enum OvernatningstypeId {
  IngenOvernatning = "INGEN_OVERNATNING",
  MellemKursusdagene = "MELLEM_KURSUSDAGENE",
  DagenFoer = "DAGEN_FOER",
}

export enum BestaaetStatusId {
  Ja = "JA",
  Nej = "NEJ",
  Syg = "SYG",
}

export enum FakturaStatusId {
  IngenStatus = "INGEN_STATUS",
  Faktureret = "FAKTURERET",
  Kreditnota = "KREDITNOTA",
  Fakturerer = "FAKTURERER",
  Fejlet = "FEJLET",
}

export type FakturaStatusKode = {
  __typename?: "FakturaStatusKode";
  fmuretssagsproeve: Array<Fmuretssagsproeve>;
  kursusPerson: Array<KursusPerson>;
  nr: FakturaStatusId;
  navn: Scalars["String"]["output"];
};

export type OvernatningstypeKode = {
  __typename?: "OvernatningstypeKode";
  kursusPerson: Array<KursusPerson>;
  fmulinjeKursist: Array<FmulinjeKursist>;
  nr: OvernatningstypeId;
  navn: Scalars["String"]["output"];
};

export type DeltagerStatusKode = {
  __typename?: "DeltagerStatusKode";
  fmulinjeKursist: Array<FmulinjeKursist>;
  kursusPerson: Array<KursusPerson>;
  nr: DeltagerStatusId;
  navn: Scalars["String"]["output"];
};

export type BestaaetStatusKode = {
  __typename?: "BestaaetStatusKode";
  kursusPerson: Array<KursusPerson>;
  nr: BestaaetStatusId;
  navn: Scalars["String"]["output"];
};

export type KursusPersonKursusGruppe = {
  __typename?: "KursusPersonKursusGruppe";
  kursusGruppeNr: Scalars["Int"]["output"];
  kursusPersonId: Scalars["UUID"]["output"];
  kursusGruppeNrNavigation?: Maybe<KursusGruppe>;
  kursusPerson: KursusPerson;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type PersonDtoFilterInput = {
  and?: InputMaybe<Array<PersonDtoFilterInput>>;
  or?: InputMaybe<Array<PersonDtoFilterInput>>;
  fmulinjeKursist?: InputMaybe<ListFilterInputTypeOfFmulinjeKursistFilterInput>;
  fmuretssagsproeveEksaminand?: InputMaybe<ListFilterInputTypeOfFmuretssagsproeveFilterInput>;
  fmuretssagsproeveCensor?: InputMaybe<ListFilterInputTypeOfFmuretssagsproeveFilterInput>;
  foreningPerson?: InputMaybe<ListFilterInputTypeOfPersonForeningFilterInput>;
  kursusholdUnderviser?: InputMaybe<ListFilterInputTypeOfKursusholdUnderviserFilterInput>;
  personAbonnement?: InputMaybe<ListFilterInputTypeOfPersonAbonnementFilterInput>;
  personPersonart?: InputMaybe<ListFilterInputTypeOfPersonPersonartFilterInput>;
  personBeskikkelse?: InputMaybe<ListFilterInputTypeOfPersonBeskikkelseFilterInput>;
  personBetalingsadresse?: InputMaybe<ListFilterInputTypeOfPersonBetalingsadresseFilterInput>;
  personBidragsopkraevning?: InputMaybe<ListFilterInputTypeOfPersonBidragsopkraevningFilterInput>;
  personDisciplinaerstatus?: InputMaybe<ListFilterInputTypeOfPersonDisciplinaerstatusFilterInput>;
  personEfteruddannelse?: InputMaybe<ListFilterInputTypeOfPersonEfteruddannelseFilterInput>;
  personPaabud?: InputMaybe<ListFilterInputTypeOfPersonPaabudFilterInput>;
  personPaalaeg?: InputMaybe<ListFilterInputTypeOfPersonPaalaegFilterInput>;
  personFirma?: InputMaybe<ListFilterInputTypeOfPersonFirmaFilterInput>;
  personForsikring?: InputMaybe<ListFilterInputTypeOfPersonForsikringFilterInput>;
  personhistorikNavigation?: InputMaybe<ListFilterInputTypeOfPersonhistorikFilterInput>;
  personhistorik2Navigation?: InputMaybe<ListFilterInputTypeOfPersonhistorik2FilterInput>;
  personInteresse?: InputMaybe<ListFilterInputTypeOfPersonInteresseFilterInput>;
  personKlienterklaering?: InputMaybe<ListFilterInputTypeOfPersonKlienterklaeringFilterInput>;
  personKontaktadresse?: InputMaybe<ListFilterInputTypeOfPersonKontaktadresseFilterInput>;
  personKorrespondance?: InputMaybe<ListFilterInputTypeOfPersonKorrespondanceFilterInput>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  personPrincipalPersonFuldm?: InputMaybe<ListFilterInputTypeOfPersonPrincipalFilterInput>;
  personPrincipalPersonPrincipalNavigation?: InputMaybe<ListFilterInputTypeOfPersonPrincipalFilterInput>;
  personSanktion?: InputMaybe<ListFilterInputTypeOfPersonSanktionFilterInput>;
  personTilsyn?: InputMaybe<ListFilterInputTypeOfPersonTilsynFilterInput>;
  personTilsynserklaering?: InputMaybe<ListFilterInputTypeOfPersonTilsynserklaeringFilterInput>;
  personPersontype?: InputMaybe<ListFilterInputTypeOfPersonPersontypeFilterInput>;
  personUdvalg?: InputMaybe<ListFilterInputTypeOfPersonUdvalgFilterInput>;
  personUdenlandskadvokatsamfund?: InputMaybe<ListFilterInputTypeOfPersonUdenlandskadvokatsamfundFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  kundeNr?: InputMaybe<LongOperationFilterInput>;
  foedselsDato?: InputMaybe<DateOperationFilterInput>;
  koen?: InputMaybe<StringOperationFilterInput>;
  fornavne?: InputMaybe<StringOperationFilterInput>;
  efternavn?: InputMaybe<StringOperationFilterInput>;
  tlfMobilNr?: InputMaybe<StringOperationFilterInput>;
  emailPrivat?: InputMaybe<StringOperationFilterInput>;
  prioriterEmailPrivat?: InputMaybe<BooleanOperationFilterInput>;
  auktionsleder?: InputMaybe<BooleanOperationFilterInput>;
  advokatnoeglen?: InputMaybe<BooleanOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  personDoedDato?: InputMaybe<DateOperationFilterInput>;
  titelId?: InputMaybe<UuidOperationFilterInput>;
  titel1Id?: InputMaybe<UuidOperationFilterInput>;
  titel?: InputMaybe<TitelFilterInput>;
  titel1?: InputMaybe<TitelFilterInput>;
  /**
   * ?
   *             Personens fulde navn `Fornavne + " " + Efternavn`
   */
  fuldtNavn?: InputMaybe<StringOperationFilterInput>;
  /**
   * ?
   *             Returnerer true, hvis Person er udøvende dvs "ErUdoevendeAdvokat || ErUdoevendeAdvokatfuldmaegtig".
   *
   *             Note: Dette er en beregnet property. Der smides en exception hvis bagvedliggende data ikke er populeret.
   */
  erUdoevende?: InputMaybe<BooleanOperationFilterInput>;
  /** Personens primære firmarelation */
  primaerPersonFirmaRelation?: InputMaybe<PersonFirmaFilterInput>;
  /** Har personen møderet for højesteret på dags dato */
  moederetHoejesteret?: InputMaybe<BooleanOperationFilterInput>;
  /** Har personen møderet for landsretten på dags dato */
  moederetLandsret?: InputMaybe<BooleanOperationFilterInput>;
  /** Personens tidligste Beskikkelse (eller registrering som EU-advokat) */
  foersteBeskikkelse?: InputMaybe<PersonBeskikkelseFilterInput>;
  /** Personens seneste genudlevering af Beskikkelse (eller registerering som EU-advokat) */
  senesteGenudlevering?: InputMaybe<PersonBeskikkelseFilterInput>;
  /** Personens seneste deponering af beskikkelsen (eller afregistrering som EU-advokat) */
  senesteDeponering?: InputMaybe<PersonBeskikkelseFilterInput>;
  /**
   * Returnerer en adresse på personen efter følgende regel:
   * Hvis der findes en primær firmarelation anvendes adressen fra denne
   * Ellers anvendes en evt PersonKontaktadresse
   * Ellers null
   */
  adresse?: InputMaybe<PersonBeregnetAdresseFilterInput>;
  /** Returnerer debitorinfo fra personen. Denne stammer enten fra PersonBetalingsadresse, personens primære firmarelation eller som sidste udvej fra personens PersonKontaktadresse. Ellers null */
  debitorInfo?: InputMaybe<PersonDebitorInfoFilterInput>;
  /** Gældende personart */
  personart?: InputMaybe<PersonartIdOperationFilterInput>;
  /** Alder i hele år */
  alder?: InputMaybe<IntOperationFilterInput>;
  /** Personens primære principal dags dato */
  primaerPrincipal?: InputMaybe<PersonFilterInput>;
  /**
   * Emailadresse, som skal bruges ved afsendelse.
   * Er Person.PrioriterEmailPrivat==true priorites EmailPrivat ellers prioriteres EmailArbejde fra den primære firmarelation
   */
  prioriteretEmail?: InputMaybe<StringOperationFilterInput>;
  /** Har personen et udfyldt Cpr-nummer */
  harCprNummer?: InputMaybe<BooleanOperationFilterInput>;
};

export type PersonDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  kundeNr?: InputMaybe<SortEnumType>;
  foedselsDato?: InputMaybe<SortEnumType>;
  koen?: InputMaybe<SortEnumType>;
  fornavne?: InputMaybe<SortEnumType>;
  efternavn?: InputMaybe<SortEnumType>;
  tlfMobilNr?: InputMaybe<SortEnumType>;
  emailPrivat?: InputMaybe<SortEnumType>;
  prioriterEmailPrivat?: InputMaybe<SortEnumType>;
  auktionsleder?: InputMaybe<SortEnumType>;
  advokatnoeglen?: InputMaybe<SortEnumType>;
  bemaerkninger?: InputMaybe<SortEnumType>;
  personDoedDato?: InputMaybe<SortEnumType>;
  titelId?: InputMaybe<SortEnumType>;
  titel1Id?: InputMaybe<SortEnumType>;
  titel?: InputMaybe<TitelSortInput>;
  titel1?: InputMaybe<TitelSortInput>;
  /**
   * ?
   *             Personens fulde navn `Fornavne + " " + Efternavn`
   */
  fuldtNavn?: InputMaybe<SortEnumType>;
  /**
   * ?
   *             Returnerer true, hvis Person er udøvende dvs "ErUdoevendeAdvokat || ErUdoevendeAdvokatfuldmaegtig".
   *
   *             Note: Dette er en beregnet property. Der smides en exception hvis bagvedliggende data ikke er populeret.
   */
  erUdoevende?: InputMaybe<SortEnumType>;
  /** Personens primære firmarelation */
  primaerPersonFirmaRelation?: InputMaybe<PersonFirmaSortInput>;
  /** Har personen møderet for højesteret på dags dato */
  moederetHoejesteret?: InputMaybe<SortEnumType>;
  /** Har personen møderet for landsretten på dags dato */
  moederetLandsret?: InputMaybe<SortEnumType>;
  /** Personens tidligste Beskikkelse (eller registrering som EU-advokat) */
  foersteBeskikkelse?: InputMaybe<PersonBeskikkelseSortInput>;
  /** Personens seneste genudlevering af Beskikkelse (eller registerering som EU-advokat) */
  senesteGenudlevering?: InputMaybe<PersonBeskikkelseSortInput>;
  /** Personens seneste deponering af beskikkelsen (eller afregistrering som EU-advokat) */
  senesteDeponering?: InputMaybe<PersonBeskikkelseSortInput>;
  /**
   * Returnerer en adresse på personen efter følgende regel:
   * Hvis der findes en primær firmarelation anvendes adressen fra denne
   * Ellers anvendes en evt PersonKontaktadresse
   * Ellers null
   */
  adresse?: InputMaybe<PersonBeregnetAdresseSortInput>;
  /** Returnerer debitorinfo fra personen. Denne stammer enten fra PersonBetalingsadresse, personens primære firmarelation eller som sidste udvej fra personens PersonKontaktadresse. Ellers null */
  debitorInfo?: InputMaybe<PersonDebitorInfoSortInput>;
  /** Gældende personart */
  personart?: InputMaybe<SortEnumType>;
  /** Alder i hele år */
  alder?: InputMaybe<SortEnumType>;
  /** Personens primære principal dags dato */
  primaerPrincipal?: InputMaybe<PersonSortInput>;
  /**
   * Emailadresse, som skal bruges ved afsendelse.
   * Er Person.PrioriterEmailPrivat==true priorites EmailPrivat ellers prioriteres EmailArbejde fra den primære firmarelation
   */
  prioriteretEmail?: InputMaybe<SortEnumType>;
  /** Har personen et udfyldt Cpr-nummer */
  harCprNummer?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PersonerConnection = {
  __typename?: "PersonerConnection";
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<PersonerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PersonDto>>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars["Int"]["output"];
};

export type FirmaDtoFilterInput = {
  and?: InputMaybe<Array<FirmaDtoFilterInput>>;
  or?: InputMaybe<Array<FirmaDtoFilterInput>>;
  firmaAbonnement?: InputMaybe<ListFilterInputTypeOfFirmaAbonnementFilterInput>;
  firmaBetalingsadresse?: InputMaybe<ListFilterInputTypeOfFirmaBetalingsadresseFilterInput>;
  firmaejerskabEjendeFirmaNavigation?: InputMaybe<ListFilterInputTypeOfFirmaejerskabFilterInput>;
  firmaejerskabEjetFirma?: InputMaybe<ListFilterInputTypeOfFirmaejerskabFilterInput>;
  firmahistorikNavigation?: InputMaybe<ListFilterInputTypeOfFirmahistorikFilterInput>;
  firmahistorik2Navigation?: InputMaybe<ListFilterInputTypeOfFirmahistorik2FilterInput>;
  firmaKlienterklaering?: InputMaybe<ListFilterInputTypeOfFirmaKlienterklaeringFilterInput>;
  firmaKorrespondance?: InputMaybe<ListFilterInputTypeOfFirmaKorrespondanceFilterInput>;
  firmaSanktion?: InputMaybe<ListFilterInputTypeOfFirmaSanktionFilterInput>;
  firmaTilsyn?: InputMaybe<ListFilterInputTypeOfFirmaTilsynFilterInput>;
  personFirma?: InputMaybe<ListFilterInputTypeOfPersonFirmaFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  firmaNr?: InputMaybe<LongOperationFilterInput>;
  cvrNr?: InputMaybe<LongOperationFilterInput>;
  pnr?: InputMaybe<LongOperationFilterInput>;
  /** Datoen for produktionsenhedens ophør registreret i CVR */
  pnrOphoertCvr?: InputMaybe<DateOperationFilterInput>;
  /** Produktionsenhedens status i CVR. */
  pnrStatusCvr?: InputMaybe<StringOperationFilterInput>;
  /** Virksomhedens status i CVR. */
  cvrNrStatusCvr?: InputMaybe<StringOperationFilterInput>;
  /** Virksomhedens ID i et udenlandsk virksomhedsregister svarende til CVR. */
  udenlandskVirksomhedsId?: InputMaybe<StringOperationFilterInput>;
  /** Driver selskabet advokatvirksomhed? */
  advokatVirksomhed?: InputMaybe<BooleanOperationFilterInput>;
  /** Perioden fra firmaets Startdato til dets Ophørsdato. */
  periode?: InputMaybe<DatoIntervalFilterInput>;
  navn1?: InputMaybe<StringOperationFilterInput>;
  navn2?: InputMaybe<StringOperationFilterInput>;
  navn3?: InputMaybe<StringOperationFilterInput>;
  /** Firmaets beliggenhedsadresse jfr CVR eller manuelt indtastet */
  beliggenhedsadresse?: InputMaybe<AdresseFilterInput>;
  kommuneNr?: InputMaybe<IntOperationFilterInput>;
  retskredsNr?: InputMaybe<IntOperationFilterInput>;
  tlf?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  webAdresse?: InputMaybe<StringOperationFilterInput>;
  selskabstype?: InputMaybe<IntOperationFilterInput>;
  emailSikker?: InputMaybe<StringOperationFilterInput>;
  virksomhedsform?: InputMaybe<NullableOfVirksomhedsformIdOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  fakturaAfsendelse?: InputMaybe<FakturaAfsendelseIdOperationFilterInput>;
  fakturaEmail?: InputMaybe<StringOperationFilterInput>;
  ean?: InputMaybe<StringOperationFilterInput>;
  fakturaReference?: InputMaybe<StringOperationFilterInput>;
  virksomhedsformNavigation?: InputMaybe<VirksomhedsformKodeFilterInput>;
  fakturaAfsendNavigation?: InputMaybe<FakturaAfsendelseKodeFilterInput>;
  retskredsNrNavigation?: InputMaybe<RetskredsFilterInput>;
  selskabstypeNavigation?: InputMaybe<SelskabstypeFilterInput>;
  kommuneNavigation?: InputMaybe<KommuneFilterInput>;
  /** Har dette firma mindst en nugældende relation til en Udøvende person */
  harUdoevende?: InputMaybe<BooleanOperationFilterInput>;
  /** Har dette firma mindst en nugældende relation til en person */
  harPersonrelationer?: InputMaybe<BooleanOperationFilterInput>;
  /** Nugældende firmatype */
  firmatype?: InputMaybe<FirmatypeOperationFilterInput>;
  /** Indikation af om brugeren af Aikas webgrænseflade forventer at se dette firma i sine lister som default */
  aktiv?: InputMaybe<BooleanOperationFilterInput>;
  /** Debitorinformationer for firmaet. Kan stamme fra enten `Firma` eller `FirmaBetalingsadresse` */
  debitorInfo?: InputMaybe<FirmaDebitorInfoFilterInput>;
  /** Antallet af ansatte, som er Udøvende og har personart Advokat */
  antalAnsatteUdoevendeAdvokater?: InputMaybe<IntOperationFilterInput>;
};

export type FirmaDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  firmaNr?: InputMaybe<SortEnumType>;
  cvrNr?: InputMaybe<SortEnumType>;
  pnr?: InputMaybe<SortEnumType>;
  /** Datoen for produktionsenhedens ophør registreret i CVR */
  pnrOphoertCvr?: InputMaybe<SortEnumType>;
  /** Produktionsenhedens status i CVR. */
  pnrStatusCvr?: InputMaybe<SortEnumType>;
  /** Virksomhedens status i CVR. */
  cvrNrStatusCvr?: InputMaybe<SortEnumType>;
  /** Virksomhedens ID i et udenlandsk virksomhedsregister svarende til CVR. */
  udenlandskVirksomhedsId?: InputMaybe<SortEnumType>;
  /** Driver selskabet advokatvirksomhed? */
  advokatVirksomhed?: InputMaybe<SortEnumType>;
  /** Perioden fra firmaets Startdato til dets Ophørsdato. */
  periode?: InputMaybe<DatoIntervalSortInput>;
  navn1?: InputMaybe<SortEnumType>;
  navn2?: InputMaybe<SortEnumType>;
  navn3?: InputMaybe<SortEnumType>;
  /** Firmaets beliggenhedsadresse jfr CVR eller manuelt indtastet */
  beliggenhedsadresse?: InputMaybe<AdresseSortInput>;
  kommuneNr?: InputMaybe<SortEnumType>;
  retskredsNr?: InputMaybe<SortEnumType>;
  tlf?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  webAdresse?: InputMaybe<SortEnumType>;
  selskabstype?: InputMaybe<SortEnumType>;
  emailSikker?: InputMaybe<SortEnumType>;
  virksomhedsform?: InputMaybe<SortEnumType>;
  bemaerkninger?: InputMaybe<SortEnumType>;
  fakturaAfsendelse?: InputMaybe<SortEnumType>;
  fakturaEmail?: InputMaybe<SortEnumType>;
  ean?: InputMaybe<SortEnumType>;
  fakturaReference?: InputMaybe<SortEnumType>;
  virksomhedsformNavigation?: InputMaybe<VirksomhedsformKodeSortInput>;
  fakturaAfsendNavigation?: InputMaybe<FakturaAfsendelseKodeSortInput>;
  retskredsNrNavigation?: InputMaybe<RetskredsSortInput>;
  selskabstypeNavigation?: InputMaybe<SelskabstypeSortInput>;
  kommuneNavigation?: InputMaybe<KommuneSortInput>;
  /** Har dette firma mindst en nugældende relation til en Udøvende person */
  harUdoevende?: InputMaybe<SortEnumType>;
  /** Har dette firma mindst en nugældende relation til en person */
  harPersonrelationer?: InputMaybe<SortEnumType>;
  /** Nugældende firmatype */
  firmatype?: InputMaybe<SortEnumType>;
  /** Indikation af om brugeren af Aikas webgrænseflade forventer at se dette firma i sine lister som default */
  aktiv?: InputMaybe<SortEnumType>;
  /** Debitorinformationer for firmaet. Kan stamme fra enten `Firma` eller `FirmaBetalingsadresse` */
  debitorInfo?: InputMaybe<FirmaDebitorInfoSortInput>;
  /** Antallet af ansatte, som er Udøvende og har personart Advokat */
  antalAnsatteUdoevendeAdvokater?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FirmaerConnection = {
  __typename?: "FirmaerConnection";
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<FirmaerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmaDto>>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars["Int"]["output"];
};

export type KursusholdDtoFilterInput = {
  and?: InputMaybe<Array<KursusholdDtoFilterInput>>;
  or?: InputMaybe<Array<KursusholdDtoFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  holdNr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  kursustype?: InputMaybe<IntOperationFilterInput>;
  varighed?: InputMaybe<StringOperationFilterInput>;
  hotelId?: InputMaybe<UuidOperationFilterInput>;
  fraDato?: InputMaybe<DateOperationFilterInput>;
  fraKlDag?: InputMaybe<TimeSpanOperationFilterInput>;
  tilDato?: InputMaybe<DateOperationFilterInput>;
  tilKlDag?: InputMaybe<TimeSpanOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  pris?: InputMaybe<DecimalOperationFilterInput>;
  kodeKursusmappe?: InputMaybe<StringOperationFilterInput>;
  fmulinjeId?: InputMaybe<UuidOperationFilterInput>;
  fmukursusKategoriNr?: InputMaybe<IntOperationFilterInput>;
  hotelNavigation?: InputMaybe<HotelFilterInput>;
  kursustypeNavigation?: InputMaybe<KursustypeFilterInput>;
  fmukursusKategoriNavigation?: InputMaybe<FmukursusKategoriFilterInput>;
  fmulinje?: InputMaybe<FmulinjeFilterInput>;
  kursusholdUnderviser?: InputMaybe<ListFilterInputTypeOfKursusholdUnderviserFilterInput>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  kursusKorrespondance?: InputMaybe<ListFilterInputTypeOfKursusholdKorrespondanceFilterInput>;
  antalTilmeldte?: InputMaybe<IntOperationFilterInput>;
  antalTilmeldteFraLinje?: InputMaybe<IntOperationFilterInput>;
  antalTilmeldteOvernatingFraDagenFoer?: InputMaybe<IntOperationFilterInput>;
  antalTilmeldteOvernatingMellemKursusdage?: InputMaybe<IntOperationFilterInput>;
};

export type KursusholdDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  holdNr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  kursustype?: InputMaybe<SortEnumType>;
  varighed?: InputMaybe<SortEnumType>;
  hotelId?: InputMaybe<SortEnumType>;
  fraDato?: InputMaybe<SortEnumType>;
  fraKlDag?: InputMaybe<SortEnumType>;
  tilDato?: InputMaybe<SortEnumType>;
  tilKlDag?: InputMaybe<SortEnumType>;
  bemaerkninger?: InputMaybe<SortEnumType>;
  pris?: InputMaybe<SortEnumType>;
  kodeKursusmappe?: InputMaybe<SortEnumType>;
  fmulinjeId?: InputMaybe<SortEnumType>;
  fmukursusKategoriNr?: InputMaybe<SortEnumType>;
  hotelNavigation?: InputMaybe<HotelSortInput>;
  kursustypeNavigation?: InputMaybe<KursustypeSortInput>;
  fmukursusKategoriNavigation?: InputMaybe<FmukursusKategoriSortInput>;
  fmulinje?: InputMaybe<FmulinjeSortInput>;
  antalTilmeldte?: InputMaybe<SortEnumType>;
  antalTilmeldteFraLinje?: InputMaybe<SortEnumType>;
  antalTilmeldteOvernatingFraDagenFoer?: InputMaybe<SortEnumType>;
  antalTilmeldteOvernatingMellemKursusdage?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type KursusholdsConnection = {
  __typename?: "KursusholdsConnection";
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<KursusholdsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<KursusholdDto>>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars["Int"]["output"];
};

export type FmulinjeDtoFilterInput = {
  and?: InputMaybe<Array<FmulinjeDtoFilterInput>>;
  or?: InputMaybe<Array<FmulinjeDtoFilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  antalKurser?: InputMaybe<IntOperationFilterInput>;
  prisPrDag?: InputMaybe<DecimalOperationFilterInput>;
  prisPrNat?: InputMaybe<DecimalOperationFilterInput>;
  hotelId?: InputMaybe<UuidOperationFilterInput>;
  hotelNavigation?: InputMaybe<HotelFilterInput>;
  antalTilmeldte?: InputMaybe<IntOperationFilterInput>;
  fmulinjeKursist?: InputMaybe<ListFilterInputTypeOfFmulinjeKursistFilterInput>;
  kursushold?: InputMaybe<ListFilterInputTypeOfKursusholdFilterInput>;
};

export type FmulinjeDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  antalKurser?: InputMaybe<SortEnumType>;
  prisPrDag?: InputMaybe<SortEnumType>;
  prisPrNat?: InputMaybe<SortEnumType>;
  hotelId?: InputMaybe<SortEnumType>;
  hotelNavigation?: InputMaybe<HotelSortInput>;
  antalTilmeldte?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FmulinjerConnection = {
  __typename?: "FmulinjerConnection";
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<FmulinjerEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FmulinjeDto>>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars["Int"]["output"];
};

export type ListFilterInputTypeOfFmulinjeKursistFilterInput = {
  all?: InputMaybe<FmulinjeKursistFilterInput>;
  none?: InputMaybe<FmulinjeKursistFilterInput>;
  some?: InputMaybe<FmulinjeKursistFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFmuretssagsproeveFilterInput = {
  all?: InputMaybe<FmuretssagsproeveFilterInput>;
  none?: InputMaybe<FmuretssagsproeveFilterInput>;
  some?: InputMaybe<FmuretssagsproeveFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonForeningFilterInput = {
  all?: InputMaybe<PersonForeningFilterInput>;
  none?: InputMaybe<PersonForeningFilterInput>;
  some?: InputMaybe<PersonForeningFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfKursusholdUnderviserFilterInput = {
  all?: InputMaybe<KursusholdUnderviserFilterInput>;
  none?: InputMaybe<KursusholdUnderviserFilterInput>;
  some?: InputMaybe<KursusholdUnderviserFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonAbonnementFilterInput = {
  all?: InputMaybe<PersonAbonnementFilterInput>;
  none?: InputMaybe<PersonAbonnementFilterInput>;
  some?: InputMaybe<PersonAbonnementFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonPersonartFilterInput = {
  all?: InputMaybe<PersonPersonartFilterInput>;
  none?: InputMaybe<PersonPersonartFilterInput>;
  some?: InputMaybe<PersonPersonartFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonBeskikkelseFilterInput = {
  all?: InputMaybe<PersonBeskikkelseFilterInput>;
  none?: InputMaybe<PersonBeskikkelseFilterInput>;
  some?: InputMaybe<PersonBeskikkelseFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonBetalingsadresseFilterInput = {
  all?: InputMaybe<PersonBetalingsadresseFilterInput>;
  none?: InputMaybe<PersonBetalingsadresseFilterInput>;
  some?: InputMaybe<PersonBetalingsadresseFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonBidragsopkraevningFilterInput = {
  all?: InputMaybe<PersonBidragsopkraevningFilterInput>;
  none?: InputMaybe<PersonBidragsopkraevningFilterInput>;
  some?: InputMaybe<PersonBidragsopkraevningFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonDisciplinaerstatusFilterInput = {
  all?: InputMaybe<PersonDisciplinaerstatusFilterInput>;
  none?: InputMaybe<PersonDisciplinaerstatusFilterInput>;
  some?: InputMaybe<PersonDisciplinaerstatusFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonEfteruddannelseFilterInput = {
  all?: InputMaybe<PersonEfteruddannelseFilterInput>;
  none?: InputMaybe<PersonEfteruddannelseFilterInput>;
  some?: InputMaybe<PersonEfteruddannelseFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonPaabudFilterInput = {
  all?: InputMaybe<PersonPaabudFilterInput>;
  none?: InputMaybe<PersonPaabudFilterInput>;
  some?: InputMaybe<PersonPaabudFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonPaalaegFilterInput = {
  all?: InputMaybe<PersonPaalaegFilterInput>;
  none?: InputMaybe<PersonPaalaegFilterInput>;
  some?: InputMaybe<PersonPaalaegFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonFirmaFilterInput = {
  all?: InputMaybe<PersonFirmaFilterInput>;
  none?: InputMaybe<PersonFirmaFilterInput>;
  some?: InputMaybe<PersonFirmaFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonForsikringFilterInput = {
  all?: InputMaybe<PersonForsikringFilterInput>;
  none?: InputMaybe<PersonForsikringFilterInput>;
  some?: InputMaybe<PersonForsikringFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonhistorikFilterInput = {
  all?: InputMaybe<PersonhistorikFilterInput>;
  none?: InputMaybe<PersonhistorikFilterInput>;
  some?: InputMaybe<PersonhistorikFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonhistorik2FilterInput = {
  all?: InputMaybe<Personhistorik2FilterInput>;
  none?: InputMaybe<Personhistorik2FilterInput>;
  some?: InputMaybe<Personhistorik2FilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonInteresseFilterInput = {
  all?: InputMaybe<PersonInteresseFilterInput>;
  none?: InputMaybe<PersonInteresseFilterInput>;
  some?: InputMaybe<PersonInteresseFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonKlienterklaeringFilterInput = {
  all?: InputMaybe<PersonKlienterklaeringFilterInput>;
  none?: InputMaybe<PersonKlienterklaeringFilterInput>;
  some?: InputMaybe<PersonKlienterklaeringFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonKontaktadresseFilterInput = {
  all?: InputMaybe<PersonKontaktadresseFilterInput>;
  none?: InputMaybe<PersonKontaktadresseFilterInput>;
  some?: InputMaybe<PersonKontaktadresseFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonKorrespondanceFilterInput = {
  all?: InputMaybe<PersonKorrespondanceFilterInput>;
  none?: InputMaybe<PersonKorrespondanceFilterInput>;
  some?: InputMaybe<PersonKorrespondanceFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfKursusPersonFilterInput = {
  all?: InputMaybe<KursusPersonFilterInput>;
  none?: InputMaybe<KursusPersonFilterInput>;
  some?: InputMaybe<KursusPersonFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonPrincipalFilterInput = {
  all?: InputMaybe<PersonPrincipalFilterInput>;
  none?: InputMaybe<PersonPrincipalFilterInput>;
  some?: InputMaybe<PersonPrincipalFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonSanktionFilterInput = {
  all?: InputMaybe<PersonSanktionFilterInput>;
  none?: InputMaybe<PersonSanktionFilterInput>;
  some?: InputMaybe<PersonSanktionFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonTilsynFilterInput = {
  all?: InputMaybe<PersonTilsynFilterInput>;
  none?: InputMaybe<PersonTilsynFilterInput>;
  some?: InputMaybe<PersonTilsynFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonTilsynserklaeringFilterInput = {
  all?: InputMaybe<PersonTilsynserklaeringFilterInput>;
  none?: InputMaybe<PersonTilsynserklaeringFilterInput>;
  some?: InputMaybe<PersonTilsynserklaeringFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonPersontypeFilterInput = {
  all?: InputMaybe<PersonPersontypeFilterInput>;
  none?: InputMaybe<PersonPersontypeFilterInput>;
  some?: InputMaybe<PersonPersontypeFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonUdvalgFilterInput = {
  all?: InputMaybe<PersonUdvalgFilterInput>;
  none?: InputMaybe<PersonUdvalgFilterInput>;
  some?: InputMaybe<PersonUdvalgFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonUdenlandskadvokatsamfundFilterInput = {
  all?: InputMaybe<PersonUdenlandskadvokatsamfundFilterInput>;
  none?: InputMaybe<PersonUdenlandskadvokatsamfundFilterInput>;
  some?: InputMaybe<PersonUdenlandskadvokatsamfundFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars["UUID"]["input"]>;
  neq?: InputMaybe<Scalars["UUID"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["UUID"]["input"]>>>;
  gt?: InputMaybe<Scalars["UUID"]["input"]>;
  ngt?: InputMaybe<Scalars["UUID"]["input"]>;
  gte?: InputMaybe<Scalars["UUID"]["input"]>;
  ngte?: InputMaybe<Scalars["UUID"]["input"]>;
  lt?: InputMaybe<Scalars["UUID"]["input"]>;
  nlt?: InputMaybe<Scalars["UUID"]["input"]>;
  lte?: InputMaybe<Scalars["UUID"]["input"]>;
  nlte?: InputMaybe<Scalars["UUID"]["input"]>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars["DateTime"]["input"]>;
  neq?: InputMaybe<Scalars["DateTime"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>;
  gt?: InputMaybe<Scalars["DateTime"]["input"]>;
  ngt?: InputMaybe<Scalars["DateTime"]["input"]>;
  gte?: InputMaybe<Scalars["DateTime"]["input"]>;
  ngte?: InputMaybe<Scalars["DateTime"]["input"]>;
  lt?: InputMaybe<Scalars["DateTime"]["input"]>;
  nlt?: InputMaybe<Scalars["DateTime"]["input"]>;
  lte?: InputMaybe<Scalars["DateTime"]["input"]>;
  nlte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  eq?: InputMaybe<Scalars["String"]["input"]>;
  neq?: InputMaybe<Scalars["String"]["input"]>;
  contains?: InputMaybe<Scalars["String"]["input"]>;
  ncontains?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  startsWith?: InputMaybe<Scalars["String"]["input"]>;
  nstartsWith?: InputMaybe<Scalars["String"]["input"]>;
  endsWith?: InputMaybe<Scalars["String"]["input"]>;
  nendsWith?: InputMaybe<Scalars["String"]["input"]>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars["Long"]["input"]>;
  neq?: InputMaybe<Scalars["Long"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  gt?: InputMaybe<Scalars["Long"]["input"]>;
  ngt?: InputMaybe<Scalars["Long"]["input"]>;
  gte?: InputMaybe<Scalars["Long"]["input"]>;
  ngte?: InputMaybe<Scalars["Long"]["input"]>;
  lt?: InputMaybe<Scalars["Long"]["input"]>;
  nlt?: InputMaybe<Scalars["Long"]["input"]>;
  lte?: InputMaybe<Scalars["Long"]["input"]>;
  nlte?: InputMaybe<Scalars["Long"]["input"]>;
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars["Date"]["input"]>;
  neq?: InputMaybe<Scalars["Date"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["Date"]["input"]>>>;
  gt?: InputMaybe<Scalars["Date"]["input"]>;
  ngt?: InputMaybe<Scalars["Date"]["input"]>;
  gte?: InputMaybe<Scalars["Date"]["input"]>;
  ngte?: InputMaybe<Scalars["Date"]["input"]>;
  lt?: InputMaybe<Scalars["Date"]["input"]>;
  nlt?: InputMaybe<Scalars["Date"]["input"]>;
  lte?: InputMaybe<Scalars["Date"]["input"]>;
  nlte?: InputMaybe<Scalars["Date"]["input"]>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars["Boolean"]["input"]>;
  neq?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TitelFilterInput = {
  and?: InputMaybe<Array<TitelFilterInput>>;
  or?: InputMaybe<Array<TitelFilterInput>>;
  titelNr?: InputMaybe<IntOperationFilterInput>;
  titel1?: InputMaybe<StringOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  falId?: InputMaybe<StringOperationFilterInput>;
  falReferenceDatatypeIndex?: InputMaybe<IntOperationFilterInput>;
  falSkjult?: InputMaybe<BooleanOperationFilterInput>;
  fal?: InputMaybe<FalreferencedataFilterInput>;
  personTitel?: InputMaybe<ListFilterInputTypeOfPersonFilterInput>;
  personTitel1?: InputMaybe<ListFilterInputTypeOfPersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonFirmaFilterInput = {
  and?: InputMaybe<Array<PersonFirmaFilterInput>>;
  or?: InputMaybe<Array<PersonFirmaFilterInput>>;
  personfirmatypeNr?: InputMaybe<PersonfirmatypeIdOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  adresseStandard?: InputMaybe<BooleanOperationFilterInput>;
  adressePrioritet?: InputMaybe<IntOperationFilterInput>;
  priorieteretPrimaerFra?: InputMaybe<DateOperationFilterInput>;
  emailArbejde?: InputMaybe<StringOperationFilterInput>;
  fakturaReference?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personfirmatypeNrNavigation?: InputMaybe<PersonfirmatypeKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonBeskikkelseFilterInput = {
  and?: InputMaybe<Array<PersonBeskikkelseFilterInput>>;
  or?: InputMaybe<Array<PersonBeskikkelseFilterInput>>;
  beskikkelsestype?: InputMaybe<BeskikkelsestypeIdOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  aarsag?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  beskikkelsestypeNavigation?: InputMaybe<BeskikkelsestypeKodeFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonBeregnetAdresseFilterInput = {
  and?: InputMaybe<Array<PersonBeregnetAdresseFilterInput>>;
  or?: InputMaybe<Array<PersonBeregnetAdresseFilterInput>>;
  kildeId?: InputMaybe<UuidOperationFilterInput>;
  kilde?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  adresse?: InputMaybe<AdresseFilterInput>;
};

export type PersonDebitorInfoFilterInput = {
  and?: InputMaybe<Array<PersonDebitorInfoFilterInput>>;
  or?: InputMaybe<Array<PersonDebitorInfoFilterInput>>;
  kundeNr?: InputMaybe<LongOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  firmaNr?: InputMaybe<LongOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  adresse?: InputMaybe<AdresseFilterInput>;
  fakturaAfsendelse?: InputMaybe<FakturaAfsendelseIdOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  ean?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  personFirmaReference?: InputMaybe<StringOperationFilterInput>;
  attention?: InputMaybe<StringOperationFilterInput>;
  kilde?: InputMaybe<StringOperationFilterInput>;
  kildeId?: InputMaybe<UuidOperationFilterInput>;
  firmaNavigation?: InputMaybe<FirmaFilterInput>;
};

export type PersonartIdOperationFilterInput = {
  eq?: InputMaybe<PersonartId>;
  neq?: InputMaybe<PersonartId>;
  in?: InputMaybe<Array<PersonartId>>;
  nin?: InputMaybe<Array<PersonartId>>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars["Int"]["input"]>;
  neq?: InputMaybe<Scalars["Int"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  gt?: InputMaybe<Scalars["Int"]["input"]>;
  ngt?: InputMaybe<Scalars["Int"]["input"]>;
  gte?: InputMaybe<Scalars["Int"]["input"]>;
  ngte?: InputMaybe<Scalars["Int"]["input"]>;
  lt?: InputMaybe<Scalars["Int"]["input"]>;
  nlt?: InputMaybe<Scalars["Int"]["input"]>;
  lte?: InputMaybe<Scalars["Int"]["input"]>;
  nlte?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PersonFilterInput = {
  and?: InputMaybe<Array<PersonFilterInput>>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  kundeNr?: InputMaybe<LongOperationFilterInput>;
  foedselsDato?: InputMaybe<DateOperationFilterInput>;
  cprNummer?: InputMaybe<StringOperationFilterInput>;
  koen?: InputMaybe<StringOperationFilterInput>;
  fornavne?: InputMaybe<StringOperationFilterInput>;
  efternavn?: InputMaybe<StringOperationFilterInput>;
  tlfMobilNr?: InputMaybe<StringOperationFilterInput>;
  emailPrivat?: InputMaybe<StringOperationFilterInput>;
  prioriterEmailPrivat?: InputMaybe<BooleanOperationFilterInput>;
  auktionsleder?: InputMaybe<BooleanOperationFilterInput>;
  advokatnoeglen?: InputMaybe<BooleanOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  personDoedDato?: InputMaybe<DateOperationFilterInput>;
  titelId?: InputMaybe<UuidOperationFilterInput>;
  titel1Id?: InputMaybe<UuidOperationFilterInput>;
  titel?: InputMaybe<TitelFilterInput>;
  titel1?: InputMaybe<TitelFilterInput>;
  fmulinjeKursist?: InputMaybe<ListFilterInputTypeOfFmulinjeKursistFilterInput>;
  fmuretssagsproeveEksaminand?: InputMaybe<ListFilterInputTypeOfFmuretssagsproeveFilterInput>;
  fmuretssagsproeveCensor?: InputMaybe<ListFilterInputTypeOfFmuretssagsproeveFilterInput>;
  personForening?: InputMaybe<ListFilterInputTypeOfPersonForeningFilterInput>;
  kursusholdUnderviser?: InputMaybe<ListFilterInputTypeOfKursusholdUnderviserFilterInput>;
  personAbonnement?: InputMaybe<ListFilterInputTypeOfPersonAbonnementFilterInput>;
  personPersonart?: InputMaybe<ListFilterInputTypeOfPersonPersonartFilterInput>;
  personBeskikkelse?: InputMaybe<ListFilterInputTypeOfPersonBeskikkelseFilterInput>;
  personBetalingsadresse?: InputMaybe<ListFilterInputTypeOfPersonBetalingsadresseFilterInput>;
  personBidragsopkraevning?: InputMaybe<ListFilterInputTypeOfPersonBidragsopkraevningFilterInput>;
  personDisciplinaerstatus?: InputMaybe<ListFilterInputTypeOfPersonDisciplinaerstatusFilterInput>;
  personEfteruddannelse?: InputMaybe<ListFilterInputTypeOfPersonEfteruddannelseFilterInput>;
  personPaabud?: InputMaybe<ListFilterInputTypeOfPersonPaabudFilterInput>;
  personPaalaeg?: InputMaybe<ListFilterInputTypeOfPersonPaalaegFilterInput>;
  personFirma?: InputMaybe<ListFilterInputTypeOfPersonFirmaFilterInput>;
  personForsikring?: InputMaybe<ListFilterInputTypeOfPersonForsikringFilterInput>;
  personhistorikNavigation?: InputMaybe<ListFilterInputTypeOfPersonhistorikFilterInput>;
  personhistorik2Navigation?: InputMaybe<ListFilterInputTypeOfPersonhistorik2FilterInput>;
  personInteresse?: InputMaybe<ListFilterInputTypeOfPersonInteresseFilterInput>;
  personKlienterklaering?: InputMaybe<ListFilterInputTypeOfPersonKlienterklaeringFilterInput>;
  personKorrespondance?: InputMaybe<ListFilterInputTypeOfPersonKorrespondanceFilterInput>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  personPrincipalPersonFuldm?: InputMaybe<ListFilterInputTypeOfPersonPrincipalFilterInput>;
  personPrincipalPersonPrincipalNavigation?: InputMaybe<ListFilterInputTypeOfPersonPrincipalFilterInput>;
  personSanktion?: InputMaybe<ListFilterInputTypeOfPersonSanktionFilterInput>;
  personTilsyn?: InputMaybe<ListFilterInputTypeOfPersonTilsynFilterInput>;
  personTilsynserklaering?: InputMaybe<ListFilterInputTypeOfPersonTilsynserklaeringFilterInput>;
  personUdenlandskadvokatsamfund?: InputMaybe<ListFilterInputTypeOfPersonUdenlandskadvokatsamfundFilterInput>;
  personPersontype?: InputMaybe<ListFilterInputTypeOfPersonPersontypeFilterInput>;
  personUdvalg?: InputMaybe<ListFilterInputTypeOfPersonUdvalgFilterInput>;
  personKontaktadresse?: InputMaybe<ListFilterInputTypeOfPersonKontaktadresseFilterInput>;
  domainEvents?: InputMaybe<ListFilterInputTypeOfIDomainEventFilterInput>;
  fuldtNavn?: InputMaybe<StringOperationFilterInput>;
  erDoed?: InputMaybe<BooleanOperationFilterInput>;
  erUdoevende?: InputMaybe<BooleanOperationFilterInput>;
  adresse?: InputMaybe<PersonBeregnetAdresseFilterInput>;
  debitorInfo?: InputMaybe<PersonDebitorInfoFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export enum SortEnumType {
  Asc = "ASC",
  Desc = "DESC",
}

export type TitelSortInput = {
  titelNr?: InputMaybe<SortEnumType>;
  titel1?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  falId?: InputMaybe<SortEnumType>;
  falReferenceDatatypeIndex?: InputMaybe<SortEnumType>;
  falSkjult?: InputMaybe<SortEnumType>;
  fal?: InputMaybe<FalreferencedataSortInput>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type PersonFirmaSortInput = {
  personfirmatypeNr?: InputMaybe<SortEnumType>;
  periode?: InputMaybe<DatoIntervalSortInput>;
  bemaerkninger?: InputMaybe<SortEnumType>;
  adresseStandard?: InputMaybe<SortEnumType>;
  adressePrioritet?: InputMaybe<SortEnumType>;
  priorieteretPrimaerFra?: InputMaybe<SortEnumType>;
  emailArbejde?: InputMaybe<SortEnumType>;
  fakturaReference?: InputMaybe<SortEnumType>;
  personId?: InputMaybe<SortEnumType>;
  firmaId?: InputMaybe<SortEnumType>;
  firma?: InputMaybe<FirmaSortInput>;
  person?: InputMaybe<PersonSortInput>;
  personfirmatypeNrNavigation?: InputMaybe<PersonfirmatypeKodeSortInput>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type PersonBeskikkelseSortInput = {
  beskikkelsestype?: InputMaybe<SortEnumType>;
  periode?: InputMaybe<DatoIntervalSortInput>;
  aarsag?: InputMaybe<SortEnumType>;
  personId?: InputMaybe<SortEnumType>;
  beskikkelsestypeNavigation?: InputMaybe<BeskikkelsestypeKodeSortInput>;
  person?: InputMaybe<PersonSortInput>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type PersonBeregnetAdresseSortInput = {
  kildeId?: InputMaybe<SortEnumType>;
  kilde?: InputMaybe<SortEnumType>;
  personId?: InputMaybe<SortEnumType>;
  adresse?: InputMaybe<AdresseSortInput>;
};

export type PersonDebitorInfoSortInput = {
  kundeNr?: InputMaybe<SortEnumType>;
  personId?: InputMaybe<SortEnumType>;
  firmaNr?: InputMaybe<SortEnumType>;
  firmaId?: InputMaybe<SortEnumType>;
  adresse?: InputMaybe<AdresseSortInput>;
  fakturaAfsendelse?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  ean?: InputMaybe<SortEnumType>;
  reference?: InputMaybe<SortEnumType>;
  personFirmaReference?: InputMaybe<SortEnumType>;
  attention?: InputMaybe<SortEnumType>;
  kilde?: InputMaybe<SortEnumType>;
  kildeId?: InputMaybe<SortEnumType>;
  firmaNavigation?: InputMaybe<FirmaSortInput>;
};

export type PersonSortInput = {
  kundeNr?: InputMaybe<SortEnumType>;
  foedselsDato?: InputMaybe<SortEnumType>;
  cprNummer?: InputMaybe<SortEnumType>;
  koen?: InputMaybe<SortEnumType>;
  fornavne?: InputMaybe<SortEnumType>;
  efternavn?: InputMaybe<SortEnumType>;
  tlfMobilNr?: InputMaybe<SortEnumType>;
  emailPrivat?: InputMaybe<SortEnumType>;
  prioriterEmailPrivat?: InputMaybe<SortEnumType>;
  auktionsleder?: InputMaybe<SortEnumType>;
  advokatnoeglen?: InputMaybe<SortEnumType>;
  bemaerkninger?: InputMaybe<SortEnumType>;
  personDoedDato?: InputMaybe<SortEnumType>;
  titelId?: InputMaybe<SortEnumType>;
  titel1Id?: InputMaybe<SortEnumType>;
  titel?: InputMaybe<TitelSortInput>;
  titel1?: InputMaybe<TitelSortInput>;
  fuldtNavn?: InputMaybe<SortEnumType>;
  erDoed?: InputMaybe<SortEnumType>;
  erUdoevende?: InputMaybe<SortEnumType>;
  adresse?: InputMaybe<PersonBeregnetAdresseSortInput>;
  debitorInfo?: InputMaybe<PersonDebitorInfoSortInput>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars["Boolean"]["output"];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PersonDto = {
  __typename?: "PersonDto";
  fmulinjeKursist?: Maybe<Array<FmulinjeKursist>>;
  fmuretssagsproeveEksaminand?: Maybe<Array<Fmuretssagsproeve>>;
  fmuretssagsproeveCensor?: Maybe<Array<Fmuretssagsproeve>>;
  foreningPerson?: Maybe<Array<PersonForening>>;
  kursusholdUnderviser?: Maybe<Array<KursusholdUnderviser>>;
  personAbonnement?: Maybe<Array<PersonAbonnement>>;
  personPersonart?: Maybe<Array<PersonPersonart>>;
  personBeskikkelse?: Maybe<Array<PersonBeskikkelse>>;
  personBetalingsadresse?: Maybe<Array<PersonBetalingsadresse>>;
  personBidragsopkraevning?: Maybe<Array<PersonBidragsopkraevning>>;
  personDisciplinaerstatus?: Maybe<Array<PersonDisciplinaerstatus>>;
  personEfteruddannelse?: Maybe<Array<PersonEfteruddannelse>>;
  personPaabud?: Maybe<Array<PersonPaabud>>;
  personFirma?: Maybe<Array<PersonFirma>>;
  personForsikring?: Maybe<Array<PersonForsikring>>;
  personhistorikNavigation?: Maybe<Array<Personhistorik>>;
  personhistorik2Navigation?: Maybe<Array<Personhistorik2>>;
  personInteresse?: Maybe<Array<PersonInteresse>>;
  personKlienterklaering?: Maybe<Array<PersonKlienterklaering>>;
  personKontaktadresse?: Maybe<Array<PersonKontaktadresse>>;
  personKorrespondance?: Maybe<Array<PersonKorrespondance>>;
  kursusPerson?: Maybe<Array<KursusPerson>>;
  personPrincipalPersonFuldm?: Maybe<Array<PersonPrincipal>>;
  personPrincipalPersonPrincipalNavigation?: Maybe<Array<PersonPrincipal>>;
  personSanktion?: Maybe<Array<PersonSanktion>>;
  personTilsyn?: Maybe<Array<PersonTilsyn>>;
  personTilsynserklaering?: Maybe<Array<PersonTilsynserklaering>>;
  personPersontype?: Maybe<Array<PersonPersontype>>;
  personUdvalg?: Maybe<Array<PersonUdvalg>>;
  personUdenlandskadvokatsamfund?: Maybe<Array<PersonUdenlandskadvokatsamfund>>;
  personIdKort?: Maybe<Array<PersonIdKort>>;
  id: Scalars["UUID"]["output"];
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  kundeNr: Scalars["Long"]["output"];
  foedselsDato?: Maybe<Scalars["Date"]["output"]>;
  koen?: Maybe<Scalars["String"]["output"]>;
  fornavne?: Maybe<Scalars["String"]["output"]>;
  efternavn?: Maybe<Scalars["String"]["output"]>;
  tlfMobilNr?: Maybe<Scalars["String"]["output"]>;
  emailPrivat?: Maybe<Scalars["String"]["output"]>;
  prioriterEmailPrivat: Scalars["Boolean"]["output"];
  auktionsleder?: Maybe<Scalars["Boolean"]["output"]>;
  advokatnoeglen?: Maybe<Scalars["Boolean"]["output"]>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  personDoedDato?: Maybe<Scalars["Date"]["output"]>;
  titelId?: Maybe<Scalars["UUID"]["output"]>;
  titel1Id?: Maybe<Scalars["UUID"]["output"]>;
  titel?: Maybe<Titel>;
  titel1?: Maybe<Titel>;
  /**
   * ?
   *             Personens fulde navn `Fornavne + " " + Efternavn`
   */
  fuldtNavn?: Maybe<Scalars["String"]["output"]>;
  /**
   * ?
   *             Returnerer true, hvis Person er udøvende dvs "ErUdoevendeAdvokat || ErUdoevendeAdvokatfuldmaegtig".
   *
   *             Note: Dette er en beregnet property. Der smides en exception hvis bagvedliggende data ikke er populeret.
   */
  erUdoevende: Scalars["Boolean"]["output"];
  /** Personens primære firmarelation */
  primaerPersonFirmaRelation?: Maybe<PersonFirma>;
  /** Har personen møderet for højesteret på dags dato */
  moederetHoejesteret: Scalars["Boolean"]["output"];
  /** Har personen møderet for landsretten på dags dato */
  moederetLandsret: Scalars["Boolean"]["output"];
  /** Personens tidligste Beskikkelse (eller registrering som EU-advokat) */
  foersteBeskikkelse?: Maybe<PersonBeskikkelse>;
  /** Personens seneste genudlevering af Beskikkelse (eller registerering som EU-advokat) */
  senesteGenudlevering?: Maybe<PersonBeskikkelse>;
  /** Personens seneste deponering af beskikkelsen (eller afregistrering som EU-advokat) */
  senesteDeponering?: Maybe<PersonBeskikkelse>;
  /**
   * Returnerer en adresse på personen efter følgende regel:
   * Hvis der findes en primær firmarelation anvendes adressen fra denne
   * Ellers anvendes en evt PersonKontaktadresse
   * Ellers null
   */
  adresse?: Maybe<PersonBeregnetAdresse>;
  /** Returnerer debitorinfo fra personen. Denne stammer enten fra PersonBetalingsadresse, personens primære firmarelation eller som sidste udvej fra personens PersonKontaktadresse. Ellers null */
  debitorInfo?: Maybe<PersonDebitorInfo>;
  /** Gældende personart */
  personart: PersonartId;
  /** Alder i hele år */
  alder?: Maybe<Scalars["Int"]["output"]>;
  /** Personens primære principal dags dato */
  primaerPrincipal?: Maybe<Person>;
  /**
   * Emailadresse, som skal bruges ved afsendelse.
   * Er Person.PrioriterEmailPrivat==true priorites EmailPrivat ellers prioriteres EmailArbejde fra den primære firmarelation
   */
  prioriteretEmail?: Maybe<Scalars["String"]["output"]>;
  /** Har personen et udfyldt Cpr-nummer */
  harCprNummer: Scalars["Boolean"]["output"];
};

/** An edge in a connection. */
export type PersonerEdge = {
  __typename?: "PersonerEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node: PersonDto;
};

export type ListFilterInputTypeOfFirmaAbonnementFilterInput = {
  all?: InputMaybe<FirmaAbonnementFilterInput>;
  none?: InputMaybe<FirmaAbonnementFilterInput>;
  some?: InputMaybe<FirmaAbonnementFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmaBetalingsadresseFilterInput = {
  all?: InputMaybe<FirmaBetalingsadresseFilterInput>;
  none?: InputMaybe<FirmaBetalingsadresseFilterInput>;
  some?: InputMaybe<FirmaBetalingsadresseFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmaejerskabFilterInput = {
  all?: InputMaybe<FirmaejerskabFilterInput>;
  none?: InputMaybe<FirmaejerskabFilterInput>;
  some?: InputMaybe<FirmaejerskabFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmahistorikFilterInput = {
  all?: InputMaybe<FirmahistorikFilterInput>;
  none?: InputMaybe<FirmahistorikFilterInput>;
  some?: InputMaybe<FirmahistorikFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmahistorik2FilterInput = {
  all?: InputMaybe<Firmahistorik2FilterInput>;
  none?: InputMaybe<Firmahistorik2FilterInput>;
  some?: InputMaybe<Firmahistorik2FilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmaKlienterklaeringFilterInput = {
  all?: InputMaybe<FirmaKlienterklaeringFilterInput>;
  none?: InputMaybe<FirmaKlienterklaeringFilterInput>;
  some?: InputMaybe<FirmaKlienterklaeringFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmaKorrespondanceFilterInput = {
  all?: InputMaybe<FirmaKorrespondanceFilterInput>;
  none?: InputMaybe<FirmaKorrespondanceFilterInput>;
  some?: InputMaybe<FirmaKorrespondanceFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmaSanktionFilterInput = {
  all?: InputMaybe<FirmaSanktionFilterInput>;
  none?: InputMaybe<FirmaSanktionFilterInput>;
  some?: InputMaybe<FirmaSanktionFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfFirmaTilsynFilterInput = {
  all?: InputMaybe<FirmaTilsynFilterInput>;
  none?: InputMaybe<FirmaTilsynFilterInput>;
  some?: InputMaybe<FirmaTilsynFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DatoIntervalFilterInput = {
  and?: InputMaybe<Array<DatoIntervalFilterInput>>;
  or?: InputMaybe<Array<DatoIntervalFilterInput>>;
  fraDato?: InputMaybe<DateOperationFilterInput>;
  tilDato?: InputMaybe<DateOperationFilterInput>;
  tilDatoInklusiv?: InputMaybe<DateOperationFilterInput>;
};

export type AdresseFilterInput = {
  and?: InputMaybe<Array<AdresseFilterInput>>;
  or?: InputMaybe<Array<AdresseFilterInput>>;
  darAdresseId?: InputMaybe<UuidOperationFilterInput>;
  coNavn?: InputMaybe<StringOperationFilterInput>;
  adresselinie1?: InputMaybe<StringOperationFilterInput>;
  adresselinie2?: InputMaybe<StringOperationFilterInput>;
  postnummer?: InputMaybe<StringOperationFilterInput>;
  bynavn?: InputMaybe<StringOperationFilterInput>;
  adresselinie4?: InputMaybe<StringOperationFilterInput>;
  landekode?: InputMaybe<StringOperationFilterInput>;
  landNavigation?: InputMaybe<LandFilterInput>;
};

export type NullableOfVirksomhedsformIdOperationFilterInput = {
  eq?: InputMaybe<VirksomhedsformId>;
  neq?: InputMaybe<VirksomhedsformId>;
  in?: InputMaybe<Array<InputMaybe<VirksomhedsformId>>>;
  nin?: InputMaybe<Array<InputMaybe<VirksomhedsformId>>>;
};

export type FakturaAfsendelseIdOperationFilterInput = {
  eq?: InputMaybe<FakturaAfsendelseId>;
  neq?: InputMaybe<FakturaAfsendelseId>;
  in?: InputMaybe<Array<FakturaAfsendelseId>>;
  nin?: InputMaybe<Array<FakturaAfsendelseId>>;
};

export type VirksomhedsformKodeFilterInput = {
  and?: InputMaybe<Array<VirksomhedsformKodeFilterInput>>;
  or?: InputMaybe<Array<VirksomhedsformKodeFilterInput>>;
  definition?: InputMaybe<StringOperationFilterInput>;
  nr?: InputMaybe<VirksomhedsformIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type FakturaAfsendelseKodeFilterInput = {
  and?: InputMaybe<Array<FakturaAfsendelseKodeFilterInput>>;
  or?: InputMaybe<Array<FakturaAfsendelseKodeFilterInput>>;
  firma?: InputMaybe<ListFilterInputTypeOfFirmaFilterInput>;
  nr?: InputMaybe<FakturaAfsendelseIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type RetskredsFilterInput = {
  and?: InputMaybe<Array<RetskredsFilterInput>>;
  or?: InputMaybe<Array<RetskredsFilterInput>>;
  retskredsId?: InputMaybe<IntOperationFilterInput>;
  advokatkredsNr?: InputMaybe<IntOperationFilterInput>;
  advokatkredsNrNavigation?: InputMaybe<AdvokatkredsFilterInput>;
  firma?: InputMaybe<ListFilterInputTypeOfFirmaFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type SelskabstypeFilterInput = {
  and?: InputMaybe<Array<SelskabstypeFilterInput>>;
  or?: InputMaybe<Array<SelskabstypeFilterInput>>;
  firma?: InputMaybe<ListFilterInputTypeOfFirmaFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type KommuneFilterInput = {
  and?: InputMaybe<Array<KommuneFilterInput>>;
  or?: InputMaybe<Array<KommuneFilterInput>>;
  regionNr?: InputMaybe<IntOperationFilterInput>;
  regionNrNavigation?: InputMaybe<RegionFilterInput>;
  firma?: InputMaybe<ListFilterInputTypeOfFirmaFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type FirmatypeOperationFilterInput = {
  eq?: InputMaybe<Firmatype>;
  neq?: InputMaybe<Firmatype>;
  in?: InputMaybe<Array<Firmatype>>;
  nin?: InputMaybe<Array<Firmatype>>;
};

export type FirmaDebitorInfoFilterInput = {
  and?: InputMaybe<Array<FirmaDebitorInfoFilterInput>>;
  or?: InputMaybe<Array<FirmaDebitorInfoFilterInput>>;
  firmaNr?: InputMaybe<LongOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  adresse?: InputMaybe<AdresseFilterInput>;
  fakturaAfsendelse?: InputMaybe<FakturaAfsendelseIdOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  ean?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  attention?: InputMaybe<StringOperationFilterInput>;
  kilde?: InputMaybe<StringOperationFilterInput>;
  kildeId?: InputMaybe<UuidOperationFilterInput>;
};

export type DatoIntervalSortInput = {
  fraDato?: InputMaybe<SortEnumType>;
  tilDato?: InputMaybe<SortEnumType>;
  tilDatoInklusiv?: InputMaybe<SortEnumType>;
};

export type AdresseSortInput = {
  darAdresseId?: InputMaybe<SortEnumType>;
  coNavn?: InputMaybe<SortEnumType>;
  adresselinie1?: InputMaybe<SortEnumType>;
  adresselinie2?: InputMaybe<SortEnumType>;
  postnummer?: InputMaybe<SortEnumType>;
  bynavn?: InputMaybe<SortEnumType>;
  adresselinie4?: InputMaybe<SortEnumType>;
  landekode?: InputMaybe<SortEnumType>;
  landNavigation?: InputMaybe<LandSortInput>;
};

export type VirksomhedsformKodeSortInput = {
  definition?: InputMaybe<SortEnumType>;
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type FakturaAfsendelseKodeSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type RetskredsSortInput = {
  retskredsId?: InputMaybe<SortEnumType>;
  advokatkredsNr?: InputMaybe<SortEnumType>;
  advokatkredsNrNavigation?: InputMaybe<AdvokatkredsSortInput>;
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type SelskabstypeSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type KommuneSortInput = {
  regionNr?: InputMaybe<SortEnumType>;
  regionNrNavigation?: InputMaybe<RegionSortInput>;
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type FirmaDebitorInfoSortInput = {
  firmaNr?: InputMaybe<SortEnumType>;
  firmaId?: InputMaybe<SortEnumType>;
  adresse?: InputMaybe<AdresseSortInput>;
  fakturaAfsendelse?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  ean?: InputMaybe<SortEnumType>;
  reference?: InputMaybe<SortEnumType>;
  attention?: InputMaybe<SortEnumType>;
  kilde?: InputMaybe<SortEnumType>;
  kildeId?: InputMaybe<SortEnumType>;
};

export type FirmaDto = {
  __typename?: "FirmaDTO";
  firmaAbonnement?: Maybe<Array<FirmaAbonnement>>;
  firmaBetalingsadresse?: Maybe<Array<FirmaBetalingsadresse>>;
  firmaejerskabEjendeFirmaNavigation?: Maybe<Array<Firmaejerskab>>;
  firmaejerskabEjetFirma?: Maybe<Array<Firmaejerskab>>;
  firmahistorikNavigation?: Maybe<Array<Firmahistorik>>;
  firmahistorik2Navigation?: Maybe<Array<Firmahistorik2>>;
  firmaKlienterklaering?: Maybe<Array<FirmaKlienterklaering>>;
  firmaKorrespondance?: Maybe<Array<FirmaKorrespondance>>;
  firmaSanktion?: Maybe<Array<FirmaSanktion>>;
  firmaTilsyn?: Maybe<Array<FirmaTilsyn>>;
  personFirma?: Maybe<Array<PersonFirma>>;
  id: Scalars["UUID"]["output"];
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  firmaNr?: Maybe<Scalars["Long"]["output"]>;
  cvrNr?: Maybe<Scalars["Long"]["output"]>;
  pnr?: Maybe<Scalars["Long"]["output"]>;
  /** Datoen for produktionsenhedens ophør registreret i CVR */
  pnrOphoertCvr?: Maybe<Scalars["Date"]["output"]>;
  /** Produktionsenhedens status i CVR. */
  pnrStatusCvr?: Maybe<Scalars["String"]["output"]>;
  /** Virksomhedens status i CVR. */
  cvrNrStatusCvr?: Maybe<Scalars["String"]["output"]>;
  /** Virksomhedens ID i et udenlandsk virksomhedsregister svarende til CVR. */
  udenlandskVirksomhedsId?: Maybe<Scalars["String"]["output"]>;
  /** Driver selskabet advokatvirksomhed? */
  advokatVirksomhed?: Maybe<Scalars["Boolean"]["output"]>;
  /** Perioden fra firmaets Startdato til dets Ophørsdato. */
  periode?: Maybe<DatoInterval>;
  navn1?: Maybe<Scalars["String"]["output"]>;
  navn2?: Maybe<Scalars["String"]["output"]>;
  navn3?: Maybe<Scalars["String"]["output"]>;
  /** Firmaets beliggenhedsadresse jfr CVR eller manuelt indtastet */
  beliggenhedsadresse?: Maybe<Adresse>;
  kommuneNr?: Maybe<Scalars["Int"]["output"]>;
  retskredsNr?: Maybe<Scalars["Int"]["output"]>;
  tlf?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  webAdresse?: Maybe<Scalars["String"]["output"]>;
  selskabstype?: Maybe<Scalars["Int"]["output"]>;
  emailSikker?: Maybe<Scalars["String"]["output"]>;
  virksomhedsform?: Maybe<VirksomhedsformId>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  fakturaAfsendelse: FakturaAfsendelseId;
  fakturaEmail?: Maybe<Scalars["String"]["output"]>;
  ean?: Maybe<Scalars["String"]["output"]>;
  fakturaReference?: Maybe<Scalars["String"]["output"]>;
  virksomhedsformNavigation?: Maybe<VirksomhedsformKode>;
  fakturaAfsendNavigation?: Maybe<FakturaAfsendelseKode>;
  retskredsNrNavigation?: Maybe<Retskreds>;
  selskabstypeNavigation?: Maybe<Selskabstype>;
  kommuneNavigation?: Maybe<Kommune>;
  /** Har dette firma mindst en nugældende relation til en Udøvende person */
  harUdoevende: Scalars["Boolean"]["output"];
  /** Har dette firma mindst en nugældende relation til en person */
  harPersonrelationer: Scalars["Boolean"]["output"];
  /** Nugældende firmatype */
  firmatype: Firmatype;
  /** Indikation af om brugeren af Aikas webgrænseflade forventer at se dette firma i sine lister som default */
  aktiv: Scalars["Boolean"]["output"];
  /** Debitorinformationer for firmaet. Kan stamme fra enten `Firma` eller `FirmaBetalingsadresse` */
  debitorInfo: FirmaDebitorInfo;
  /** Antallet af ansatte, som er Udøvende og har personart Advokat */
  antalAnsatteUdoevendeAdvokater: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type FirmaerEdge = {
  __typename?: "FirmaerEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node: FirmaDto;
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  neq?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["TimeSpan"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["TimeSpan"]["input"]>>>;
  gt?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  ngt?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  gte?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  ngte?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  lt?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  nlt?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  lte?: InputMaybe<Scalars["TimeSpan"]["input"]>;
  nlte?: InputMaybe<Scalars["TimeSpan"]["input"]>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars["Decimal"]["input"]>;
  neq?: InputMaybe<Scalars["Decimal"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Decimal"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["Decimal"]["input"]>>>;
  gt?: InputMaybe<Scalars["Decimal"]["input"]>;
  ngt?: InputMaybe<Scalars["Decimal"]["input"]>;
  gte?: InputMaybe<Scalars["Decimal"]["input"]>;
  ngte?: InputMaybe<Scalars["Decimal"]["input"]>;
  lt?: InputMaybe<Scalars["Decimal"]["input"]>;
  nlt?: InputMaybe<Scalars["Decimal"]["input"]>;
  lte?: InputMaybe<Scalars["Decimal"]["input"]>;
  nlte?: InputMaybe<Scalars["Decimal"]["input"]>;
};

export type HotelFilterInput = {
  and?: InputMaybe<Array<HotelFilterInput>>;
  or?: InputMaybe<Array<HotelFilterInput>>;
  hotelNr?: InputMaybe<IntOperationFilterInput>;
  navn1?: InputMaybe<StringOperationFilterInput>;
  navn2?: InputMaybe<StringOperationFilterInput>;
  sted?: InputMaybe<StringOperationFilterInput>;
  tlfNr?: InputMaybe<StringOperationFilterInput>;
  faxNr?: InputMaybe<StringOperationFilterInput>;
  attPerson?: InputMaybe<StringOperationFilterInput>;
  eMail?: InputMaybe<StringOperationFilterInput>;
  webAdresse?: InputMaybe<StringOperationFilterInput>;
  aflysUgeHotel?: InputMaybe<IntOperationFilterInput>;
  aflysUgeV_relse?: InputMaybe<IntOperationFilterInput>;
  fuldtNavn?: InputMaybe<StringOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type KursustypeFilterInput = {
  and?: InputMaybe<Array<KursustypeFilterInput>>;
  or?: InputMaybe<Array<KursustypeFilterInput>>;
  kursushold?: InputMaybe<ListFilterInputTypeOfKursusholdFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type FmukursusKategoriFilterInput = {
  and?: InputMaybe<Array<FmukursusKategoriFilterInput>>;
  or?: InputMaybe<Array<FmukursusKategoriFilterInput>>;
  kursushold?: InputMaybe<ListFilterInputTypeOfKursusholdFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type FmulinjeFilterInput = {
  and?: InputMaybe<Array<FmulinjeFilterInput>>;
  or?: InputMaybe<Array<FmulinjeFilterInput>>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  antalKurser?: InputMaybe<IntOperationFilterInput>;
  prisPrDag?: InputMaybe<DecimalOperationFilterInput>;
  prisPrNat?: InputMaybe<DecimalOperationFilterInput>;
  hotelId?: InputMaybe<UuidOperationFilterInput>;
  hotelNavigation?: InputMaybe<HotelFilterInput>;
  fmulinjeKursist?: InputMaybe<ListFilterInputTypeOfFmulinjeKursistFilterInput>;
  kursushold?: InputMaybe<ListFilterInputTypeOfKursusholdFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type ListFilterInputTypeOfKursusholdKorrespondanceFilterInput = {
  all?: InputMaybe<KursusholdKorrespondanceFilterInput>;
  none?: InputMaybe<KursusholdKorrespondanceFilterInput>;
  some?: InputMaybe<KursusholdKorrespondanceFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HotelSortInput = {
  hotelNr?: InputMaybe<SortEnumType>;
  navn1?: InputMaybe<SortEnumType>;
  navn2?: InputMaybe<SortEnumType>;
  sted?: InputMaybe<SortEnumType>;
  tlfNr?: InputMaybe<SortEnumType>;
  faxNr?: InputMaybe<SortEnumType>;
  attPerson?: InputMaybe<SortEnumType>;
  eMail?: InputMaybe<SortEnumType>;
  webAdresse?: InputMaybe<SortEnumType>;
  aflysUgeHotel?: InputMaybe<SortEnumType>;
  aflysUgeV_relse?: InputMaybe<SortEnumType>;
  fuldtNavn?: InputMaybe<SortEnumType>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type KursustypeSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type FmukursusKategoriSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type FmulinjeSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  antalKurser?: InputMaybe<SortEnumType>;
  prisPrDag?: InputMaybe<SortEnumType>;
  prisPrNat?: InputMaybe<SortEnumType>;
  hotelId?: InputMaybe<SortEnumType>;
  hotelNavigation?: InputMaybe<HotelSortInput>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type KursusholdDto = {
  __typename?: "KursusholdDTO";
  id: Scalars["UUID"]["output"];
  holdNr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
  kursustype: Scalars["Int"]["output"];
  varighed?: Maybe<Scalars["String"]["output"]>;
  hotelId?: Maybe<Scalars["UUID"]["output"]>;
  fraDato: Scalars["Date"]["output"];
  fraKlDag?: Maybe<Scalars["TimeSpan"]["output"]>;
  tilDato: Scalars["Date"]["output"];
  tilKlDag?: Maybe<Scalars["TimeSpan"]["output"]>;
  bemaerkninger?: Maybe<Scalars["String"]["output"]>;
  pris?: Maybe<Scalars["Decimal"]["output"]>;
  kodeKursusmappe?: Maybe<Scalars["String"]["output"]>;
  fmulinjeId?: Maybe<Scalars["UUID"]["output"]>;
  fmukursusKategoriNr?: Maybe<Scalars["Int"]["output"]>;
  hotelNavigation?: Maybe<Hotel>;
  kursustypeNavigation?: Maybe<Kursustype>;
  fmukursusKategoriNavigation?: Maybe<FmukursusKategori>;
  fmulinje?: Maybe<Fmulinje>;
  kursusholdUnderviser?: Maybe<Array<KursusholdUnderviser>>;
  kursusPerson?: Maybe<Array<KursusPerson>>;
  kursusKorrespondance?: Maybe<Array<KursusholdKorrespondance>>;
  antalTilmeldte: Scalars["Int"]["output"];
  antalTilmeldteFraLinje: Scalars["Int"]["output"];
  antalTilmeldteOvernatingFraDagenFoer: Scalars["Int"]["output"];
  antalTilmeldteOvernatingMellemKursusdage: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type KursusholdsEdge = {
  __typename?: "KursusholdsEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node: KursusholdDto;
};

export type ListFilterInputTypeOfKursusholdFilterInput = {
  all?: InputMaybe<KursusholdFilterInput>;
  none?: InputMaybe<KursusholdFilterInput>;
  some?: InputMaybe<KursusholdFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type FmulinjeDto = {
  __typename?: "FmulinjeDTO";
  id: Scalars["UUID"]["output"];
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  nr: Scalars["Int"]["output"];
  navn?: Maybe<Scalars["String"]["output"]>;
  antalKurser?: Maybe<Scalars["Int"]["output"]>;
  prisPrDag?: Maybe<Scalars["Decimal"]["output"]>;
  prisPrNat?: Maybe<Scalars["Decimal"]["output"]>;
  hotelId: Scalars["UUID"]["output"];
  hotelNavigation: Hotel;
  antalTilmeldte?: Maybe<Scalars["Int"]["output"]>;
  fmulinjeKursist?: Maybe<Array<FmulinjeKursist>>;
  kursushold?: Maybe<Array<Kursushold>>;
};

/** An edge in a connection. */
export type FmulinjerEdge = {
  __typename?: "FmulinjerEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node: FmulinjeDto;
};

export type FmulinjeKursistFilterInput = {
  and?: InputMaybe<Array<FmulinjeKursistFilterInput>>;
  or?: InputMaybe<Array<FmulinjeKursistFilterInput>>;
  deltagerStatus?: InputMaybe<NullableOfDeltagerStatusIdOperationFilterInput>;
  tilmeldDato?: InputMaybe<DateOperationFilterInput>;
  overnatning?: InputMaybe<NullableOfOvernatningstypeIdOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fmulinjeId?: InputMaybe<UuidOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  fmulinje?: InputMaybe<FmulinjeFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  overnatningstypeNavigation?: InputMaybe<OvernatningstypeKodeFilterInput>;
  deltagerStatusNavigation?: InputMaybe<DeltagerStatusKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FmuretssagsproeveFilterInput = {
  and?: InputMaybe<Array<FmuretssagsproeveFilterInput>>;
  or?: InputMaybe<Array<FmuretssagsproeveFilterInput>>;
  nr?: InputMaybe<IntOperationFilterInput>;
  fiktiv?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<FmuretssagsproeveResultatIdOperationFilterInput>;
  eksaminandPersonId?: InputMaybe<UuidOperationFilterInput>;
  censorPersonId?: InputMaybe<UuidOperationFilterInput>;
  proceduredato?: InputMaybe<DateOperationFilterInput>;
  tidspunkt?: InputMaybe<StringOperationFilterInput>;
  retFirmaId?: InputMaybe<UuidOperationFilterInput>;
  adresse?: InputMaybe<StringOperationFilterInput>;
  retssal?: InputMaybe<StringOperationFilterInput>;
  bsNummer?: InputMaybe<StringOperationFilterInput>;
  antalDommere?: InputMaybe<IntOperationFilterInput>;
  dommernavn?: InputMaybe<StringOperationFilterInput>;
  pris?: InputMaybe<DecimalOperationFilterInput>;
  fakturaStatus?: InputMaybe<FakturaStatusIdOperationFilterInput>;
  fakturaNr?: InputMaybe<LongOperationFilterInput>;
  notat?: InputMaybe<StringOperationFilterInput>;
  eksaminandNavigation?: InputMaybe<PersonFilterInput>;
  censorNavigation?: InputMaybe<PersonFilterInput>;
  retNavigation?: InputMaybe<FirmaFilterInput>;
  statusNavigation?: InputMaybe<FmuretssagsproeveResultatKodeFilterInput>;
  fakturaStatusNavigation?: InputMaybe<FakturaStatusKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonForeningFilterInput = {
  and?: InputMaybe<Array<PersonForeningFilterInput>>;
  or?: InputMaybe<Array<PersonForeningFilterInput>>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  sidsteOpkraevning?: InputMaybe<IntOperationFilterInput>;
  lbNr?: InputMaybe<IntOperationFilterInput>;
  sidsteFakturaNr?: InputMaybe<LongOperationFilterInput>;
  foreningId?: InputMaybe<UuidOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  forening?: InputMaybe<ForeningFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type KursusholdUnderviserFilterInput = {
  and?: InputMaybe<Array<KursusholdUnderviserFilterInput>>;
  or?: InputMaybe<Array<KursusholdUnderviserFilterInput>>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  holdId?: InputMaybe<UuidOperationFilterInput>;
  hold?: InputMaybe<KursusholdFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonAbonnementFilterInput = {
  and?: InputMaybe<Array<PersonAbonnementFilterInput>>;
  or?: InputMaybe<Array<PersonAbonnementFilterInput>>;
  abonnementNr?: InputMaybe<IntOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  faktureres?: InputMaybe<BooleanOperationFilterInput>;
  antalEksemplar?: InputMaybe<IntOperationFilterInput>;
  sidsteOpkraevning?: InputMaybe<IntOperationFilterInput>;
  sidsteFakturaNr?: InputMaybe<LongOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  abonnementNrNavigation?: InputMaybe<AbonnementFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonPersonartFilterInput = {
  and?: InputMaybe<Array<PersonPersonartFilterInput>>;
  or?: InputMaybe<Array<PersonPersonartFilterInput>>;
  personartNr?: InputMaybe<PersonartIdOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personartNrNavigation?: InputMaybe<PersonartKodeFilterInput>;
};

export type PersonBetalingsadresseFilterInput = {
  and?: InputMaybe<Array<PersonBetalingsadresseFilterInput>>;
  or?: InputMaybe<Array<PersonBetalingsadresseFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  adresse?: InputMaybe<AdresseFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  attention?: InputMaybe<StringOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonBidragsopkraevningFilterInput = {
  and?: InputMaybe<Array<PersonBidragsopkraevningFilterInput>>;
  or?: InputMaybe<Array<PersonBidragsopkraevningFilterInput>>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  dato?: InputMaybe<DateOperationFilterInput>;
  opkraevningsaar?: InputMaybe<IntOperationFilterInput>;
  fakturaNr?: InputMaybe<LongOperationFilterInput>;
  faktureretBeloeb?: InputMaybe<DecimalOperationFilterInput>;
  fakturaStatus?: InputMaybe<FakturaStatusIdOperationFilterInput>;
  bidragsmodtager?: InputMaybe<BidragsmodtagerIdOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  fakturaStatusNavigation?: InputMaybe<FakturaStatusKodeFilterInput>;
  bidragsmodtagerNavigation?: InputMaybe<BidragsmodtagerKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonDisciplinaerstatusFilterInput = {
  and?: InputMaybe<Array<PersonDisciplinaerstatusFilterInput>>;
  or?: InputMaybe<Array<PersonDisciplinaerstatusFilterInput>>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  disciplinaerstatustypeNr?: InputMaybe<IntOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  esdhSagsNr?: InputMaybe<StringOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  disciplinaerstatustypeNrNavigation?: InputMaybe<DisciplinaerstatustypeFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonEfteruddannelseFilterInput = {
  and?: InputMaybe<Array<PersonEfteruddannelseFilterInput>>;
  or?: InputMaybe<Array<PersonEfteruddannelseFilterInput>>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  lektionerGennemfoert?: InputMaybe<FloatOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  fraDatoLaast?: InputMaybe<BooleanOperationFilterInput>;
  tilDatoLaast?: InputMaybe<BooleanOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personEfteruddannelseIndberetning?: InputMaybe<ListFilterInputTypeOfPersonEfteruddannelseIndberetningFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonPaabudFilterInput = {
  and?: InputMaybe<Array<PersonPaabudFilterInput>>;
  or?: InputMaybe<Array<PersonPaabudFilterInput>>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  paakraevedeLektioner?: InputMaybe<FloatOperationFilterInput>;
  lektionerGennemfoert?: InputMaybe<FloatOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  personEfteruddannelseId?: InputMaybe<UuidOperationFilterInput>;
  status?: InputMaybe<PersonPaabudStatusIdOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personEfteruddannelse?: InputMaybe<PersonEfteruddannelseFilterInput>;
  personPaabudIndberetning?: InputMaybe<ListFilterInputTypeOfPersonPaabudIndberetningFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonPaalaegFilterInput = {
  and?: InputMaybe<Array<PersonPaalaegFilterInput>>;
  or?: InputMaybe<Array<PersonPaalaegFilterInput>>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  paakraevedeLektioner?: InputMaybe<FloatOperationFilterInput>;
  lektionerGennemfoert?: InputMaybe<FloatOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  status?: InputMaybe<PersonPaalaegStatusIdOperationFilterInput>;
  decisionDocumentFileName?: InputMaybe<StringOperationFilterInput>;
  decisionDocumentContentType?: InputMaybe<StringOperationFilterInput>;
  kendelseDato?: InputMaybe<DateOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personPaalaegIndberetning?: InputMaybe<ListFilterInputTypeOfPersonPaalaegIndberetningFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonForsikringFilterInput = {
  and?: InputMaybe<Array<PersonForsikringFilterInput>>;
  or?: InputMaybe<Array<PersonForsikringFilterInput>>;
  policeNr?: InputMaybe<StringOperationFilterInput>;
  restance?: InputMaybe<BooleanOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  garantiordning?: InputMaybe<BooleanOperationFilterInput>;
  garantiPoliceNr?: InputMaybe<StringOperationFilterInput>;
  notat?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  forsikringsselskabId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  forsikringsselskab?: InputMaybe<ForsikringsselskabFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonhistorikFilterInput = {
  and?: InputMaybe<Array<PersonhistorikFilterInput>>;
  or?: InputMaybe<Array<PersonhistorikFilterInput>>;
  titel1?: InputMaybe<StringOperationFilterInput>;
  titel2?: InputMaybe<StringOperationFilterInput>;
  efternavn?: InputMaybe<StringOperationFilterInput>;
  fornavne?: InputMaybe<StringOperationFilterInput>;
  adr1?: InputMaybe<StringOperationFilterInput>;
  husNr?: InputMaybe<IntOperationFilterInput>;
  husNrBogstav?: InputMaybe<StringOperationFilterInput>;
  etageNr?: InputMaybe<StringOperationFilterInput>;
  side?: InputMaybe<StringOperationFilterInput>;
  adr2?: InputMaybe<StringOperationFilterInput>;
  adr3?: InputMaybe<StringOperationFilterInput>;
  adr4?: InputMaybe<StringOperationFilterInput>;
  postNr?: InputMaybe<StringOperationFilterInput>;
  landeKode?: InputMaybe<StringOperationFilterInput>;
  tlfPrivat?: InputMaybe<StringOperationFilterInput>;
  tlfMobilNr?: InputMaybe<StringOperationFilterInput>;
  tlfFaxNr?: InputMaybe<StringOperationFilterInput>;
  emailPrivat?: InputMaybe<StringOperationFilterInput>;
  webAdresse?: InputMaybe<StringOperationFilterInput>;
  personart?: InputMaybe<StringOperationFilterInput>;
  aktiv?: InputMaybe<BooleanOperationFilterInput>;
  foedselsDato?: InputMaybe<DateOperationFilterInput>;
  mkmark?: InputMaybe<StringOperationFilterInput>;
  postboks?: InputMaybe<IntOperationFilterInput>;
  regionNavn?: InputMaybe<StringOperationFilterInput>;
  kommuneNavn?: InputMaybe<StringOperationFilterInput>;
  kredsNavn?: InputMaybe<StringOperationFilterInput>;
  tlfArbejde?: InputMaybe<StringOperationFilterInput>;
  emailArbejde?: InputMaybe<StringOperationFilterInput>;
  afsendelsesformStd?: InputMaybe<StringOperationFilterInput>;
  frakendtBeskikkelse?: InputMaybe<BooleanOperationFilterInput>;
  advokatnoeglen?: InputMaybe<BooleanOperationFilterInput>;
  personDoed?: InputMaybe<BooleanOperationFilterInput>;
  personDoedDato?: InputMaybe<DateOperationFilterInput>;
  personFirmaNavn?: InputMaybe<StringOperationFilterInput>;
  advokatsamfundudlNavn?: InputMaybe<StringOperationFilterInput>;
  emailFirma?: InputMaybe<StringOperationFilterInput>;
  emailSikkerFirma?: InputMaybe<StringOperationFilterInput>;
  retskreds?: InputMaybe<IntOperationFilterInput>;
  land?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type Personhistorik2FilterInput = {
  and?: InputMaybe<Array<Personhistorik2FilterInput>>;
  or?: InputMaybe<Array<Personhistorik2FilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  snapshotTid?: InputMaybe<DateTimeOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  kundeNr?: InputMaybe<LongOperationFilterInput>;
  titel1?: InputMaybe<StringOperationFilterInput>;
  titel2?: InputMaybe<StringOperationFilterInput>;
  fornavne?: InputMaybe<StringOperationFilterInput>;
  efternavn?: InputMaybe<StringOperationFilterInput>;
  personart?: InputMaybe<StringOperationFilterInput>;
  erUdoevende?: InputMaybe<BooleanOperationFilterInput>;
  foedselsDato?: InputMaybe<DateOperationFilterInput>;
  personDoedDato?: InputMaybe<DateOperationFilterInput>;
  tlfMobilNr?: InputMaybe<StringOperationFilterInput>;
  emailPrivat?: InputMaybe<StringOperationFilterInput>;
  fakturaAfsendelse?: InputMaybe<StringOperationFilterInput>;
  primaerFirmaFirmaNr?: InputMaybe<LongOperationFilterInput>;
  primaerFirmaNavn?: InputMaybe<StringOperationFilterInput>;
  primaerFirmaEmailSikker?: InputMaybe<StringOperationFilterInput>;
  primaerFirmaEmailArbejde?: InputMaybe<StringOperationFilterInput>;
  primaerFirmaAdvokatkreds?: InputMaybe<StringOperationFilterInput>;
  adresseCoNavn?: InputMaybe<StringOperationFilterInput>;
  adresseAdresselinie1?: InputMaybe<StringOperationFilterInput>;
  adresseAdresselinie2?: InputMaybe<StringOperationFilterInput>;
  adressePostnummer?: InputMaybe<StringOperationFilterInput>;
  adresseBynavn?: InputMaybe<StringOperationFilterInput>;
  adresseAdresselinie4?: InputMaybe<StringOperationFilterInput>;
  adresseLandekode?: InputMaybe<StringOperationFilterInput>;
};

export type PersonInteresseFilterInput = {
  and?: InputMaybe<Array<PersonInteresseFilterInput>>;
  or?: InputMaybe<Array<PersonInteresseFilterInput>>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  interesseId?: InputMaybe<UuidOperationFilterInput>;
  interesse?: InputMaybe<InteresseFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonKlienterklaeringFilterInput = {
  and?: InputMaybe<Array<PersonKlienterklaeringFilterInput>>;
  or?: InputMaybe<Array<PersonKlienterklaeringFilterInput>>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  erklAar?: InputMaybe<IntOperationFilterInput>;
  erklNr?: InputMaybe<IntOperationFilterInput>;
  klienterklaeringstype?: InputMaybe<KlienterklaeringstypeIdOperationFilterInput>;
  erklModtaget?: InputMaybe<DateOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  frist?: InputMaybe<DateOperationFilterInput>;
  koerselDato?: InputMaybe<DateOperationFilterInput>;
  klienterklaeringStatus?: InputMaybe<KlienterklaeringStatusIdOperationFilterInput>;
  erklDocument?: InputMaybe<ListByteOperationFilterInput>;
  indberetningsData?: InputMaybe<StringOperationFilterInput>;
  erklNrWeb?: InputMaybe<IntOperationFilterInput>;
  indberettetformular?: InputMaybe<NullableOfKlienterklaeringIndberettetformularOperationFilterInput>;
  firmaCvrNr?: InputMaybe<LongOperationFilterInput>;
  klienterklaeringStatusNavigation?: InputMaybe<KlienterklaeringStatusKodeFilterInput>;
  klienterklaeringstypeNavigation?: InputMaybe<KlienterklaeringstypeKodeFilterInput>;
  klienterklaeringIndberettetformularNavigation?: InputMaybe<KlienterklaeringIndberettetformularKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonKontaktadresseFilterInput = {
  and?: InputMaybe<Array<PersonKontaktadresseFilterInput>>;
  or?: InputMaybe<Array<PersonKontaktadresseFilterInput>>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  adresse?: InputMaybe<AdresseFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  attention?: InputMaybe<StringOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonKorrespondanceFilterInput = {
  and?: InputMaybe<Array<PersonKorrespondanceFilterInput>>;
  or?: InputMaybe<Array<PersonKorrespondanceFilterInput>>;
  dokumentNr?: InputMaybe<IntOperationFilterInput>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  filnavn?: InputMaybe<StringOperationFilterInput>;
  dokument?: InputMaybe<ListByteOperationFilterInput>;
  originatorRid?: InputMaybe<UuidOperationFilterInput>;
  originatorTableName?: InputMaybe<StringOperationFilterInput>;
  searchRid?: InputMaybe<UuidOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type KursusPersonFilterInput = {
  and?: InputMaybe<Array<KursusPersonFilterInput>>;
  or?: InputMaybe<Array<KursusPersonFilterInput>>;
  deltagerStatus?: InputMaybe<NullableOfDeltagerStatusIdOperationFilterInput>;
  tilmeldtRaekkefoelge?: InputMaybe<IntOperationFilterInput>;
  tilmeldDato?: InputMaybe<DateOperationFilterInput>;
  betalMark?: InputMaybe<BooleanOperationFilterInput>;
  bestaaetMark?: InputMaybe<NullableOfBestaaetStatusIdOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  prisdeltagertotal?: InputMaybe<DecimalOperationFilterInput>;
  fakturaNr?: InputMaybe<LongOperationFilterInput>;
  fakturaStatus?: InputMaybe<FakturaStatusIdOperationFilterInput>;
  tilEksamen?: InputMaybe<BooleanOperationFilterInput>;
  afKursist?: InputMaybe<StringOperationFilterInput>;
  hotelPris?: InputMaybe<DecimalOperationFilterInput>;
  kursusPris?: InputMaybe<DecimalOperationFilterInput>;
  tillaegsPris?: InputMaybe<DecimalOperationFilterInput>;
  overnatning?: InputMaybe<NullableOfOvernatningstypeIdOperationFilterInput>;
  eksamensdato?: InputMaybe<DateOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fmuLinjeTilmeldt?: InputMaybe<BooleanOperationFilterInput>;
  ikkeGennemfoert?: InputMaybe<BooleanOperationFilterInput>;
  holdId?: InputMaybe<UuidOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  hold?: InputMaybe<KursusholdFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  fakturaStatusNavigation?: InputMaybe<FakturaStatusKodeFilterInput>;
  overnatningstypeNavigation?: InputMaybe<OvernatningstypeKodeFilterInput>;
  deltagerStatusNavigation?: InputMaybe<DeltagerStatusKodeFilterInput>;
  bestaaetStatusNavigation?: InputMaybe<BestaaetStatusKodeFilterInput>;
  kursusPersonKursusGruppe?: InputMaybe<ListFilterInputTypeOfKursusPersonKursusGruppeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonPrincipalFilterInput = {
  and?: InputMaybe<Array<PersonPrincipalFilterInput>>;
  or?: InputMaybe<Array<PersonPrincipalFilterInput>>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  personFuldmId?: InputMaybe<UuidOperationFilterInput>;
  personPrincipalId?: InputMaybe<UuidOperationFilterInput>;
  personFuldm?: InputMaybe<PersonFilterInput>;
  personPrincipalNavigation?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonSanktionFilterInput = {
  and?: InputMaybe<Array<PersonSanktionFilterInput>>;
  or?: InputMaybe<Array<PersonSanktionFilterInput>>;
  sagsNr?: InputMaybe<StringOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  sagsLink?: InputMaybe<StringOperationFilterInput>;
  afgoerelseskoder?: InputMaybe<StringOperationFilterInput>;
  indbragtretten?: InputMaybe<BooleanOperationFilterInput>;
  naevnskendelseSanktionstypeNr?: InputMaybe<IntOperationFilterInput>;
  naevnskendelseDato?: InputMaybe<DateOperationFilterInput>;
  naevnskendelseBoedebeloeb?: InputMaybe<IntOperationFilterInput>;
  retskendelseSanktionstypeNr?: InputMaybe<IntOperationFilterInput>;
  retskendelseDato?: InputMaybe<DateOperationFilterInput>;
  retskendelseBoedebeloeb?: InputMaybe<IntOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  naevnskendelseSanktionstypeNrNavigation?: InputMaybe<SanktionstypeFilterInput>;
  retskendelseSanktionstypeNrNavigation?: InputMaybe<SanktionstypeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonTilsynFilterInput = {
  and?: InputMaybe<Array<PersonTilsynFilterInput>>;
  or?: InputMaybe<Array<PersonTilsynFilterInput>>;
  personTilsynstype?: InputMaybe<PersonTilsynstypeIdOperationFilterInput>;
  gennemfoerselDato?: InputMaybe<DateOperationFilterInput>;
  sagsNr?: InputMaybe<StringOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  personTilsynstypeNavigation?: InputMaybe<PersonTilsynstypeKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonTilsynserklaeringFilterInput = {
  and?: InputMaybe<Array<PersonTilsynserklaeringFilterInput>>;
  or?: InputMaybe<Array<PersonTilsynserklaeringFilterInput>>;
  erklAar?: InputMaybe<IntOperationFilterInput>;
  erklModtaget?: InputMaybe<DateOperationFilterInput>;
  tilsynserklaeringStatus?: InputMaybe<TilsynserklaeringStatusIdOperationFilterInput>;
  erklDocument?: InputMaybe<ListByteOperationFilterInput>;
  koerselDato?: InputMaybe<DateOperationFilterInput>;
  frist?: InputMaybe<DateOperationFilterInput>;
  indberetningsData?: InputMaybe<StringOperationFilterInput>;
  forsikringDaekning?: InputMaybe<StringOperationFilterInput>;
  forsikringPolice?: InputMaybe<StringOperationFilterInput>;
  forsikringSelskab?: InputMaybe<StringOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  tilsynserklaeringStatusNavigation?: InputMaybe<TilsynserklaeringStatusKodeFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonPersontypeFilterInput = {
  and?: InputMaybe<Array<PersonPersontypeFilterInput>>;
  or?: InputMaybe<Array<PersonPersontypeFilterInput>>;
  persontypeNr?: InputMaybe<IntOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  persontypeNrNavigation?: InputMaybe<PersontypeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonUdvalgFilterInput = {
  and?: InputMaybe<Array<PersonUdvalgFilterInput>>;
  or?: InputMaybe<Array<PersonUdvalgFilterInput>>;
  tillidshvervNr?: InputMaybe<TillidshvervIdOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  fratraadtAarsag?: InputMaybe<StringOperationFilterInput>;
  udvalgId?: InputMaybe<UuidOperationFilterInput>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  tillidshvervNrNavigation?: InputMaybe<TillidshvervKodeFilterInput>;
  udvalg?: InputMaybe<UdvalgFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonUdenlandskadvokatsamfundFilterInput = {
  and?: InputMaybe<Array<PersonUdenlandskadvokatsamfundFilterInput>>;
  or?: InputMaybe<Array<PersonUdenlandskadvokatsamfundFilterInput>>;
  personId?: InputMaybe<UuidOperationFilterInput>;
  udenlandskadvokatsamfundId?: InputMaybe<UuidOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  person?: InputMaybe<PersonFilterInput>;
  udenlandskadvokatsamfundNavigation?: InputMaybe<UdenlandskadvokatsamfundFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FalreferencedataFilterInput = {
  and?: InputMaybe<Array<FalreferencedataFilterInput>>;
  or?: InputMaybe<Array<FalreferencedataFilterInput>>;
  referenceDataVaerdiId?: InputMaybe<StringOperationFilterInput>;
  referenceDatatypeIndex?: InputMaybe<IntOperationFilterInput>;
  referenceDatatypeGruppeNavn?: InputMaybe<StringOperationFilterInput>;
  referenceDataVaerdi?: InputMaybe<StringOperationFilterInput>;
  aktiv?: InputMaybe<BooleanOperationFilterInput>;
  interesse?: InputMaybe<ListFilterInputTypeOfInteresseFilterInput>;
  land?: InputMaybe<ListFilterInputTypeOfLandFilterInput>;
  titel?: InputMaybe<ListFilterInputTypeOfTitelFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type ListFilterInputTypeOfPersonFilterInput = {
  all?: InputMaybe<PersonFilterInput>;
  none?: InputMaybe<PersonFilterInput>;
  some?: InputMaybe<PersonFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PersonfirmatypeIdOperationFilterInput = {
  eq?: InputMaybe<PersonfirmatypeId>;
  neq?: InputMaybe<PersonfirmatypeId>;
  in?: InputMaybe<Array<PersonfirmatypeId>>;
  nin?: InputMaybe<Array<PersonfirmatypeId>>;
};

export type FirmaFilterInput = {
  and?: InputMaybe<Array<FirmaFilterInput>>;
  or?: InputMaybe<Array<FirmaFilterInput>>;
  firmaNr?: InputMaybe<LongOperationFilterInput>;
  cvrNr?: InputMaybe<LongOperationFilterInput>;
  pnr?: InputMaybe<LongOperationFilterInput>;
  pnrSubNr?: InputMaybe<IntOperationFilterInput>;
  pnrOphoertCvr?: InputMaybe<DateOperationFilterInput>;
  pnrStatusCvr?: InputMaybe<StringOperationFilterInput>;
  cvrNrStatusCvr?: InputMaybe<StringOperationFilterInput>;
  udenlandskVirksomhedsId?: InputMaybe<StringOperationFilterInput>;
  advokatVirksomhed?: InputMaybe<BooleanOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  navn1?: InputMaybe<StringOperationFilterInput>;
  navn2?: InputMaybe<StringOperationFilterInput>;
  navn3?: InputMaybe<StringOperationFilterInput>;
  beliggenhedsadresse?: InputMaybe<AdresseFilterInput>;
  kommuneNr?: InputMaybe<IntOperationFilterInput>;
  retskredsNr?: InputMaybe<IntOperationFilterInput>;
  tlf?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  webAdresse?: InputMaybe<StringOperationFilterInput>;
  selskabstype?: InputMaybe<IntOperationFilterInput>;
  emailSikker?: InputMaybe<StringOperationFilterInput>;
  virksomhedsform?: InputMaybe<NullableOfVirksomhedsformIdOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  fakturaAfsendelse?: InputMaybe<FakturaAfsendelseIdOperationFilterInput>;
  fakturaEmail?: InputMaybe<StringOperationFilterInput>;
  ean?: InputMaybe<StringOperationFilterInput>;
  fakturaReference?: InputMaybe<StringOperationFilterInput>;
  virksomhedsformNavigation?: InputMaybe<VirksomhedsformKodeFilterInput>;
  fakturaAfsendelseNavigation?: InputMaybe<FakturaAfsendelseKodeFilterInput>;
  retskredsNrNavigation?: InputMaybe<RetskredsFilterInput>;
  selskabstypeNavigation?: InputMaybe<SelskabstypeFilterInput>;
  kommuneNavigation?: InputMaybe<KommuneFilterInput>;
  firmaAbonnement?: InputMaybe<ListFilterInputTypeOfFirmaAbonnementFilterInput>;
  firmaBetalingsadresse?: InputMaybe<ListFilterInputTypeOfFirmaBetalingsadresseFilterInput>;
  firmaejerskabEjendeFirmaNavigation?: InputMaybe<ListFilterInputTypeOfFirmaejerskabFilterInput>;
  firmaejerskabEjetFirma?: InputMaybe<ListFilterInputTypeOfFirmaejerskabFilterInput>;
  firmahistorikNavigation?: InputMaybe<ListFilterInputTypeOfFirmahistorikFilterInput>;
  firmahistorik2Navigation?: InputMaybe<ListFilterInputTypeOfFirmahistorik2FilterInput>;
  firmaKlienterklaering?: InputMaybe<ListFilterInputTypeOfFirmaKlienterklaeringFilterInput>;
  firmaKorrespondance?: InputMaybe<ListFilterInputTypeOfFirmaKorrespondanceFilterInput>;
  firmaSanktion?: InputMaybe<ListFilterInputTypeOfFirmaSanktionFilterInput>;
  firmaTilsyn?: InputMaybe<ListFilterInputTypeOfFirmaTilsynFilterInput>;
  personFirma?: InputMaybe<ListFilterInputTypeOfPersonFirmaFilterInput>;
  maaGrunddataSynkroniseres?: InputMaybe<BooleanOperationFilterInput>;
  harAktivitet?: InputMaybe<BooleanOperationFilterInput>;
  harUdoevende?: InputMaybe<BooleanOperationFilterInput>;
  harPersonrelation?: InputMaybe<BooleanOperationFilterInput>;
  firmatype?: InputMaybe<FirmatypeOperationFilterInput>;
  debitorInfo?: InputMaybe<FirmaDebitorInfoFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonfirmatypeKodeFilterInput = {
  and?: InputMaybe<Array<PersonfirmatypeKodeFilterInput>>;
  or?: InputMaybe<Array<PersonfirmatypeKodeFilterInput>>;
  personFirma?: InputMaybe<ListFilterInputTypeOfPersonFirmaFilterInput>;
  nr?: InputMaybe<PersonfirmatypeIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type BeskikkelsestypeIdOperationFilterInput = {
  eq?: InputMaybe<BeskikkelsestypeId>;
  neq?: InputMaybe<BeskikkelsestypeId>;
  in?: InputMaybe<Array<BeskikkelsestypeId>>;
  nin?: InputMaybe<Array<BeskikkelsestypeId>>;
};

export type BeskikkelsestypeKodeFilterInput = {
  and?: InputMaybe<Array<BeskikkelsestypeKodeFilterInput>>;
  or?: InputMaybe<Array<BeskikkelsestypeKodeFilterInput>>;
  personBeskikkelse?: InputMaybe<ListFilterInputTypeOfPersonBeskikkelseFilterInput>;
  nr?: InputMaybe<BeskikkelsestypeIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type ListFilterInputTypeOfIDomainEventFilterInput = {
  all?: InputMaybe<IDomainEventFilterInput>;
  none?: InputMaybe<IDomainEventFilterInput>;
  some?: InputMaybe<IDomainEventFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type FalreferencedataSortInput = {
  referenceDataVaerdiId?: InputMaybe<SortEnumType>;
  referenceDatatypeIndex?: InputMaybe<SortEnumType>;
  referenceDatatypeGruppeNavn?: InputMaybe<SortEnumType>;
  referenceDataVaerdi?: InputMaybe<SortEnumType>;
  aktiv?: InputMaybe<SortEnumType>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type FirmaSortInput = {
  firmaNr?: InputMaybe<SortEnumType>;
  cvrNr?: InputMaybe<SortEnumType>;
  pnr?: InputMaybe<SortEnumType>;
  pnrSubNr?: InputMaybe<SortEnumType>;
  pnrOphoertCvr?: InputMaybe<SortEnumType>;
  pnrStatusCvr?: InputMaybe<SortEnumType>;
  cvrNrStatusCvr?: InputMaybe<SortEnumType>;
  udenlandskVirksomhedsId?: InputMaybe<SortEnumType>;
  advokatVirksomhed?: InputMaybe<SortEnumType>;
  periode?: InputMaybe<DatoIntervalSortInput>;
  navn1?: InputMaybe<SortEnumType>;
  navn2?: InputMaybe<SortEnumType>;
  navn3?: InputMaybe<SortEnumType>;
  beliggenhedsadresse?: InputMaybe<AdresseSortInput>;
  kommuneNr?: InputMaybe<SortEnumType>;
  retskredsNr?: InputMaybe<SortEnumType>;
  tlf?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  webAdresse?: InputMaybe<SortEnumType>;
  selskabstype?: InputMaybe<SortEnumType>;
  emailSikker?: InputMaybe<SortEnumType>;
  virksomhedsform?: InputMaybe<SortEnumType>;
  bemaerkninger?: InputMaybe<SortEnumType>;
  fakturaAfsendelse?: InputMaybe<SortEnumType>;
  fakturaEmail?: InputMaybe<SortEnumType>;
  ean?: InputMaybe<SortEnumType>;
  fakturaReference?: InputMaybe<SortEnumType>;
  virksomhedsformNavigation?: InputMaybe<VirksomhedsformKodeSortInput>;
  fakturaAfsendelseNavigation?: InputMaybe<FakturaAfsendelseKodeSortInput>;
  retskredsNrNavigation?: InputMaybe<RetskredsSortInput>;
  selskabstypeNavigation?: InputMaybe<SelskabstypeSortInput>;
  kommuneNavigation?: InputMaybe<KommuneSortInput>;
  maaGrunddataSynkroniseres?: InputMaybe<SortEnumType>;
  harAktivitet?: InputMaybe<SortEnumType>;
  harUdoevende?: InputMaybe<SortEnumType>;
  harPersonrelation?: InputMaybe<SortEnumType>;
  firmatype?: InputMaybe<SortEnumType>;
  debitorInfo?: InputMaybe<FirmaDebitorInfoSortInput>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type PersonfirmatypeKodeSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type BeskikkelsestypeKodeSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type FirmaAbonnementFilterInput = {
  and?: InputMaybe<Array<FirmaAbonnementFilterInput>>;
  or?: InputMaybe<Array<FirmaAbonnementFilterInput>>;
  abonnementNr?: InputMaybe<IntOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  faktureres?: InputMaybe<BooleanOperationFilterInput>;
  antalEksemplar?: InputMaybe<IntOperationFilterInput>;
  sidsteOpkraevningsaar?: InputMaybe<IntOperationFilterInput>;
  erpFakturaRegnskabsId?: InputMaybe<StringOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  abonnementNrNavigation?: InputMaybe<AbonnementFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FirmaBetalingsadresseFilterInput = {
  and?: InputMaybe<Array<FirmaBetalingsadresseFilterInput>>;
  or?: InputMaybe<Array<FirmaBetalingsadresseFilterInput>>;
  email?: InputMaybe<StringOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  adresse?: InputMaybe<AdresseFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  attention?: InputMaybe<StringOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  reference?: InputMaybe<StringOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FirmaejerskabFilterInput = {
  and?: InputMaybe<Array<FirmaejerskabFilterInput>>;
  or?: InputMaybe<Array<FirmaejerskabFilterInput>>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  ejetFirmaId?: InputMaybe<UuidOperationFilterInput>;
  ejendeFirmaId?: InputMaybe<UuidOperationFilterInput>;
  ejendeFirmaNavigation?: InputMaybe<FirmaFilterInput>;
  ejetFirma?: InputMaybe<FirmaFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FirmahistorikFilterInput = {
  and?: InputMaybe<Array<FirmahistorikFilterInput>>;
  or?: InputMaybe<Array<FirmahistorikFilterInput>>;
  navn1?: InputMaybe<StringOperationFilterInput>;
  navn2?: InputMaybe<StringOperationFilterInput>;
  navn3?: InputMaybe<StringOperationFilterInput>;
  adr1?: InputMaybe<StringOperationFilterInput>;
  adr2?: InputMaybe<StringOperationFilterInput>;
  adr3?: InputMaybe<StringOperationFilterInput>;
  adr4?: InputMaybe<StringOperationFilterInput>;
  husNr?: InputMaybe<IntOperationFilterInput>;
  husNrBogstav?: InputMaybe<StringOperationFilterInput>;
  etageNr?: InputMaybe<StringOperationFilterInput>;
  side?: InputMaybe<StringOperationFilterInput>;
  postNr?: InputMaybe<StringOperationFilterInput>;
  landeKode?: InputMaybe<StringOperationFilterInput>;
  tlf?: InputMaybe<StringOperationFilterInput>;
  tlfFaxNr?: InputMaybe<StringOperationFilterInput>;
  emailArbejde?: InputMaybe<StringOperationFilterInput>;
  webAdresse?: InputMaybe<StringOperationFilterInput>;
  firmatype?: InputMaybe<StringOperationFilterInput>;
  aktiv?: InputMaybe<BooleanOperationFilterInput>;
  cvrNr?: InputMaybe<LongOperationFilterInput>;
  pnr?: InputMaybe<LongOperationFilterInput>;
  indskudskapital?: InputMaybe<FloatOperationFilterInput>;
  firmaStartDato?: InputMaybe<DateTimeOperationFilterInput>;
  adrCo?: InputMaybe<StringOperationFilterInput>;
  postboks?: InputMaybe<IntOperationFilterInput>;
  regionNavn?: InputMaybe<StringOperationFilterInput>;
  kommuneNavn?: InputMaybe<StringOperationFilterInput>;
  kredsNavn?: InputMaybe<StringOperationFilterInput>;
  advokatnoeglen?: InputMaybe<BooleanOperationFilterInput>;
  afsendelsesformStd?: InputMaybe<StringOperationFilterInput>;
  faktureringAs?: InputMaybe<BooleanOperationFilterInput>;
  erOvertaget?: InputMaybe<BooleanOperationFilterInput>;
  emailSikkerArbejde?: InputMaybe<StringOperationFilterInput>;
  erpKundegruppe?: InputMaybe<StringOperationFilterInput>;
  erpBetalingsbetingelseKode?: InputMaybe<StringOperationFilterInput>;
  erpMomskode?: InputMaybe<StringOperationFilterInput>;
  ejerskab?: InputMaybe<IntOperationFilterInput>;
  retskreds?: InputMaybe<IntOperationFilterInput>;
  land?: InputMaybe<StringOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type Firmahistorik2FilterInput = {
  and?: InputMaybe<Array<Firmahistorik2FilterInput>>;
  or?: InputMaybe<Array<Firmahistorik2FilterInput>>;
  id?: InputMaybe<UuidOperationFilterInput>;
  snapshotTid?: InputMaybe<DateTimeOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firmaNr?: InputMaybe<LongOperationFilterInput>;
  navn1?: InputMaybe<StringOperationFilterInput>;
  navn2?: InputMaybe<StringOperationFilterInput>;
  advokatvirksomhed?: InputMaybe<BooleanOperationFilterInput>;
  harAktivitet?: InputMaybe<BooleanOperationFilterInput>;
  cvrNr?: InputMaybe<LongOperationFilterInput>;
  pnr?: InputMaybe<LongOperationFilterInput>;
  virksomhedsform?: InputMaybe<StringOperationFilterInput>;
  selskabstype?: InputMaybe<StringOperationFilterInput>;
  tlf?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailSikker?: InputMaybe<StringOperationFilterInput>;
  webAdresse?: InputMaybe<StringOperationFilterInput>;
  periodeFraDato?: InputMaybe<DateOperationFilterInput>;
  periodeTilDato?: InputMaybe<DateOperationFilterInput>;
  adresseCoNavn?: InputMaybe<StringOperationFilterInput>;
  adresseAdresselinie1?: InputMaybe<StringOperationFilterInput>;
  adresseAdresselinie2?: InputMaybe<StringOperationFilterInput>;
  adressePostnummer?: InputMaybe<StringOperationFilterInput>;
  adresseBynavn?: InputMaybe<StringOperationFilterInput>;
  adresseAdresselinie4?: InputMaybe<StringOperationFilterInput>;
  adresseLandekode?: InputMaybe<StringOperationFilterInput>;
  kommune?: InputMaybe<StringOperationFilterInput>;
  region?: InputMaybe<StringOperationFilterInput>;
  advokatkreds?: InputMaybe<StringOperationFilterInput>;
  retskreds?: InputMaybe<StringOperationFilterInput>;
};

export type FirmaKlienterklaeringFilterInput = {
  and?: InputMaybe<Array<FirmaKlienterklaeringFilterInput>>;
  or?: InputMaybe<Array<FirmaKlienterklaeringFilterInput>>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  erklAar?: InputMaybe<IntOperationFilterInput>;
  erklNr?: InputMaybe<IntOperationFilterInput>;
  klienterklaeringstype?: InputMaybe<KlienterklaeringstypeIdOperationFilterInput>;
  erklModtaget?: InputMaybe<DateOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  frist?: InputMaybe<DateOperationFilterInput>;
  koerselDato?: InputMaybe<DateOperationFilterInput>;
  klienterklaeringStatus?: InputMaybe<KlienterklaeringStatusIdOperationFilterInput>;
  erklDocument?: InputMaybe<ListByteOperationFilterInput>;
  indberetningsData?: InputMaybe<StringOperationFilterInput>;
  erklNrWeb?: InputMaybe<IntOperationFilterInput>;
  indberettetformular?: InputMaybe<NullableOfKlienterklaeringIndberettetformularOperationFilterInput>;
  firmaCvrNr?: InputMaybe<LongOperationFilterInput>;
  klienterklaeringStatusNavigation?: InputMaybe<KlienterklaeringStatusKodeFilterInput>;
  klienterklaeringstypeNavigation?: InputMaybe<KlienterklaeringstypeKodeFilterInput>;
  klienterklaeringIndberettetformularNavigation?: InputMaybe<KlienterklaeringIndberettetformularKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FirmaKorrespondanceFilterInput = {
  and?: InputMaybe<Array<FirmaKorrespondanceFilterInput>>;
  or?: InputMaybe<Array<FirmaKorrespondanceFilterInput>>;
  dokumentNr?: InputMaybe<IntOperationFilterInput>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  filnavn?: InputMaybe<StringOperationFilterInput>;
  dokument?: InputMaybe<ListByteOperationFilterInput>;
  originatorRid?: InputMaybe<UuidOperationFilterInput>;
  originatorTableName?: InputMaybe<StringOperationFilterInput>;
  searchRid?: InputMaybe<UuidOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FirmaSanktionFilterInput = {
  and?: InputMaybe<Array<FirmaSanktionFilterInput>>;
  or?: InputMaybe<Array<FirmaSanktionFilterInput>>;
  sagsNr?: InputMaybe<StringOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  sagsLink?: InputMaybe<StringOperationFilterInput>;
  afgoerelseskoder?: InputMaybe<StringOperationFilterInput>;
  indbragtretten?: InputMaybe<BooleanOperationFilterInput>;
  naevnskendelseSanktionstypeNr?: InputMaybe<IntOperationFilterInput>;
  naevnskendelseDato?: InputMaybe<DateOperationFilterInput>;
  naevnskendelseBoedebeloeb?: InputMaybe<IntOperationFilterInput>;
  retskendelseSanktionstypeNr?: InputMaybe<IntOperationFilterInput>;
  retskendelseDato?: InputMaybe<DateOperationFilterInput>;
  retskendelseBoedebeloeb?: InputMaybe<IntOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  naevnskendelseSanktionstypeNrNavigation?: InputMaybe<SanktionstypeFilterInput>;
  retskendelseSanktionstypeNrNavigation?: InputMaybe<SanktionstypeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type FirmaTilsynFilterInput = {
  and?: InputMaybe<Array<FirmaTilsynFilterInput>>;
  or?: InputMaybe<Array<FirmaTilsynFilterInput>>;
  firmaTilsynstype?: InputMaybe<FirmaTilsynstypeIdOperationFilterInput>;
  gennemfoerselDato?: InputMaybe<DateOperationFilterInput>;
  sagsNr?: InputMaybe<StringOperationFilterInput>;
  bemaerkning?: InputMaybe<StringOperationFilterInput>;
  firmaId?: InputMaybe<UuidOperationFilterInput>;
  firma?: InputMaybe<FirmaFilterInput>;
  firmaTilsynstypeNavigation?: InputMaybe<FirmaTilsynstypeKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type LandFilterInput = {
  and?: InputMaybe<Array<LandFilterInput>>;
  or?: InputMaybe<Array<LandFilterInput>>;
  landekode?: InputMaybe<StringOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  falId?: InputMaybe<StringOperationFilterInput>;
  falReferenceDatatypeIndex?: InputMaybe<IntOperationFilterInput>;
  fal?: InputMaybe<FalreferencedataFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type VirksomhedsformIdOperationFilterInput = {
  eq?: InputMaybe<VirksomhedsformId>;
  neq?: InputMaybe<VirksomhedsformId>;
  in?: InputMaybe<Array<VirksomhedsformId>>;
  nin?: InputMaybe<Array<VirksomhedsformId>>;
};

export type ListFilterInputTypeOfFirmaFilterInput = {
  all?: InputMaybe<FirmaFilterInput>;
  none?: InputMaybe<FirmaFilterInput>;
  some?: InputMaybe<FirmaFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AdvokatkredsFilterInput = {
  and?: InputMaybe<Array<AdvokatkredsFilterInput>>;
  or?: InputMaybe<Array<AdvokatkredsFilterInput>>;
  retskreds?: InputMaybe<ListFilterInputTypeOfRetskredsFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type RegionFilterInput = {
  and?: InputMaybe<Array<RegionFilterInput>>;
  or?: InputMaybe<Array<RegionFilterInput>>;
  kommune?: InputMaybe<ListFilterInputTypeOfKommuneFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type LandSortInput = {
  landekode?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
  falId?: InputMaybe<SortEnumType>;
  falReferenceDatatypeIndex?: InputMaybe<SortEnumType>;
  fal?: InputMaybe<FalreferencedataSortInput>;
  opretDato?: InputMaybe<SortEnumType>;
  opretInit?: InputMaybe<SortEnumType>;
  retteDato?: InputMaybe<SortEnumType>;
  retteInit?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type AdvokatkredsSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type RegionSortInput = {
  nr?: InputMaybe<SortEnumType>;
  navn?: InputMaybe<SortEnumType>;
};

export type KursusholdKorrespondanceFilterInput = {
  and?: InputMaybe<Array<KursusholdKorrespondanceFilterInput>>;
  or?: InputMaybe<Array<KursusholdKorrespondanceFilterInput>>;
  dokument?: InputMaybe<ListByteOperationFilterInput>;
  sendt?: InputMaybe<DateTimeOperationFilterInput>;
  emne?: InputMaybe<StringOperationFilterInput>;
  antalModtagere?: InputMaybe<IntOperationFilterInput>;
  kursusholdId?: InputMaybe<UuidOperationFilterInput>;
  kursushold?: InputMaybe<KursusholdFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type KursusholdFilterInput = {
  and?: InputMaybe<Array<KursusholdFilterInput>>;
  or?: InputMaybe<Array<KursusholdFilterInput>>;
  holdNr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  kursustype?: InputMaybe<IntOperationFilterInput>;
  varighed?: InputMaybe<StringOperationFilterInput>;
  hotelId?: InputMaybe<UuidOperationFilterInput>;
  fraDato?: InputMaybe<DateOperationFilterInput>;
  fraKlDag?: InputMaybe<TimeSpanOperationFilterInput>;
  tilDato?: InputMaybe<DateOperationFilterInput>;
  tilKlDag?: InputMaybe<TimeSpanOperationFilterInput>;
  bemaerkninger?: InputMaybe<StringOperationFilterInput>;
  pris?: InputMaybe<DecimalOperationFilterInput>;
  kodeKursusmappe?: InputMaybe<StringOperationFilterInput>;
  fmulinjeId?: InputMaybe<UuidOperationFilterInput>;
  fmukursusKategoriNr?: InputMaybe<IntOperationFilterInput>;
  hotelNavigation?: InputMaybe<HotelFilterInput>;
  kursustypeNavigation?: InputMaybe<KursustypeFilterInput>;
  fmukursusKategoriNavigation?: InputMaybe<FmukursusKategoriFilterInput>;
  fmulinje?: InputMaybe<FmulinjeFilterInput>;
  kursusholdUnderviser?: InputMaybe<ListFilterInputTypeOfKursusholdUnderviserFilterInput>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  kursusKorrespondance?: InputMaybe<ListFilterInputTypeOfKursusholdKorrespondanceFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type NullableOfDeltagerStatusIdOperationFilterInput = {
  eq?: InputMaybe<DeltagerStatusId>;
  neq?: InputMaybe<DeltagerStatusId>;
  in?: InputMaybe<Array<InputMaybe<DeltagerStatusId>>>;
  nin?: InputMaybe<Array<InputMaybe<DeltagerStatusId>>>;
};

export type NullableOfOvernatningstypeIdOperationFilterInput = {
  eq?: InputMaybe<OvernatningstypeId>;
  neq?: InputMaybe<OvernatningstypeId>;
  in?: InputMaybe<Array<InputMaybe<OvernatningstypeId>>>;
  nin?: InputMaybe<Array<InputMaybe<OvernatningstypeId>>>;
};

export type OvernatningstypeKodeFilterInput = {
  and?: InputMaybe<Array<OvernatningstypeKodeFilterInput>>;
  or?: InputMaybe<Array<OvernatningstypeKodeFilterInput>>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  fmulinjeKursist?: InputMaybe<ListFilterInputTypeOfFmulinjeKursistFilterInput>;
  nr?: InputMaybe<OvernatningstypeIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type DeltagerStatusKodeFilterInput = {
  and?: InputMaybe<Array<DeltagerStatusKodeFilterInput>>;
  or?: InputMaybe<Array<DeltagerStatusKodeFilterInput>>;
  fmulinjeKursist?: InputMaybe<ListFilterInputTypeOfFmulinjeKursistFilterInput>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  nr?: InputMaybe<DeltagerStatusIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type FmuretssagsproeveResultatIdOperationFilterInput = {
  eq?: InputMaybe<FmuretssagsproeveResultatId>;
  neq?: InputMaybe<FmuretssagsproeveResultatId>;
  in?: InputMaybe<Array<FmuretssagsproeveResultatId>>;
  nin?: InputMaybe<Array<FmuretssagsproeveResultatId>>;
};

export type FakturaStatusIdOperationFilterInput = {
  eq?: InputMaybe<FakturaStatusId>;
  neq?: InputMaybe<FakturaStatusId>;
  in?: InputMaybe<Array<FakturaStatusId>>;
  nin?: InputMaybe<Array<FakturaStatusId>>;
};

export type FmuretssagsproeveResultatKodeFilterInput = {
  and?: InputMaybe<Array<FmuretssagsproeveResultatKodeFilterInput>>;
  or?: InputMaybe<Array<FmuretssagsproeveResultatKodeFilterInput>>;
  fmuretssagsproeve?: InputMaybe<ListFilterInputTypeOfFmuretssagsproeveFilterInput>;
  nr?: InputMaybe<FmuretssagsproeveResultatIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type FakturaStatusKodeFilterInput = {
  and?: InputMaybe<Array<FakturaStatusKodeFilterInput>>;
  or?: InputMaybe<Array<FakturaStatusKodeFilterInput>>;
  fmuretssagsproeve?: InputMaybe<ListFilterInputTypeOfFmuretssagsproeveFilterInput>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  nr?: InputMaybe<FakturaStatusIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type ForeningFilterInput = {
  and?: InputMaybe<Array<ForeningFilterInput>>;
  or?: InputMaybe<Array<ForeningFilterInput>>;
  navn?: InputMaybe<StringOperationFilterInput>;
  forkortelse?: InputMaybe<StringOperationFilterInput>;
  adr1?: InputMaybe<StringOperationFilterInput>;
  adr2?: InputMaybe<StringOperationFilterInput>;
  postNr?: InputMaybe<StringOperationFilterInput>;
  land?: InputMaybe<StringOperationFilterInput>;
  tlfNr?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  indmeldAuto?: InputMaybe<BooleanOperationFilterInput>;
  udmeldAuto?: InputMaybe<ForeningAutoudmeldelseIdOperationFilterInput>;
  advokatAttention?: InputMaybe<BooleanOperationFilterInput>;
  medlemstype?: InputMaybe<IntOperationFilterInput>;
  firmaopkraevning?: InputMaybe<BooleanOperationFilterInput>;
  regnskabStart?: InputMaybe<StringOperationFilterInput>;
  regnskabSlut?: InputMaybe<StringOperationFilterInput>;
  adrCo?: InputMaybe<StringOperationFilterInput>;
  personForening?: InputMaybe<ListFilterInputTypeOfPersonForeningFilterInput>;
  udmeldAutoNavigation?: InputMaybe<ForeningAutoudmeldelseKodeFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type AbonnementFilterInput = {
  and?: InputMaybe<Array<AbonnementFilterInput>>;
  or?: InputMaybe<Array<AbonnementFilterInput>>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  personAbonnement?: InputMaybe<ListFilterInputTypeOfPersonAbonnementFilterInput>;
  firmaAbonnement?: InputMaybe<ListFilterInputTypeOfFirmaAbonnementFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonartKodeFilterInput = {
  and?: InputMaybe<Array<PersonartKodeFilterInput>>;
  or?: InputMaybe<Array<PersonartKodeFilterInput>>;
  personArter?: InputMaybe<ListFilterInputTypeOfPersonPersonartFilterInput>;
  nr?: InputMaybe<PersonartIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type BidragsmodtagerIdOperationFilterInput = {
  eq?: InputMaybe<BidragsmodtagerId>;
  neq?: InputMaybe<BidragsmodtagerId>;
  in?: InputMaybe<Array<BidragsmodtagerId>>;
  nin?: InputMaybe<Array<BidragsmodtagerId>>;
};

export type BidragsmodtagerKodeFilterInput = {
  and?: InputMaybe<Array<BidragsmodtagerKodeFilterInput>>;
  or?: InputMaybe<Array<BidragsmodtagerKodeFilterInput>>;
  personBidragsopkraevning?: InputMaybe<ListFilterInputTypeOfPersonBidragsopkraevningFilterInput>;
  nr?: InputMaybe<BidragsmodtagerIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type DisciplinaerstatustypeFilterInput = {
  and?: InputMaybe<Array<DisciplinaerstatustypeFilterInput>>;
  or?: InputMaybe<Array<DisciplinaerstatustypeFilterInput>>;
  personDisciplinaerstatus?: InputMaybe<ListFilterInputTypeOfPersonDisciplinaerstatusFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars["Float"]["input"]>;
  neq?: InputMaybe<Scalars["Float"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>;
  gt?: InputMaybe<Scalars["Float"]["input"]>;
  ngt?: InputMaybe<Scalars["Float"]["input"]>;
  gte?: InputMaybe<Scalars["Float"]["input"]>;
  ngte?: InputMaybe<Scalars["Float"]["input"]>;
  lt?: InputMaybe<Scalars["Float"]["input"]>;
  nlt?: InputMaybe<Scalars["Float"]["input"]>;
  lte?: InputMaybe<Scalars["Float"]["input"]>;
  nlte?: InputMaybe<Scalars["Float"]["input"]>;
};

export type ListFilterInputTypeOfPersonEfteruddannelseIndberetningFilterInput =
  {
    all?: InputMaybe<PersonEfteruddannelseIndberetningFilterInput>;
    none?: InputMaybe<PersonEfteruddannelseIndberetningFilterInput>;
    some?: InputMaybe<PersonEfteruddannelseIndberetningFilterInput>;
    any?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type ListFilterInputTypeOfPersonPaabudIndberetningFilterInput = {
  all?: InputMaybe<PersonPaabudIndberetningFilterInput>;
  none?: InputMaybe<PersonPaabudIndberetningFilterInput>;
  some?: InputMaybe<PersonPaabudIndberetningFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfPersonPaalaegIndberetningFilterInput = {
  all?: InputMaybe<PersonPaalaegIndberetningFilterInput>;
  none?: InputMaybe<PersonPaalaegIndberetningFilterInput>;
  some?: InputMaybe<PersonPaalaegIndberetningFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ForsikringsselskabFilterInput = {
  and?: InputMaybe<Array<ForsikringsselskabFilterInput>>;
  or?: InputMaybe<Array<ForsikringsselskabFilterInput>>;
  forsikringsselskabNr?: InputMaybe<IntOperationFilterInput>;
  godkendt?: InputMaybe<BooleanOperationFilterInput>;
  cvrNr?: InputMaybe<LongOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  navn1?: InputMaybe<StringOperationFilterInput>;
  navn2?: InputMaybe<StringOperationFilterInput>;
  adresse?: InputMaybe<AdresseFilterInput>;
  tlfNr?: InputMaybe<StringOperationFilterInput>;
  faxNr?: InputMaybe<StringOperationFilterInput>;
  attPerson?: InputMaybe<StringOperationFilterInput>;
  notat?: InputMaybe<StringOperationFilterInput>;
  eMail?: InputMaybe<StringOperationFilterInput>;
  webAdresse?: InputMaybe<StringOperationFilterInput>;
  personForsikring?: InputMaybe<ListFilterInputTypeOfPersonForsikringFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type InteresseFilterInput = {
  and?: InputMaybe<Array<InteresseFilterInput>>;
  or?: InputMaybe<Array<InteresseFilterInput>>;
  forkortelse?: InputMaybe<StringOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  navnEngelsk?: InputMaybe<StringOperationFilterInput>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  falId?: InputMaybe<StringOperationFilterInput>;
  falReferenceDatatypeIndex?: InputMaybe<IntOperationFilterInput>;
  fal?: InputMaybe<FalreferencedataFilterInput>;
  interesseGroup?: InputMaybe<ListFilterInputTypeOfInteresseGroupFilterInput>;
  personInteresse?: InputMaybe<ListFilterInputTypeOfPersonInteresseFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type KlienterklaeringstypeIdOperationFilterInput = {
  eq?: InputMaybe<KlienterklaeringstypeId>;
  neq?: InputMaybe<KlienterklaeringstypeId>;
  in?: InputMaybe<Array<KlienterklaeringstypeId>>;
  nin?: InputMaybe<Array<KlienterklaeringstypeId>>;
};

export type KlienterklaeringStatusIdOperationFilterInput = {
  eq?: InputMaybe<KlienterklaeringStatusId>;
  neq?: InputMaybe<KlienterklaeringStatusId>;
  in?: InputMaybe<Array<KlienterklaeringStatusId>>;
  nin?: InputMaybe<Array<KlienterklaeringStatusId>>;
};

export type ListByteOperationFilterInput = {
  all?: InputMaybe<ByteOperationFilterInput>;
  none?: InputMaybe<ByteOperationFilterInput>;
  some?: InputMaybe<ByteOperationFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NullableOfKlienterklaeringIndberettetformularOperationFilterInput =
  {
    eq?: InputMaybe<KlienterklaeringIndberettetformular>;
    neq?: InputMaybe<KlienterklaeringIndberettetformular>;
    in?: InputMaybe<Array<InputMaybe<KlienterklaeringIndberettetformular>>>;
    nin?: InputMaybe<Array<InputMaybe<KlienterklaeringIndberettetformular>>>;
  };

export type KlienterklaeringStatusKodeFilterInput = {
  and?: InputMaybe<Array<KlienterklaeringStatusKodeFilterInput>>;
  or?: InputMaybe<Array<KlienterklaeringStatusKodeFilterInput>>;
  personKlienterklaering?: InputMaybe<ListFilterInputTypeOfPersonKlienterklaeringFilterInput>;
  firmaKlienterklaering?: InputMaybe<ListFilterInputTypeOfFirmaKlienterklaeringFilterInput>;
  nr?: InputMaybe<KlienterklaeringStatusIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type KlienterklaeringstypeKodeFilterInput = {
  and?: InputMaybe<Array<KlienterklaeringstypeKodeFilterInput>>;
  or?: InputMaybe<Array<KlienterklaeringstypeKodeFilterInput>>;
  personKlienterklaering?: InputMaybe<ListFilterInputTypeOfPersonKlienterklaeringFilterInput>;
  firmaKlienterklaering?: InputMaybe<ListFilterInputTypeOfFirmaKlienterklaeringFilterInput>;
  nr?: InputMaybe<KlienterklaeringstypeIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type KlienterklaeringIndberettetformularKodeFilterInput = {
  and?: InputMaybe<Array<KlienterklaeringIndberettetformularKodeFilterInput>>;
  or?: InputMaybe<Array<KlienterklaeringIndberettetformularKodeFilterInput>>;
  personKlienterklaering?: InputMaybe<ListFilterInputTypeOfPersonKlienterklaeringFilterInput>;
  firmaKlienterklaering?: InputMaybe<ListFilterInputTypeOfFirmaKlienterklaeringFilterInput>;
  nr?: InputMaybe<KlienterklaeringIndberettetformularOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type NullableOfBestaaetStatusIdOperationFilterInput = {
  eq?: InputMaybe<BestaaetStatusId>;
  neq?: InputMaybe<BestaaetStatusId>;
  in?: InputMaybe<Array<InputMaybe<BestaaetStatusId>>>;
  nin?: InputMaybe<Array<InputMaybe<BestaaetStatusId>>>;
};

export type BestaaetStatusKodeFilterInput = {
  and?: InputMaybe<Array<BestaaetStatusKodeFilterInput>>;
  or?: InputMaybe<Array<BestaaetStatusKodeFilterInput>>;
  kursusPerson?: InputMaybe<ListFilterInputTypeOfKursusPersonFilterInput>;
  nr?: InputMaybe<BestaaetStatusIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type ListFilterInputTypeOfKursusPersonKursusGruppeFilterInput = {
  all?: InputMaybe<KursusPersonKursusGruppeFilterInput>;
  none?: InputMaybe<KursusPersonKursusGruppeFilterInput>;
  some?: InputMaybe<KursusPersonKursusGruppeFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SanktionstypeFilterInput = {
  and?: InputMaybe<Array<SanktionstypeFilterInput>>;
  or?: InputMaybe<Array<SanktionstypeFilterInput>>;
  udvidetLevetid?: InputMaybe<BooleanOperationFilterInput>;
  firmaSanktionKendelseNaevn?: InputMaybe<ListFilterInputTypeOfFirmaSanktionFilterInput>;
  firmaSanktionKendelseRetten?: InputMaybe<ListFilterInputTypeOfFirmaSanktionFilterInput>;
  personSanktionKendelseNaevn?: InputMaybe<ListFilterInputTypeOfPersonSanktionFilterInput>;
  personSanktionKendelseRetten?: InputMaybe<ListFilterInputTypeOfPersonSanktionFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type PersonTilsynstypeIdOperationFilterInput = {
  eq?: InputMaybe<PersonTilsynstypeId>;
  neq?: InputMaybe<PersonTilsynstypeId>;
  in?: InputMaybe<Array<PersonTilsynstypeId>>;
  nin?: InputMaybe<Array<PersonTilsynstypeId>>;
};

export type PersonPaabudStatusIdOperationFilterInput = {
  eq?: InputMaybe<PersonPaabudStatusId>;
  neq?: InputMaybe<PersonPaabudStatusId>;
  in?: InputMaybe<Array<PersonPaabudStatusId>>;
  nin?: InputMaybe<Array<PersonPaabudStatusId>>;
};

export type PersonPaalaegStatusIdOperationFilterInput = {
  eq?: InputMaybe<PersonPaalaegStatusId>;
  neq?: InputMaybe<PersonPaalaegStatusId>;
  in?: InputMaybe<Array<PersonPaalaegStatusId>>;
  nin?: InputMaybe<Array<PersonPaalaegStatusId>>;
};

export type PersonTilsynstypeKodeFilterInput = {
  and?: InputMaybe<Array<PersonTilsynstypeKodeFilterInput>>;
  or?: InputMaybe<Array<PersonTilsynstypeKodeFilterInput>>;
  personTilsyn?: InputMaybe<ListFilterInputTypeOfPersonTilsynFilterInput>;
  nr?: InputMaybe<PersonTilsynstypeIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type TilsynserklaeringStatusIdOperationFilterInput = {
  eq?: InputMaybe<TilsynserklaeringStatusId>;
  neq?: InputMaybe<TilsynserklaeringStatusId>;
  in?: InputMaybe<Array<TilsynserklaeringStatusId>>;
  nin?: InputMaybe<Array<TilsynserklaeringStatusId>>;
};

export type TilsynserklaeringStatusKodeFilterInput = {
  and?: InputMaybe<Array<TilsynserklaeringStatusKodeFilterInput>>;
  or?: InputMaybe<Array<TilsynserklaeringStatusKodeFilterInput>>;
  personTilsynserklaering?: InputMaybe<ListFilterInputTypeOfPersonTilsynserklaeringFilterInput>;
  nr?: InputMaybe<TilsynserklaeringStatusIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type PersontypeFilterInput = {
  and?: InputMaybe<Array<PersontypeFilterInput>>;
  or?: InputMaybe<Array<PersontypeFilterInput>>;
  personPersontype?: InputMaybe<ListFilterInputTypeOfPersonPersontypeFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type TillidshvervIdOperationFilterInput = {
  eq?: InputMaybe<TillidshvervId>;
  neq?: InputMaybe<TillidshvervId>;
  in?: InputMaybe<Array<TillidshvervId>>;
  nin?: InputMaybe<Array<TillidshvervId>>;
};

export type TillidshvervKodeFilterInput = {
  and?: InputMaybe<Array<TillidshvervKodeFilterInput>>;
  or?: InputMaybe<Array<TillidshvervKodeFilterInput>>;
  personUdvalg?: InputMaybe<ListFilterInputTypeOfPersonUdvalgFilterInput>;
  nr?: InputMaybe<TillidshvervIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type UdvalgFilterInput = {
  and?: InputMaybe<Array<UdvalgFilterInput>>;
  or?: InputMaybe<Array<UdvalgFilterInput>>;
  udvalgNr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  personUdvalg?: InputMaybe<ListFilterInputTypeOfPersonUdvalgFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type UdenlandskadvokatsamfundFilterInput = {
  and?: InputMaybe<Array<UdenlandskadvokatsamfundFilterInput>>;
  or?: InputMaybe<Array<UdenlandskadvokatsamfundFilterInput>>;
  navn?: InputMaybe<StringOperationFilterInput>;
  beskrivelse?: InputMaybe<StringOperationFilterInput>;
  personUdenlandskadvokatsamfund?: InputMaybe<ListFilterInputTypeOfPersonUdenlandskadvokatsamfundFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type ListFilterInputTypeOfInteresseFilterInput = {
  all?: InputMaybe<InteresseFilterInput>;
  none?: InputMaybe<InteresseFilterInput>;
  some?: InputMaybe<InteresseFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfLandFilterInput = {
  all?: InputMaybe<LandFilterInput>;
  none?: InputMaybe<LandFilterInput>;
  some?: InputMaybe<LandFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfTitelFilterInput = {
  all?: InputMaybe<TitelFilterInput>;
  none?: InputMaybe<TitelFilterInput>;
  some?: InputMaybe<TitelFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IDomainEventFilterInput = {
  and?: InputMaybe<Array<IDomainEventFilterInput>>;
  or?: InputMaybe<Array<IDomainEventFilterInput>>;
  raisedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FirmaTilsynstypeIdOperationFilterInput = {
  eq?: InputMaybe<FirmaTilsynstypeId>;
  neq?: InputMaybe<FirmaTilsynstypeId>;
  in?: InputMaybe<Array<FirmaTilsynstypeId>>;
  nin?: InputMaybe<Array<FirmaTilsynstypeId>>;
};

export type FirmaTilsynstypeKodeFilterInput = {
  and?: InputMaybe<Array<FirmaTilsynstypeKodeFilterInput>>;
  or?: InputMaybe<Array<FirmaTilsynstypeKodeFilterInput>>;
  firmaTilsyn?: InputMaybe<ListFilterInputTypeOfFirmaTilsynFilterInput>;
  nr?: InputMaybe<FirmaTilsynstypeIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type ListFilterInputTypeOfRetskredsFilterInput = {
  all?: InputMaybe<RetskredsFilterInput>;
  none?: InputMaybe<RetskredsFilterInput>;
  some?: InputMaybe<RetskredsFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListFilterInputTypeOfKommuneFilterInput = {
  all?: InputMaybe<KommuneFilterInput>;
  none?: InputMaybe<KommuneFilterInput>;
  some?: InputMaybe<KommuneFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OvernatningstypeIdOperationFilterInput = {
  eq?: InputMaybe<OvernatningstypeId>;
  neq?: InputMaybe<OvernatningstypeId>;
  in?: InputMaybe<Array<OvernatningstypeId>>;
  nin?: InputMaybe<Array<OvernatningstypeId>>;
};

export type DeltagerStatusIdOperationFilterInput = {
  eq?: InputMaybe<DeltagerStatusId>;
  neq?: InputMaybe<DeltagerStatusId>;
  in?: InputMaybe<Array<DeltagerStatusId>>;
  nin?: InputMaybe<Array<DeltagerStatusId>>;
};

export type ForeningAutoudmeldelseIdOperationFilterInput = {
  eq?: InputMaybe<ForeningAutoudmeldelseId>;
  neq?: InputMaybe<ForeningAutoudmeldelseId>;
  in?: InputMaybe<Array<ForeningAutoudmeldelseId>>;
  nin?: InputMaybe<Array<ForeningAutoudmeldelseId>>;
};

export type ForeningAutoudmeldelseKodeFilterInput = {
  and?: InputMaybe<Array<ForeningAutoudmeldelseKodeFilterInput>>;
  or?: InputMaybe<Array<ForeningAutoudmeldelseKodeFilterInput>>;
  nr?: InputMaybe<ForeningAutoudmeldelseIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type PersonEfteruddannelseIndberetningFilterInput = {
  and?: InputMaybe<Array<PersonEfteruddannelseIndberetningFilterInput>>;
  or?: InputMaybe<Array<PersonEfteruddannelseIndberetningFilterInput>>;
  personEfteruddannelseId?: InputMaybe<UuidOperationFilterInput>;
  personEfteruddannelseIndberetningLinje?: InputMaybe<ListFilterInputTypeOfPersonEfteruddannelseIndberetningLinjeFilterInput>;
  personEfteruddannelseNavigation?: InputMaybe<PersonEfteruddannelseFilterInput>;
  registreringsDato?: InputMaybe<DateOperationFilterInput>;
  efteruddannelseIndberetningstype?: InputMaybe<EfteruddannelseIndberetningstypeIdOperationFilterInput>;
  efteruddannelseIndberetningstypeNavigation?: InputMaybe<EfteruddannelseIndberetningstypeKodeFilterInput>;
  efteruddannelseIndberetningStatus?: InputMaybe<NullableOfEfteruddannelseIndberetningStatusIdOperationFilterInput>;
  efteruddannelseIndberetningStatusNavigation?: InputMaybe<EfteruddannelseIndberetningStatusKodeFilterInput>;
  indberetningFrist?: InputMaybe<DateOperationFilterInput>;
  signatur?: InputMaybe<ListByteOperationFilterInput>;
  signaturNavn?: InputMaybe<StringOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonPaabudIndberetningFilterInput = {
  and?: InputMaybe<Array<PersonPaabudIndberetningFilterInput>>;
  or?: InputMaybe<Array<PersonPaabudIndberetningFilterInput>>;
  personPaabudId?: InputMaybe<UuidOperationFilterInput>;
  personPaabudNavigation?: InputMaybe<PersonPaabudFilterInput>;
  registreringsDato?: InputMaybe<DateOperationFilterInput>;
  efteruddannelseIndberetningStatus?: InputMaybe<NullableOfEfteruddannelseIndberetningStatusIdOperationFilterInput>;
  efteruddannelseIndberetningStatusNavigation?: InputMaybe<EfteruddannelseIndberetningStatusKodeFilterInput>;
  indberetningFrist?: InputMaybe<DateOperationFilterInput>;
  signatur?: InputMaybe<ListByteOperationFilterInput>;
  signaturNavn?: InputMaybe<StringOperationFilterInput>;
  overfoertTilPersonEfteruddannelseId?: InputMaybe<UuidOperationFilterInput>;
  overfoertTilPersonEfteruddannelseIndberetningId?: InputMaybe<UuidOperationFilterInput>;
  overfoertTilPersonEfteruddannelse?: InputMaybe<PersonEfteruddannelseFilterInput>;
  overfoertTilPersonEfteruddannelseIndberetning?: InputMaybe<PersonEfteruddannelseIndberetningFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type PersonPaalaegIndberetningFilterInput = {
  and?: InputMaybe<Array<PersonPaalaegIndberetningFilterInput>>;
  or?: InputMaybe<Array<PersonPaalaegIndberetningFilterInput>>;
  personPaalaegId?: InputMaybe<UuidOperationFilterInput>;
  personPaalaegNavigation?: InputMaybe<PersonPaalaegFilterInput>;
  registreringsDato?: InputMaybe<DateOperationFilterInput>;
  efteruddannelseIndberetningStatus?: InputMaybe<NullableOfEfteruddannelseIndberetningStatusIdOperationFilterInput>;
  efteruddannelseIndberetningStatusNavigation?: InputMaybe<EfteruddannelseIndberetningStatusKodeFilterInput>;
  indberetningFrist?: InputMaybe<DateOperationFilterInput>;
  signatur?: InputMaybe<ListByteOperationFilterInput>;
  signaturNavn?: InputMaybe<StringOperationFilterInput>;
  overfoertTilPersonEfteruddannelseId?: InputMaybe<UuidOperationFilterInput>;
  overfoertTilPersonEfteruddannelseIndberetningId?: InputMaybe<UuidOperationFilterInput>;
  lektionerOverfoert?: InputMaybe<FloatOperationFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type ListFilterInputTypeOfInteresseGroupFilterInput = {
  all?: InputMaybe<InteresseGroupFilterInput>;
  none?: InputMaybe<InteresseGroupFilterInput>;
  some?: InputMaybe<InteresseGroupFilterInput>;
  any?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars["Byte"]["input"]>;
  neq?: InputMaybe<Scalars["Byte"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["Byte"]["input"]>>>;
  nin?: InputMaybe<Array<InputMaybe<Scalars["Byte"]["input"]>>>;
  gt?: InputMaybe<Scalars["Byte"]["input"]>;
  ngt?: InputMaybe<Scalars["Byte"]["input"]>;
  gte?: InputMaybe<Scalars["Byte"]["input"]>;
  ngte?: InputMaybe<Scalars["Byte"]["input"]>;
  lt?: InputMaybe<Scalars["Byte"]["input"]>;
  nlt?: InputMaybe<Scalars["Byte"]["input"]>;
  lte?: InputMaybe<Scalars["Byte"]["input"]>;
  nlte?: InputMaybe<Scalars["Byte"]["input"]>;
};

export type KlienterklaeringIndberettetformularOperationFilterInput = {
  eq?: InputMaybe<KlienterklaeringIndberettetformular>;
  neq?: InputMaybe<KlienterklaeringIndberettetformular>;
  in?: InputMaybe<Array<KlienterklaeringIndberettetformular>>;
  nin?: InputMaybe<Array<KlienterklaeringIndberettetformular>>;
};

export type BestaaetStatusIdOperationFilterInput = {
  eq?: InputMaybe<BestaaetStatusId>;
  neq?: InputMaybe<BestaaetStatusId>;
  in?: InputMaybe<Array<BestaaetStatusId>>;
  nin?: InputMaybe<Array<BestaaetStatusId>>;
};

export type KursusPersonKursusGruppeFilterInput = {
  and?: InputMaybe<Array<KursusPersonKursusGruppeFilterInput>>;
  or?: InputMaybe<Array<KursusPersonKursusGruppeFilterInput>>;
  kursusGruppeNr?: InputMaybe<IntOperationFilterInput>;
  kursusPersonId?: InputMaybe<UuidOperationFilterInput>;
  kursusGruppeNrNavigation?: InputMaybe<KursusGruppeFilterInput>;
  kursusPerson?: InputMaybe<KursusPersonFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type ListFilterInputTypeOfPersonEfteruddannelseIndberetningLinjeFilterInput =
  {
    all?: InputMaybe<PersonEfteruddannelseIndberetningLinjeFilterInput>;
    none?: InputMaybe<PersonEfteruddannelseIndberetningLinjeFilterInput>;
    some?: InputMaybe<PersonEfteruddannelseIndberetningLinjeFilterInput>;
    any?: InputMaybe<Scalars["Boolean"]["input"]>;
  };

export type EfteruddannelseIndberetningstypeIdOperationFilterInput = {
  eq?: InputMaybe<EfteruddannelseIndberetningstypeId>;
  neq?: InputMaybe<EfteruddannelseIndberetningstypeId>;
  in?: InputMaybe<Array<EfteruddannelseIndberetningstypeId>>;
  nin?: InputMaybe<Array<EfteruddannelseIndberetningstypeId>>;
};

export type EfteruddannelseIndberetningstypeKodeFilterInput = {
  and?: InputMaybe<Array<EfteruddannelseIndberetningstypeKodeFilterInput>>;
  or?: InputMaybe<Array<EfteruddannelseIndberetningstypeKodeFilterInput>>;
  personEfteruddannelseIndberetning?: InputMaybe<ListFilterInputTypeOfPersonEfteruddannelseIndberetningFilterInput>;
  nr?: InputMaybe<EfteruddannelseIndberetningstypeIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type NullableOfEfteruddannelseIndberetningStatusIdOperationFilterInput =
  {
    eq?: InputMaybe<EfteruddannelseIndberetningStatusId>;
    neq?: InputMaybe<EfteruddannelseIndberetningStatusId>;
    in?: InputMaybe<Array<InputMaybe<EfteruddannelseIndberetningStatusId>>>;
    nin?: InputMaybe<Array<InputMaybe<EfteruddannelseIndberetningStatusId>>>;
  };

export type EfteruddannelseIndberetningStatusKodeFilterInput = {
  and?: InputMaybe<Array<EfteruddannelseIndberetningStatusKodeFilterInput>>;
  or?: InputMaybe<Array<EfteruddannelseIndberetningStatusKodeFilterInput>>;
  personEfteruddannelseIndberetning?: InputMaybe<ListFilterInputTypeOfPersonEfteruddannelseIndberetningFilterInput>;
  nr?: InputMaybe<EfteruddannelseIndberetningStatusIdOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type InteresseGroupFilterInput = {
  and?: InputMaybe<Array<InteresseGroupFilterInput>>;
  or?: InputMaybe<Array<InteresseGroupFilterInput>>;
  interesseNr?: InputMaybe<IntOperationFilterInput>;
  synonym?: InputMaybe<StringOperationFilterInput>;
  interesseChildId?: InputMaybe<UuidOperationFilterInput>;
  interesseChild?: InputMaybe<InteresseFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type KursusGruppeFilterInput = {
  and?: InputMaybe<Array<KursusGruppeFilterInput>>;
  or?: InputMaybe<Array<KursusGruppeFilterInput>>;
  kursusPersonKursusGruppe?: InputMaybe<ListFilterInputTypeOfKursusPersonKursusGruppeFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type PersonEfteruddannelseIndberetningLinjeFilterInput = {
  and?: InputMaybe<Array<PersonEfteruddannelseIndberetningLinjeFilterInput>>;
  or?: InputMaybe<Array<PersonEfteruddannelseIndberetningLinjeFilterInput>>;
  personEfteruddannelseIndberetningId?: InputMaybe<UuidOperationFilterInput>;
  efteruddannelsestypenr?: InputMaybe<IntOperationFilterInput>;
  indberettedeLektioner?: InputMaybe<FloatOperationFilterInput>;
  efteruddannelsestypenrNavigation?: InputMaybe<EfteruddannelsestypeFilterInput>;
  personEfteruddannelseIndberetningNavigation?: InputMaybe<PersonEfteruddannelseIndberetningFilterInput>;
  opretDato?: InputMaybe<DateTimeOperationFilterInput>;
  opretInit?: InputMaybe<StringOperationFilterInput>;
  retteDato?: InputMaybe<DateTimeOperationFilterInput>;
  retteInit?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
};

export type EfteruddannelseIndberetningStatusIdOperationFilterInput = {
  eq?: InputMaybe<EfteruddannelseIndberetningStatusId>;
  neq?: InputMaybe<EfteruddannelseIndberetningStatusId>;
  in?: InputMaybe<Array<EfteruddannelseIndberetningStatusId>>;
  nin?: InputMaybe<Array<EfteruddannelseIndberetningStatusId>>;
};

export type EfteruddannelsestypeFilterInput = {
  and?: InputMaybe<Array<EfteruddannelsestypeFilterInput>>;
  or?: InputMaybe<Array<EfteruddannelsestypeFilterInput>>;
  periode?: InputMaybe<DatoIntervalFilterInput>;
  maxLektioner?: InputMaybe<IntOperationFilterInput>;
  overfoerPrioritet?: InputMaybe<IntOperationFilterInput>;
  formaal?: InputMaybe<IntOperationFilterInput>;
  overfoerTilMax?: InputMaybe<BooleanOperationFilterInput>;
  personEfteruddannelseIndberetningLinje?: InputMaybe<ListFilterInputTypeOfPersonEfteruddannelseIndberetningLinjeFilterInput>;
  nr?: InputMaybe<IntOperationFilterInput>;
  navn?: InputMaybe<StringOperationFilterInput>;
};

export type KursusGruppe = {
  __typename?: "KursusGruppe";
  kursusPersonKursusGruppe: Array<KursusPersonKursusGruppe>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Firmahistorik2Input = {
  id: Scalars["UUID"]["input"];
  snapshotTid: Scalars["DateTime"]["input"];
  firmaId: Scalars["UUID"]["input"];
  firmaNr: Scalars["Long"]["input"];
  navn1: Scalars["String"]["input"];
  navn2?: InputMaybe<Scalars["String"]["input"]>;
  advokatvirksomhed: Scalars["Boolean"]["input"];
  harAktivitet: Scalars["Boolean"]["input"];
  cvrNr?: InputMaybe<Scalars["Long"]["input"]>;
  pnr?: InputMaybe<Scalars["Long"]["input"]>;
  virksomhedsform?: InputMaybe<Scalars["String"]["input"]>;
  selskabstype?: InputMaybe<Scalars["String"]["input"]>;
  tlf?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  emailSikker?: InputMaybe<Scalars["String"]["input"]>;
  webAdresse?: InputMaybe<Scalars["String"]["input"]>;
  periodeFraDato: Scalars["Date"]["input"];
  periodeTilDato: Scalars["Date"]["input"];
  adresseCoNavn?: InputMaybe<Scalars["String"]["input"]>;
  adresseAdresselinie1?: InputMaybe<Scalars["String"]["input"]>;
  adresseAdresselinie2?: InputMaybe<Scalars["String"]["input"]>;
  adressePostnummer?: InputMaybe<Scalars["String"]["input"]>;
  adresseBynavn?: InputMaybe<Scalars["String"]["input"]>;
  adresseAdresselinie4?: InputMaybe<Scalars["String"]["input"]>;
  adresseLandekode?: InputMaybe<Scalars["String"]["input"]>;
  kommune?: InputMaybe<Scalars["String"]["input"]>;
  region?: InputMaybe<Scalars["String"]["input"]>;
  advokatkreds?: InputMaybe<Scalars["String"]["input"]>;
  retskreds?: InputMaybe<Scalars["String"]["input"]>;
};

export type Region = {
  __typename?: "Region";
  kommune: Array<Kommune>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Advokatkreds = {
  __typename?: "Advokatkreds";
  retskreds: Array<Retskreds>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type Udvalg = {
  __typename?: "Udvalg";
  udvalgNr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
  beskrivelse?: Maybe<Scalars["String"]["output"]>;
  periode: DatoInterval;
  personUdvalg: Array<PersonUdvalg>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type TillidshvervKode = {
  __typename?: "TillidshvervKode";
  personUdvalg: Array<PersonUdvalg>;
  nr: TillidshvervId;
  navn: Scalars["String"]["output"];
};

export enum TillidshvervId {
  Menig = "MENIG",
  Naestformand = "NAESTFORMAND",
  Formand = "FORMAND",
  Sekretaer = "SEKRETAER",
}

export type Udenlandskadvokatsamfund = {
  __typename?: "Udenlandskadvokatsamfund";
  navn: Scalars["String"]["output"];
  beskrivelse?: Maybe<Scalars["String"]["output"]>;
  personUdenlandskadvokatsamfund: Array<PersonUdenlandskadvokatsamfund>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Interesse = {
  __typename?: "Interesse";
  forkortelse?: Maybe<Scalars["String"]["output"]>;
  navn: Scalars["String"]["output"];
  navnEngelsk?: Maybe<Scalars["String"]["output"]>;
  beskrivelse?: Maybe<Scalars["String"]["output"]>;
  falId?: Maybe<Scalars["String"]["output"]>;
  falReferenceDatatypeIndex?: Maybe<Scalars["Int"]["output"]>;
  fal?: Maybe<Falreferencedata>;
  interesseGroup: Array<InteresseGroup>;
  personInteresse: Array<PersonInteresse>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Personhistorik2Input = {
  id: Scalars["UUID"]["input"];
  snapshotTid: Scalars["DateTime"]["input"];
  personId: Scalars["UUID"]["input"];
  kundeNr: Scalars["Long"]["input"];
  titel1?: InputMaybe<Scalars["String"]["input"]>;
  titel2?: InputMaybe<Scalars["String"]["input"]>;
  fornavne?: InputMaybe<Scalars["String"]["input"]>;
  efternavn?: InputMaybe<Scalars["String"]["input"]>;
  personart?: InputMaybe<Scalars["String"]["input"]>;
  erUdoevende?: InputMaybe<Scalars["Boolean"]["input"]>;
  foedselsDato?: InputMaybe<Scalars["Date"]["input"]>;
  personDoedDato?: InputMaybe<Scalars["Date"]["input"]>;
  tlfMobilNr?: InputMaybe<Scalars["String"]["input"]>;
  emailPrivat?: InputMaybe<Scalars["String"]["input"]>;
  fakturaAfsendelse?: InputMaybe<Scalars["String"]["input"]>;
  primaerFirmaFirmaNr?: InputMaybe<Scalars["Long"]["input"]>;
  primaerFirmaNavn?: InputMaybe<Scalars["String"]["input"]>;
  primaerFirmaEmailSikker?: InputMaybe<Scalars["String"]["input"]>;
  primaerFirmaEmailArbejde?: InputMaybe<Scalars["String"]["input"]>;
  primaerFirmaAdvokatkreds?: InputMaybe<Scalars["String"]["input"]>;
  adresseCoNavn?: InputMaybe<Scalars["String"]["input"]>;
  adresseAdresselinie1?: InputMaybe<Scalars["String"]["input"]>;
  adresseAdresselinie2?: InputMaybe<Scalars["String"]["input"]>;
  adressePostnummer?: InputMaybe<Scalars["String"]["input"]>;
  adresseBynavn?: InputMaybe<Scalars["String"]["input"]>;
  adresseAdresselinie4?: InputMaybe<Scalars["String"]["input"]>;
  adresseLandekode?: InputMaybe<Scalars["String"]["input"]>;
};

export type Disciplinaerstatustype = {
  __typename?: "Disciplinaerstatustype";
  personDisciplinaerstatus: Array<PersonDisciplinaerstatus>;
  nr: Scalars["Int"]["output"];
  navn: Scalars["String"]["output"];
};

export type BidragsmodtagerKode = {
  __typename?: "BidragsmodtagerKode";
  personBidragsopkraevning: Array<PersonBidragsopkraevning>;
  nr: BidragsmodtagerId;
  navn: Scalars["String"]["output"];
};

export enum BidragsmodtagerId {
  Advokatsamfundet = "ADVOKATSAMFUNDET",
  Erstatningsfonden = "ERSTATNINGSFONDEN",
}

export type Abonnement = {
  __typename?: "Abonnement";
  nr: Scalars["Int"]["output"];
  navn?: Maybe<Scalars["String"]["output"]>;
  beskrivelse?: Maybe<Scalars["String"]["output"]>;
  personAbonnement: Array<PersonAbonnement>;
  firmaAbonnement: Array<FirmaAbonnement>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type Forening = {
  __typename?: "Forening";
  navn: Scalars["String"]["output"];
  forkortelse: Scalars["String"]["output"];
  adr1?: Maybe<Scalars["String"]["output"]>;
  adr2?: Maybe<Scalars["String"]["output"]>;
  postNr?: Maybe<Scalars["String"]["output"]>;
  land?: Maybe<Scalars["String"]["output"]>;
  tlfNr?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  indmeldAuto: Scalars["Boolean"]["output"];
  udmeldAuto: ForeningAutoudmeldelseId;
  advokatAttention?: Maybe<Scalars["Boolean"]["output"]>;
  medlemstype: Scalars["Int"]["output"];
  firmaopkraevning: Scalars["Boolean"]["output"];
  regnskabStart?: Maybe<Scalars["String"]["output"]>;
  regnskabSlut?: Maybe<Scalars["String"]["output"]>;
  adrCo?: Maybe<Scalars["String"]["output"]>;
  personForening: Array<PersonForening>;
  udmeldAutoNavigation?: Maybe<ForeningAutoudmeldelseKode>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export type FmuretssagsproeveResultatKode = {
  __typename?: "FmuretssagsproeveResultatKode";
  fmuretssagsproeve: Array<Fmuretssagsproeve>;
  nr: FmuretssagsproeveResultatId;
  navn: Scalars["String"]["output"];
};

export enum FmuretssagsproeveResultatId {
  IkkeAfholdt = "IKKE_AFHOLDT",
  Bestaaet = "BESTAAET",
  IkkeBestaaet = "IKKE_BESTAAET",
  Aflyst = "AFLYST",
  GodkendelseTilbagekaldt = "GODKENDELSE_TILBAGEKALDT",
  Omberammet = "OMBERAMMET",
}

export type Falreferencedata = {
  __typename?: "Falreferencedata";
  referenceDataVaerdiId: Scalars["String"]["output"];
  referenceDatatypeIndex: Scalars["Int"]["output"];
  referenceDatatypeGruppeNavn?: Maybe<Scalars["String"]["output"]>;
  referenceDataVaerdi?: Maybe<Scalars["String"]["output"]>;
  aktiv?: Maybe<Scalars["Boolean"]["output"]>;
  interesse: Array<Interesse>;
  land: Array<Land>;
  titel: Array<Titel>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};

export enum ForeningAutoudmeldelseId {
  Ingen = "INGEN",
  BeskikkelsesOphoer = "BESKIKKELSES_OPHOER",
  AaretsUdgang = "AARETS_UDGANG",
}

export type ForeningAutoudmeldelseKode = {
  __typename?: "ForeningAutoudmeldelseKode";
  nr: ForeningAutoudmeldelseId;
  navn: Scalars["String"]["output"];
};

export type InteresseGroup = {
  __typename?: "InteresseGroup";
  interesseNr?: Maybe<Scalars["Int"]["output"]>;
  synonym?: Maybe<Scalars["String"]["output"]>;
  interesseChildId?: Maybe<Scalars["UUID"]["output"]>;
  interesseChild?: Maybe<Interesse>;
  opretDato?: Maybe<Scalars["DateTime"]["output"]>;
  opretInit?: Maybe<Scalars["String"]["output"]>;
  retteDato?: Maybe<Scalars["DateTime"]["output"]>;
  retteInit?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["UUID"]["output"];
};
